import * as tt from "vue";
import { reactive as Uo, computed as l, onMounted as Le, onUnmounted as Br, ref as y, watchEffect as kr, getCurrentInstance as qe, watch as R, nextTick as ie, useCssModule as D, effectScope as Lr, shallowReactive as Dr, useSlots as ve, onBeforeUnmount as Go, onBeforeMount as Zo, onUpdated as Mr } from "vue";
import * as Ve from "vue-i18n";
import { isVue2 as J, isVue3 as Yo } from "vue-demi";
import * as Jo from "vue-router";
import Ar from "dompurify";
import { useElementVisibility as Or, useElementHover as Fr, onClickOutside as Qo, onKeyStroke as er, useElementSize as Er, whenever as Rr, watchOnce as Nr, useVirtualList as Xr } from "@vueuse/core";
import { FontAwesomeIcon as tr } from "@fortawesome/vue-fontawesome";
import { offset as Vr, arrow as zr, flip as jr, autoUpdate as qr, computePosition as Hr } from "@floating-ui/dom";
import Wr from "vue-ctk-date-time-picker";
const ht = 600, yt = 1200, Re = {
  desktop: {
    minWidth: yt
  },
  tablet: {
    minWidth: ht,
    maxWidth: yt
  },
  mobile: {
    maxWidth: ht
  }
};
function Kr() {
  const n = Uo({
    width: null
  }), e = l(() => n.width >= Re.desktop.minWidth), s = l(() => n.width >= Re.tablet.minWidth && n.width < Re.tablet.maxWidth), t = l(() => n.width < Re.mobile.maxWidth);
  function a() {
    n.width = window.innerWidth;
  }
  function o() {
    window.addEventListener("resize", a);
  }
  function r() {
    window.removeEventListener("resize", a);
  }
  return Le(() => {
    a(), o();
  }), Br(r), { isDesktop: e, isTablet: s, isMobile: t };
}
function Ur() {
  return {
    isNuxt: !!(window != null && window.__NUXT__ || window != null && window.$nuxt)
  };
}
const Gr = {
  actions: {
    close: "Clique aqui para fechar o alerta."
  }
}, Zr = {
  actions: {
    close: "Clique aqui para remover."
  }
}, Yr = {
  actions: {
    openMenu: "Clique aqui para visualizar todos os links."
  }
}, Jr = {
  actions: {
    close: "Clique aqui para ocultar as informações.",
    open: "Clique aqui para exibir as informações."
  }
}, Qr = {
  placeholder: "Selecionar arquivo"
}, el = {
  actions: {
    edit: {
      title: "Clique aqui para editar {label}"
    },
    cancel: {
      title: "Clique aqui para cancelar a edição {label}"
    },
    save: {
      title: "Clique aqui para salvar a edição {label}"
    }
  }
}, tl = {
  actions: {
    close: "Clique aqui para fechar o modal."
  }
}, sl = {
  aria: {
    label: "Páginas para navegação."
  },
  next: "Ir para próxima página.",
  prev: "Ir para página anterior."
}, nl = {
  actions: {
    select: {
      ellipsis: "Selecione...",
      all: "Selecionar todos"
    },
    search: "Buscar"
  },
  searchEmpty: "Nenhum resultado encontrado."
}, al = {
  loading: "Carregando"
}, ol = {
  loading: "Carregando..."
}, rl = {
  actions: {
    close: "Clique aqui para fechar."
  }
}, ll = {
  errors: {
    required: "O campo é obrigatório",
    phone: "Digite um telefone válido",
    email: "Informe um e-mail válido",
    cnpj: "Informe um CNPJ válido",
    cpf: "Informe um CPF válido",
    document: "Informe um documento válido",
    date: "Informe uma data válida",
    fullName: "Utilize nome e sobrenome",
    dateInThePast: "Deve ser anterior à data atual"
  }
}, il = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
}, cl = {
  actions: {
    edit: {
      base: "Editar"
    },
    cancel: {
      base: "Cancelar"
    },
    save: {
      base: "Salvar"
    }
  },
  badge: {
    new: "Novo",
    beta: "Beta"
  }
}, dl = {
  currency: {
    style: "currency",
    currency: "BRL",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}, st = {
  messages: {
    ds: {
      xAlert: Gr,
      xBadge: Zr,
      XBreadCrumb: Yr,
      xCollapse: Jr,
      XFileInput: Qr,
      xInlineEdit: el,
      xModal: tl,
      xPagination: sl,
      xSelect: nl,
      xSkeletonLoader: al,
      xSpinner: ol,
      xTooltip: rl,
      validations: ll,
      global: cl
    }
  },
  datetimeFormats: il,
  numberFormats: dl
}, ul = {
  actions: {
    close: "Click here to close the alert."
  }
}, _l = {
  actions: {
    close: "Click here to remove."
  }
}, pl = {
  actions: {
    openMenu: "Click here to see all links."
  }
}, fl = {
  actions: {
    close: "Click here to hide the information.",
    open: "Click here to show the information."
  }
}, ml = {
  placeholder: "Select file"
}, vl = {
  actions: {
    edit: {
      title: "Click here to edit {label}"
    },
    cancel: {
      title: "Click here to cancel the edit {label}"
    },
    save: {
      title: "Click here to save the edit {label}"
    }
  }
}, gl = {
  actions: {
    close: "Click here to close the modal."
  }
}, hl = {
  aria: {
    label: "Navigation pages."
  },
  next: "Go to next page.",
  prev: "Go to previous page."
}, yl = {
  actions: {
    select: {
      ellipsis: "Select...",
      all: "Select all"
    },
    search: "Search"
  },
  searchEmpty: "No results found."
}, bl = {
  loading: "Loading"
}, $l = {
  loading: "Loading..."
}, Il = {
  actions: {
    close: "Click here to close."
  }
}, xl = {
  errors: {
    required: "This field is required",
    phone: "Enter a valid phone number",
    email: "Enter a valid email address",
    cnpj: "Enter a valid CNPJ",
    cpf: "Enter a valid CPF",
    document: "Enter a valid document",
    date: "Enter a valid date",
    fullName: "Use both first and last names",
    dateInThePast: "Must be before the current date"
  }
}, Tl = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
}, Sl = {
  actions: {
    edit: {
      base: "Edit"
    },
    cancel: {
      base: "Cancel"
    },
    save: {
      base: "Save"
    }
  },
  badge: {
    new: "New",
    beta: "Beta"
  }
}, Pl = {
  currency: {
    style: "currency",
    currency: "USD",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}, nt = {
  messages: {
    ds: {
      xAlert: ul,
      xBadge: _l,
      XBreadCrumb: pl,
      xCollapse: fl,
      XFileInput: ml,
      xInlineEdit: vl,
      xModal: gl,
      xPagination: hl,
      xSelect: yl,
      xSkeletonLoader: bl,
      xSpinner: $l,
      xTooltip: Il,
      validations: xl,
      global: Sl
    }
  },
  datetimeFormats: Tl,
  numberFormats: Pl
}, Cl = {
  actions: {
    close: "Haz clic aquí para cerrar la alerta."
  }
}, wl = {
  actions: {
    close: "Haga clic aquí para eliminar."
  }
}, Bl = {
  actions: {
    openMenu: "Haz click aquí para ver todos los enlaces."
  }
}, kl = {
  actions: {
    close: "Haz click aquí para ocultar la información.",
    open: "Haz click aquí para mostrar la información."
  }
}, Ll = {
  placeholder: "Seleccionar archivo"
}, Dl = {
  actions: {
    edit: {
      title: "Haz click aquí para editar {label}"
    },
    cancel: {
      title: "Haz click aquí para cancelar la edición de {label}"
    },
    save: {
      title: "Haz click aquí para guardar la edición de {label}"
    }
  }
}, Ml = {
  actions: {
    close: "Haz click aquí para cerrar la ventana."
  }
}, Al = {
  aria: {
    label: "Páginas para navegación web."
  },
  next: "Ir a la siguiente página.",
  prev: "Ir a la página anterior."
}, Ol = {
  actions: {
    select: {
      ellipsis: "Seleccionar...",
      all: "Seleccionar todos"
    },
    search: "Buscar"
  },
  searchEmpty: "No se encontraron resultados."
}, Fl = {
  loading: "Cargando"
}, El = {
  loading: "Cargando..."
}, Rl = {
  actions: {
    close: "Haz click aquí para cerrar."
  }
}, Nl = {
  errors: {
    required: "El campo es obligatorio",
    phone: "Ingresa un teléfono válido",
    email: "Ingresa un correo electrónico válido",
    cnpj: "Ingresa un CNPJ válido",
    cpf: "Ingresa un CPF válido",
    document: "Ingresa un documento válido",
    date: "Ingresa una fecha válida",
    fullName: "Utiliza nombre y apellido",
    dateInThePast: "Debe ser anterior a la fecha actual"
  }
}, Xl = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
}, Vl = {
  actions: {
    edit: {
      base: "Editar"
    },
    cancel: {
      base: "Cancelar"
    },
    save: {
      base: "Guardar"
    }
  },
  badge: {
    new: "Nuevo",
    beta: "Beta"
  }
}, zl = {
  currency: {
    style: "currency",
    currency: "MXN",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}, at = {
  messages: {
    ds: {
      xAlert: Cl,
      xBadge: wl,
      XBreadCrumb: Bl,
      xCollapse: kl,
      XFileInput: Ll,
      xInlineEdit: Dl,
      xModal: Ml,
      xPagination: Al,
      xSelect: Ol,
      xSkeletonLoader: Fl,
      xSpinner: El,
      xTooltip: Rl,
      validations: Nl,
      global: Vl
    }
  },
  datetimeFormats: Xl,
  numberFormats: zl
}, jl = {
  "pt-BR": st.messages,
  "en-US": nt.messages,
  "es-MX": at.messages
}, sr = {
  "pt-BR": st.datetimeFormats,
  "en-US": nt.datetimeFormats,
  "es-MX": at.datetimeFormats
}, ql = {
  "pt-BR": st.numberFormats,
  "en-US": nt.numberFormats,
  "es-MX": at.numberFormats
};
typeof window > "u" && (global.window = {
  $excalibur: {}
});
window.$excalibur = window.$excalibur || {};
const bt = "pt-BR";
function nr() {
  return {
    locale: bt,
    fallbackLocale: {
      enUs: ["en-US"],
      en: ["en-US"],
      esMx: ["es-MX"],
      default: [bt]
    },
    messages: jl,
    numberFormats: ql
  };
}
function ar(n) {
  var e;
  (e = window.$excalibur) != null && e.locale || (window.$excalibur.locale = n);
}
function Hl() {
  const n = Ve == null ? void 0 : Ve.default;
  tt.default.use(n);
  const e = new n({
    ...nr(),
    dateTimeFormats: sr,
    silentFallbackWarn: !0
  });
  function s(t) {
    e.locale = t;
  }
  ar({
    useI18n: {
      t: (t, ...a) => e.t(t, ...a),
      tc: (t, ...a) => e.tc(t, ...a),
      d: (t, ...a) => e.d(t, ...a),
      n: (t, ...a) => e.n(t, ...a),
      setLocale: s
    },
    i18n: e
  });
}
function Wl() {
  const { createI18n: n } = Ve, e = n({
    ...nr(),
    legacy: !1,
    globalInjection: !0,
    fallbackWarn: !1,
    missingWarn: !1,
    datetimeFormats: sr
  });
  function s(a) {
    e.global.locale.value = a;
  }
  const { t } = e.global;
  ar({
    useI18n: {
      ...e.global,
      tc: t,
      setLocale: s
    },
    i18n: e
  });
}
const Kl = l(() => {
  var n, e, s, t, a;
  return J ? (e = (n = window.$excalibur) == null ? void 0 : n.locale) == null ? void 0 : e.i18n.locale : (a = (t = (s = window.$excalibur) == null ? void 0 : s.locale) == null ? void 0 : t.i18n) == null ? void 0 : a.global.locale.value;
});
function W() {
  var e;
  (e = window.$excalibur) != null && e.locale || (J ? Hl() : Wl());
  const { useI18n: n } = window.$excalibur.locale;
  return n;
}
const or = () => ({
  autofocus: {
    type: Boolean,
    default: !1
  }
}), rr = (n, e = y(null)) => (kr(() => {
  n.autofocus && e.value && e.value.focus();
}), { inputRef: e }), U = (n = []) => ({ v2Listeners: l(() => {
  var t;
  let s = {};
  if (J) {
    const a = qe();
    s = { ...(t = a == null ? void 0 : a.proxy) == null ? void 0 : t.$listeners }, n.length >= 1 && n.forEach((o) => delete s[o]);
  }
  return s;
}) }), Ul = 250;
function lr(n) {
  const {
    itemsList: e,
    itemsListRef: s,
    virtualizedList: t = !1,
    horizontal: a = !0,
    enabled: o = !0,
    initialPosition: r = 0,
    callBack: d
  } = n || {}, c = y([]), u = y(!1), i = y(null), _ = y(-1), f = l(() => e == null ? void 0 : e.value.filter(($) => !($ != null && $.hidden)));
  function p($) {
    return !$.ariaReadOnly && !$.disabled && !$.ariaDisabled && !$.dataset.invalid && $.dataset.index;
  }
  const m = l({
    get() {
      return c.value.map((w) => (w == null ? void 0 : w.$el) || w).filter((w) => w && p(w));
    },
    set($) {
      c.value = [...$];
    }
  }), v = l(() => L.value === 0), I = l(
    () => {
      var $;
      return L.value === (($ = m.value) == null ? void 0 : $.length) - 1;
    }
  ), g = {
    prev: a ? "ArrowLeft" : "ArrowUp",
    next: a ? "ArrowRight" : "ArrowDown"
  }, T = l(() => o && m.value.length > 0), k = y(null), L = y(0);
  function O($) {
    d && typeof d == "function" && d(i.value, $);
  }
  function h($) {
    var w;
    return parseInt((w = $ == null ? void 0 : $.dataset) == null ? void 0 : w.index, 10);
  }
  function M($) {
    return m.value.findIndex((w) => h(w) === $);
  }
  function X($) {
    L.value = $;
  }
  function V($) {
    var w;
    m.value.length > 0 && (k.value = (w = m.value) == null ? void 0 : w[$], X($));
  }
  function F() {
    _.value = h(k.value), f != null && f.value && (i.value = f.value[_.value]);
  }
  function N($ = !1) {
    const w = $ ? "center" : "nearest", j = () => {
      var Y, _e;
      (Y = k.value) != null && Y.scrollIntoView ? k.value.scrollIntoView({
        behavior: "auto",
        block: w,
        inline: w
      }) : (_e = k.value) != null && _e.scrollIntoViewIfNeeded && k.value.scrollIntoViewIfNeeded(!0);
    };
    $ ? setTimeout(j, Ul) : j();
  }
  function b() {
    var $;
    k.value && (($ = k.value) == null || $.focus());
  }
  function P($, w) {
    return Math.max(Math.min($, w - 1), 0);
  }
  function E($, w) {
    return ($ % w + w) % w;
  }
  function G($) {
    const w = $ === g.prev, j = $ === g.next;
    return {
      isPrev: w,
      isNext: j,
      emptyDirection: !j && !w
    };
  }
  function re($ = 0) {
    H(() => {
      const j = M($);
      V(j), N(!0), F();
    })();
  }
  function be($ = 0) {
    H(() => {
      const j = M($);
      V(j), N(), F(), O();
    })();
  }
  function ue($ = 0) {
    ie(() => {
      V($), N(), F(), O(), b(), u.value = !0;
    });
  }
  function A($) {
    const { isNext: w } = G($);
    u.value = !0;
    const j = w ? 1 : -1, Y = L.value + j, _e = m.value.length, Ue = t ? P(Y, _e) : E(Y, _e);
    V(Ue), N(), b();
  }
  function H($) {
    return () => {
      T.value && $();
    };
  }
  function Ce($) {
    H(() => {
      const { emptyDirection: j } = G($);
      j || (A($), F(), O($));
    })();
  }
  function Ke($) {
    H(() => {
      const { code: j } = $, { emptyDirection: Y } = G(j);
      Y || ($.preventDefault(), A(j), F(), O($));
    })();
  }
  function Ee() {
    u.value = !1, L.value = 0;
  }
  function we() {
    if (T.value && u.value) {
      const $ = m.value.findIndex((w) => h(w) === h(k.value));
      V($), b();
    }
  }
  return R(
    s,
    () => {
      c.value = (s == null ? void 0 : s.value) || [], we();
    },
    {
      deep: !0,
      immediate: !0
    }
  ), R(f, async () => {
    await ie(), m.value = c.value, we();
  }), R(
    () => T.value,
    () => {
      re(r);
    }
  ), {
    handleNavigationKeyboard: Ke,
    handleNavigationArrows: Ce,
    handleNavigationByItemIndex: be,
    setInitialFocusByNodeIndex: ue,
    resetKeyboardNavigation: Ee,
    scrollCurrentNavigableNodeIntoView: N,
    currentItemOfList: i,
    currentItemOfListIndex: _,
    directions: g,
    isFirstNode: v,
    isLastNode: I,
    currentNavigableNodeIndex: L,
    currentNavigableNode: k
  };
}
const Gl = (n) => n.charAt(0).toUpperCase() + n.slice(1), Zl = /[\u0300-\u036f]/g, Yl = /[^a-zA-Z0-9]+/g;
function Jl(n) {
  return n.normalize("NFD").trim().replace(Zl, "").replace(Yl, " ");
}
const ze = (n) => n && Jl(n).split(" ").reduce((t, a, o) => {
  const r = a.slice(0, -1) + a.slice(-1).toLowerCase(), d = r.toLowerCase()[0] + r.slice(1), c = r.toUpperCase()[0] + r.slice(1);
  return t + (o ? c : d);
}, "");
function fe(n = "") {
  return `${n}${Math.random().toString(16).substring(2, 10)}`;
}
const $t = (n) => {
  let e = 0, s = 0, t = 0;
  n.length === 4 ? (e = `0x${n[1]}${n[1]}`, s = `0x${n[2]}${n[2]}`, t = `0x${n[3]}${n[3]}`) : n.length === 7 && (e = `0x${n[1]}${n[2]}`, s = `0x${n[3]}${n[4]}`, t = `0x${n[5]}${n[6]}`), e /= 255, s /= 255, t /= 255;
  const a = Math.min(e, s, t), o = Math.max(e, s, t), r = o - a;
  let d = 0, c = 0, u = 0;
  return r === 0 ? d = 0 : o === e ? d = (s - t) / r % 6 : o === s ? d = (t - e) / r + 2 : d = (e - s) / r + 4, d = Math.round(d * 60), d < 0 && (d += 360), u = (o + a) / 2, c = r === 0 ? 0 : r / (1 - Math.abs(2 * u - 1)), c = +(c * 100).toFixed(1), u = +(u * 100).toFixed(1), `hsl(${d}, ${c}%, ${u}%)`;
}, ir = /\d+\.?\d?%(?=\)$)/, Ql = (n) => ir.exec(n)[0];
function ei(n, e) {
  if (!(!e || !n))
    return n.replace(ir, e);
}
function ti(n, e = 16) {
  if (n.length <= e) return n;
  const t = Math.floor((e - 3) / 2), a = n.substring(0, t), o = n.substring(n.length - t - 1);
  return `${a}...${o}`;
}
function It(n) {
  const e = typeof n;
  return !!n && (e === "object" || e === "function");
}
function S() {
  function n() {
    return {
      dataTestid: {
        type: String,
        default: ""
      }
    };
  }
  function e(s) {
    function t(a = "") {
      return s != null && s.dataTestid ? ze(`${s.dataTestid} ${a}`).trim() : "";
    }
    return {
      formatTestId: t
    };
  }
  return {
    createTestIdProp: n,
    setupTestId: e
  };
}
function q() {
  function n(s = !1) {
    return {
      disabled: {
        type: Boolean,
        default: s
      }
    };
  }
  function e(s) {
    const t = D();
    return {
      disabledClass: l(() => ({
        [t.isDisabled]: s.disabled
      }))
    };
  }
  return {
    createDisabledProp: n,
    getDisabledClass: e
  };
}
function ot() {
  const n = ["", "low", "medium", "high", "ultra"];
  function e(t = String, a = "") {
    return t === String ? {
      elevation: {
        type: t,
        default: a,
        validator: (o) => n.includes(o)
      }
    } : {
      elevation: {
        type: t,
        default: a
      }
    };
  }
  function s(t) {
    const a = {
      low: "var(--shadow-small)",
      medium: "var(--shadow-medium)",
      high: "var(--shadow-large)",
      ultra: "var(--shadow-large-x)"
    }, o = l(() => ({
      boxShadow: a[t.elevation]
    }));
    return { boxShadowOptions: a, boxShadow: o };
  }
  return {
    ELEVATIONS: n,
    createElevationProp: e,
    getElevationBoxShadow: s
  };
}
function Q() {
  function n(s = !1) {
    return {
      fullWidth: {
        type: Boolean,
        default: s
      }
    };
  }
  function e(s) {
    const t = D();
    return {
      fullWidthClass: l(() => ({
        [t.isFullWidth]: s.fullWidth
      }))
    };
  }
  return {
    createFullWidthProp: n,
    getFullWidthClass: e
  };
}
function De() {
  function n(s = {}) {
    const { height: t = "auto", minHeight: a = "auto", maxHeight: o = "auto" } = s;
    return {
      height: {
        type: String,
        default: t
      },
      minHeight: {
        type: String,
        default: a
      },
      maxHeight: {
        type: String,
        default: o
      }
    };
  }
  function e(s) {
    return {
      heightStyles: l(() => ({
        height: s.height,
        minHeight: s.minHeight,
        maxHeight: s.maxHeight
      }))
    };
  }
  return {
    createHeightProps: n,
    getHeightStyles: e
  };
}
function ce() {
  const n = ["fal", "fas", "fak", "fad", "fab"];
  function e({ required: s = !1, style: t = "fal" } = {
    required: void 0,
    style: void 0
  }) {
    return {
      icon: {
        type: String,
        required: s
      },
      iconStyle: {
        type: String,
        default: t,
        validator: (a) => n.includes(a)
      }
    };
  }
  return {
    ICON_STYLES: n,
    createIconProps: e
  };
}
function ge() {
  const n = {
    error: "error",
    warning: "warning",
    success: "success",
    info: "info"
  };
  function e() {
    return {
      message: {
        type: String,
        default: ""
      },
      messageType: {
        type: String,
        default: n.error,
        validator: (d) => Object.values(n).includes(d)
      }
    };
  }
  function s() {
    return {
      additionalMessages: {
        type: Array,
        default: () => []
      }
    };
  }
  function t() {
    return {
      label: {
        type: String,
        default: ""
      },
      helpLink: {
        type: String,
        default: ""
      },
      helpTooltip: {
        type: String,
        default: ""
      }
    };
  }
  function a() {
    return {
      focusable: {
        type: Boolean,
        default: !0
      },
      grouped: {
        type: Boolean,
        default: !1
      },
      flexible: {
        type: Boolean,
        default: !1
      }
    };
  }
  function o({ placeholder: d = "" } = { placeholder: void 0 }) {
    return {
      value: {
        type: String,
        default: ""
      },
      name: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: d
      }
    };
  }
  function r() {
    return {
      required: {
        type: Boolean,
        default: !1
      }
    };
  }
  return {
    MESSAGE_TYPES: n,
    createMessageProps: e,
    createAdditionalMessagesProp: s,
    createLabelProps: t,
    createFormFieldProps: a,
    createInputProps: o,
    createRequiredProp: r
  };
}
function rt(n = {}) {
  const e = {
    itemsPropName: "items",
    itemTextKey: "text",
    itemValueKey: "value"
  }, {
    itemsPropName: s = e.itemsPropName,
    itemTextKey: t = e.itemTextKey,
    itemValueKey: a = e.itemValueKey,
    validator: o = (i) => i
  } = n;
  function r() {
    return {
      itemTextKey: {
        type: String,
        default: t,
        validator: (i) => !!i
      },
      itemValueKey: {
        type: String,
        default: a,
        validator: (i) => !!i
      }
    };
  }
  function d(i, _ = e) {
    const f = It(i), p = f ? i[e.itemValueKey] ?? i[_.itemValueKey] : i, m = f ? i[e.itemTextKey] ?? i[_.itemTextKey] : i, v = {
      [e.itemTextKey]: m,
      [e.itemValueKey]: p
    };
    return _ != null && _.itemTextKey && e.itemTextKey !== _.itemTextKey && (v[_.itemTextKey] = m), _ != null && _.itemValueKey && e.itemValueKey !== _.itemValueKey && (v[_.itemValueKey] = p), v;
  }
  function c(i, _ = e) {
    if (!It(i))
      return !1;
    const f = e.itemTextKey in i, p = e.itemValueKey in i, m = _.itemTextKey in i, v = _.itemValueKey in i;
    return f && p && m && v;
  }
  function u(i) {
    function _(p) {
      const m = p;
      return o(m) && (m != null && m[e.itemTextKey] || (m[e.itemTextKey] = m == null ? void 0 : m[i.itemTextKey]), m != null && m[e.itemValueKey] || (m[e.itemValueKey] = m == null ? void 0 : m[i.itemValueKey])), m;
    }
    return {
      computedItems: l(() => i[s].map((p) => _(p)))
    };
  }
  return {
    DEFAULT_OPTIONS: e,
    createItemsCustomKeysProps: r,
    getItemsWithDefaultKeys: u,
    createItemObject: d,
    itemHasCorrectKeys: c
  };
}
function $e() {
  const n = ["_blank", "_self", "_parent", "_top", "framename"];
  function e({ defaultTo: t = "", defaultTarget: a = null } = {
    defaultTo: void 0,
    defaultTarget: void 0
  }) {
    return {
      to: {
        type: [String, Object],
        default: t
      },
      target: {
        type: String,
        default: a,
        validator: (o) => n.includes(o)
      },
      external: {
        type: Boolean,
        default: !1
      },
      native: {
        type: Boolean,
        default: !1
      }
    };
  }
  function s(t) {
    return {
      to: t.to,
      target: t.target,
      external: t.external,
      native: t.native
    };
  }
  return {
    TARGETS: n,
    createLinkProps: e,
    getLinkProps: s
  };
}
function He() {
  function n(s = !1) {
    return {
      loading: {
        type: Boolean,
        default: s
      }
    };
  }
  function e(s) {
    const t = D();
    return {
      loadingClass: l(() => ({
        [t.isLoading]: s.loading
      }))
    };
  }
  return {
    createLoadingProp: n,
    getLoadingClass: e
  };
}
function Ie() {
  const n = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ];
  function e(s = "bottom") {
    return {
      placement: {
        type: String,
        default: s,
        validator: (t) => n.includes(t)
      }
    };
  }
  return {
    PLACEMENTS: n,
    createPlacementProp: e
  };
}
function si() {
  function n(e = !0) {
    return {
      sanitize: {
        type: Boolean,
        default: e
      }
    };
  }
  return {
    createSanitizeProp: n
  };
}
const { t: te } = W();
function Me() {
  const n = l(() => ({
    requiredIf: te("ds.validations.errors.required"),
    required: te("ds.validations.errors.required"),
    phone: te("ds.validations.errors.phone"),
    email: te("ds.validations.errors.email"),
    cnpj: te("ds.validations.errors.cnpj"),
    cpf: te("ds.validations.errors.cpf"),
    date: te("ds.validations.errors.date"),
    fullName: te("ds.validations.errors.fullName"),
    dateInThePast: te("ds.validations.errors.dateInThePast")
  }));
  function e() {
    return {
      validations: {
        type: Object,
        default: () => ({})
      }
    };
  }
  function s(t = {}) {
    const a = l(() => (t == null ? void 0 : t.value) || t), o = l(
      () => !a.value || !Object.keys(a.value).length
    );
    return {
      validationError: l(() => {
        const c = "";
        if (o.value) return c;
        const u = Object.keys(a.value).filter(
          (_) => Object.keys(n.value).includes(_)
        );
        if (!a.value.$dirty) return c;
        const i = u.find((_) => !a.value[_]);
        return n.value[i];
      }),
      triggerValidation: () => {
        o.value || (a.value.$dirty || a.value.$model) && a.value.$touch();
      }
    };
  }
  return {
    MESSAGES: n,
    createValidationsProp: e,
    setupValidations: s
  };
}
function ni(n) {
  var e, s;
  return ((s = (e = tt.default) == null ? void 0 : e.options) == null ? void 0 : s.components[n]) || n;
}
const ai = J ? ni : tt.resolveComponent, oi = () => {
  const n = qe().proxy.$root;
  if (n.$router) {
    if (!n._$route) {
      const e = Lr(!0).run(() => Dr({ ...n.$router.currentRoute }));
      n._$route = e, n.$router.afterEach((s) => {
        Object.assign(e, s);
      });
    }
    return n._$route;
  }
}, ri = J ? oi : Jo.useRoute, li = () => qe().proxy.$router, ii = J ? li : Jo.useRouter;
function ci(n) {
  function e(t) {
    return /<([a-zA-Z][\s\S]*?)>/i.test(t);
  }
  function s(t) {
    return typeof t == "string" && e(t) && (n != null && n.sanitize) ? Ar.sanitize(t) : t;
  }
  return {
    sanitizeValue: s
  };
}
function cr(n = {}) {
  const { scrollRef: e = y(null), isHorizontal: s = y(!0), scrollPixels: t = 100, callBack: a } = n, o = Or(e), r = y(!0), d = y(!1), c = l(() => {
    var k, L, O, h;
    if (!o.value) return !1;
    const g = ((k = e.value) == null ? void 0 : k.scrollHeight) > ((L = e.value) == null ? void 0 : L.clientHeight), T = ((O = e.value) == null ? void 0 : O.scrollWidth) > ((h = e.value) == null ? void 0 : h.clientWidth);
    return g || T;
  }), u = l(() => !r.value && !d.value), i = l(() => u.value || d.value), _ = l(() => u.value || r.value), f = () => {
    e.value && e.value.scrollBy({
      [s.value ? "left" : "top"]: t,
      behavior: "smooth"
    });
  }, p = () => {
    e.value && e.value.scrollBy({
      [s.value ? "left" : "top"]: -t,
      behavior: "smooth"
    });
  };
  function m() {
    r.value = e.value.scrollLeft === 0, d.value = e.value.scrollLeft + e.value.clientWidth === e.value.scrollWidth;
  }
  function v() {
    r.value = e.value.scrollTop === 0, d.value = e.value.scrollTop + e.value.clientHeight === e.value.scrollHeight;
  }
  function I() {
    e.value && (s.value ? m() : v(), a && typeof a == "function" && a());
  }
  return {
    isScrollAtStart: r,
    isScrollAtEnd: d,
    isScrollMoving: u,
    isScrollNotAtStart: i,
    isScrollNotAtEnd: _,
    hasScroll: c,
    isScrollRefVisible: o,
    scrollNext: f,
    scrollPrev: p,
    handleScroll: I
  };
}
const { createSanitizeProp: di } = si();
function se() {
  function n(s = String, t = "") {
    return {
      modelValue: {
        type: s,
        default: t
      },
      ...di()
    };
  }
  function e(s, t, a = "modelValue", o = "input", r = "value") {
    var f, p;
    let d = a, c = `update:${d}`;
    const { sanitizeValue: u } = ci(s);
    if (J) {
      const m = qe(), v = (p = (f = m == null ? void 0 : m.proxy) == null ? void 0 : f.$options) == null ? void 0 : p.model;
      c = (v == null ? void 0 : v.event) || o, d = (v == null ? void 0 : v.prop) || r;
    }
    const i = y(u(s[d])), _ = l({
      get: () => i.value,
      set: (m) => {
        i.value = u(m), t(c, i.value);
      }
    });
    return R(
      () => s[d],
      (m) => {
        i.value = u(m);
      }
    ), { data: _, modelPropName: d, modelEventName: c };
  }
  return {
    createVModelProp: n,
    setupVModel: e
  };
}
const ui = "_icon_10ehf_5", _i = "_isFixedWidth_10ehf_5", pi = "_left_10ehf_9", fi = "_right_10ehf_13", mi = {
  icon: ui,
  isFixedWidth: _i,
  left: pi,
  right: fi
};
function x(n, e, s, t, a, o, r, d) {
  var c = typeof n == "function" ? n.options : n;
  e && (c.render = e, c.staticRenderFns = s, c._compiled = !0);
  var u;
  if (a && (u = a), u)
    if (c.functional) {
      c._injectStyles = u;
      var i = c.render;
      c.render = function(p, m) {
        return u.call(m), i(p, m);
      };
    } else {
      var _ = c.beforeCreate;
      c.beforeCreate = _ ? [].concat(_, u) : [u];
    }
  return {
    exports: n,
    options: c
  };
}
const xt = [
  "2xs",
  "xs",
  "sm",
  "lg",
  "xl",
  "2xl",
  "1x",
  "2x",
  "3x",
  "4x",
  "5x",
  "6x",
  "7x",
  "8x",
  "9x",
  "10x"
], { createIconProps: Tt } = ce(), vi = {
  name: "XIcon",
  components: {
    FontAwesomeIcon: tr
  }
}, gi = Object.assign(vi, {
  props: {
    size: {
      type: String,
      default: null,
      validation: (n) => xt.includes(n)
    },
    rotation: {
      type: String,
      default: null
    },
    flip: {
      type: String,
      default: null
    },
    pull: {
      type: String,
      default: null
    },
    transform: {
      type: String,
      default: null
    },
    fixedWidth: Boolean,
    spin: Boolean,
    pulse: Boolean,
    border: Boolean,
    inverse: Boolean,
    swapOpacity: Boolean,
    left: Boolean,
    right: Boolean,
    ...Tt({
      required: !0
    })
  },
  setup(n) {
    const e = n, s = D(), t = l(() => [
      { [s.left]: e.left },
      { [s.right]: e.right }
    ]);
    return { __sfc: !0, ICON_SIZES: xt, createIconProps: Tt, props: e, $style: s, iconClasses: t, FontAwesomeIcon: tr };
  }
});
var hi = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.FontAwesomeIcon, { class: [t.iconClasses, t.$style.icon, e.fixedWidth && t.$style.isFixedWidth], attrs: { icon: [e.iconStyle, e.icon], size: e.size, "fixed-width": e.fixedWidth, rotation: e.rotation, flip: e.flip, spin: e.spin, pulse: e.pulse, border: e.border, pull: e.pull, inverse: e.inverse, "swap-opacity": e.swapOpacity, transform: e.transform } });
}, yi = [];
const St = {
  $style: mi
};
function bi(n) {
  for (var e in St)
    this[e] = St[e];
}
var $i = /* @__PURE__ */ x(
  gi,
  hi,
  yi,
  !1,
  bi
);
const B = $i.exports, { createDisabledProp: Pt } = q(), { createLinkProps: Ct } = $e(), { createTestIdProp: wt } = S(), Ii = {
  name: "BaseLink"
}, xi = /* @__PURE__ */ Object.assign(Ii, {
  props: {
    ...Ct(),
    ...Pt(),
    ...wt()
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const s = n, t = ii(), { isNuxt: a } = Ur(), { v2Listeners: o } = U(["click"]), r = l(() => !!t), d = l(() => !s.to), c = l(() => {
      try {
        return !!new URL(s.to);
      } catch {
        return !1;
      }
    }), u = l(() => {
      if (s.external) return !0;
      if (c.value) {
        const { origin: T } = window.location, { origin: k } = new URL(s.to);
        return T !== k;
      }
      return !1;
    }), i = l(() => !u.value && !d.value), _ = l(() => a && !s.native), f = l(
      () => r.value && i.value && !s.disabled && !s.native
    ), p = l(() => {
      if (c.value && !u.value) {
        const { origin: T } = window.location;
        return s.to.replace(T, "");
      }
      return s.to;
    }), m = l(() => _.value ? ai("NuxtLink") : f.value ? "router-link" : "a"), v = l(() => f.value || _.value ? "to" : "href"), I = l(() => ({
      [v.value]: p.value,
      rel: s.target === "_blank" ? "noopener noreferrer" : null,
      target: s.target,
      "aria-disabled": s.disabled,
      "data-testid": s.dataTestid
    }));
    function g(T) {
      s.disabled ? T.preventDefault() : (d.value && T.preventDefault(), e("click", T));
    }
    return { __sfc: !0, createDisabledProp: Pt, createLinkProps: Ct, createTestIdProp: wt, props: s, emit: e, router: t, isNuxt: a, v2Listeners: o, hasRouter: r, isInvalidUrl: d, isCompleteUrl: c, isExternalUrl: u, isValidUrlToRouterLink: i, canUseNuxt: _, canUseRouterLink: f, linkUrl: p, linkTag: m, linkUrlAttr: v, linkAttributes: I, clickHandler: g };
  }
});
var Ti = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.linkTag, e._g(e._b({ tag: "Component", on: { click: t.clickHandler } }, "Component", t.linkAttributes, !1), t.v2Listeners), [e._t("default")], 2);
}, Si = [], Pi = /* @__PURE__ */ x(
  xi,
  Ti,
  Si,
  !1,
  null
);
const xe = Pi.exports, Ci = "_XLinkPlain_dw9p0_1", wi = "_XLink_dw9p0_1", Bi = "_sizeSmall_dw9p0_27", ki = "_noPadding_dw9p0_30", Li = "_right_dw9p0_33", Di = "_icon_dw9p0_33", Mi = "_isInverted_dw9p0_36", Ai = "_isDisabled_dw9p0_46", Oi = {
  XLinkPlain: Ci,
  XLink: wi,
  sizeSmall: Bi,
  noPadding: ki,
  right: Li,
  icon: Di,
  isInverted: Mi,
  isDisabled: Ai
}, { createIconProps: Bt } = ce(), { createLinkProps: kt } = $e(), { createDisabledProp: Lt } = q(), { createTestIdProp: Dt, setupTestId: Mt } = S(), Fi = {
  name: "XLink",
  components: { XIcon: B, BaseLink: xe }
}, Ei = /* @__PURE__ */ Object.assign(Fi, {
  props: {
    inverted: {
      type: Boolean,
      default: !1
    },
    iconPosition: {
      type: String,
      default: "left",
      validator: (n) => /left|right/.test(n)
    },
    small: Boolean,
    plain: Boolean,
    noPadding: Boolean,
    ...kt(),
    ...Bt(),
    ...Lt(),
    ...Dt()
  },
  emits: ["click"],
  setup(n) {
    const e = n, s = D(), { formatTestId: t } = Mt(e), a = l(() => e.small ? "sm" : "1x"), o = l(() => ({
      [s.XLink]: !e.plain,
      [s.XLinkPlain]: e.plain
    })), r = l(() => ({
      ...o.value,
      [s.isInverted]: e.inverted,
      [s.sizeSmall]: e.small,
      [s.noPadding]: e.noPadding,
      [s[e.iconPosition]]: !0
    }));
    return { __sfc: !0, createIconProps: Bt, createLinkProps: kt, createDisabledProp: Lt, createTestIdProp: Dt, setupTestId: Mt, props: e, $style: s, formatTestId: t, iconSize: a, baseClass: o, linkClasses: r, BaseLink: xe, XIcon: B };
  }
});
var Ri = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.BaseLink, e._b({ class: [t.linkClasses], attrs: { "aria-disabled": e.disabled, "data-testid": t.formatTestId() }, on: { click: (a) => e.$emit("click", a) } }, "BaseLink", { ...e.$props, ...e.$attrs }, !1), [e.icon ? s(t.XIcon, { class: t.$style.icon, attrs: { icon: e.icon, "icon-style": e.iconStyle, size: t.iconSize, "data-testid": t.formatTestId("icon"), "fixed-width": !0 } }) : e._e(), e._t("default")], 2);
}, Ni = [];
const At = {
  $style: Oi
};
function Xi(n) {
  for (var e in At)
    this[e] = At[e];
}
var Vi = /* @__PURE__ */ x(
  Ei,
  Ri,
  Ni,
  !1,
  Xi
);
const ne = Vi.exports;
function zi(n = "default") {
  const e = ve();
  return {
    hasContent: l(() => {
      var a, o, r;
      if (!e[n] || ((a = e[n]()) == null ? void 0 : a.length) === 0) return !1;
      const t = e[n]()[0];
      return J ? !!((o = String(t.text)) != null && o.replace(/\s+/g, "")) : !!((r = String(t.children)) != null && r.replace(/\s+/g, ""));
    })
  };
}
function dr() {
  const n = {
    topRight: "top-right",
    bottomLeft: "bottom-left",
    bottomRight: "bottom-right",
    topLeft: "top-left"
  };
  function e() {
    return {
      position: {
        type: String,
        default: n.topRight
      }
    };
  }
  function s(t) {
    const a = D();
    return {
      positionClass: l(() => ({
        [a.isTopRight]: t.position === n.topRight,
        [a.isTopLeft]: t.position === n.topLeft,
        [a.isBottomRight]: t.position === n.bottomRight,
        [a.isBottomLeft]: t.position === n.bottomLeft
      }))
    };
  }
  return {
    createPositionProp: e,
    getCurrentPositionClass: s,
    POSITIONS: n
  };
}
const le = {
  inline: {
    name: "inline",
    className: "modelInline"
  },
  banner: {
    name: "banner",
    className: "modelBanner"
  },
  toast: {
    name: "toast",
    className: "modelToast"
  }
}, ji = Object.values(le).map(({ name: n }) => n);
function lt(n) {
  const e = l(() => n.model === le.inline.name), s = l(() => n.model === le.banner.name), t = l(() => n.model === le.toast.name);
  return {
    isInlineModel: e,
    isBannerModel: s,
    isToastModel: t
  };
}
const { getFullWidthClass: qi } = Q(), { getCurrentPositionClass: Hi } = dr();
function Wi(n) {
  const e = D(), { fullWidthClass: s } = qi(n), { positionClass: t } = Hi(n), { isInlineModel: a, isBannerModel: o, isToastModel: r } = lt(n), d = l(() => ({
    [e[le.inline.className]]: a.value,
    [e[le.banner.className]]: o.value,
    [e[le.toast.className]]: r.value
  }));
  return { alertClasses: l(() => ({
    [e[n.type]]: !!n.type,
    [e.hasElevation]: n.elevation,
    [e.noTitle]: !n.title,
    [e.isClosable]: n.closable,
    ...d.value,
    ...s.value,
    ...t.value
  })), positionClass: t };
}
const Ki = 7e3;
function Ui(n) {
  const { alertRef: e, timeBarRef: s, props: t, callback: a } = n;
  let o = !1, r = null, d, c = t.duration;
  const u = Fr(e), { isToastModel: i } = lt(t);
  function _() {
    i.value && !o && (d = Date.now(), v(), r = setTimeout(() => {
      a();
    }, c));
  }
  function f() {
    if (i.value) {
      m();
      const g = Date.now() - d;
      v("paused"), c -= g;
    }
  }
  function p() {
    i.value && (m(), o = !0);
  }
  function m() {
    r && (clearTimeout(r), r = null);
  }
  function v(g = "running") {
    var T;
    (T = s.value) != null && T.style && (s.value.style.animationPlayState = g);
  }
  function I() {
    s.value && i.value && (s.value.style.animationDuration = `${t.duration}ms`);
  }
  return R(u, (g) => {
    g ? f() : _();
  }), R(
    () => t.isVisible,
    (g) => {
      g && _();
    },
    { immediate: !0 }
  ), Le(() => {
    I();
  }), {
    finishCloseTimer: p
  };
}
const it = {
  info: {
    name: "info",
    icon: "circle-info"
  },
  success: {
    name: "success",
    icon: "circle-check"
  },
  warning: {
    name: "warning",
    icon: "triangle-exclamation"
  },
  error: {
    name: "error",
    icon: "circle-xmark"
  }
}, Gi = Object.values(it).map(({ name: n }) => n);
function Zi(n) {
  return {
    activeIcon: l(() => n.icon || it[n.type].icon)
  };
}
const Yi = "_fadeEnterActive_1q30g_54", Ji = "_fadeIn_1q30g_1", Qi = "_fadeLeaveActive_1q30g_58", ec = "_fadeOut_1q30g_1", tc = "_xAlert_1q30g_62", sc = "_modelInline_1q30g_68", nc = "_info_1q30g_77", ac = "_success_1q30g_82", oc = "_error_1q30g_87", rc = "_warning_1q30g_92", lc = "_modelBanner_1q30g_97", ic = "_details_1q30g_123", cc = "_title_1q30g_129", dc = "_actions_1q30g_132", uc = "_isClosable_1q30g_137", _c = "_modelToast_1q30g_141", pc = "_isTopRight_1q30g_148", fc = "_slideEnterActive_1q30g_148", mc = "_isBottomRight_1q30g_148", vc = "_slideEnterRight_1q30g_1", gc = "_slideLeaveActive_1q30g_154", hc = "_slideLeaveRight_1q30g_1", yc = "_isTopLeft_1q30g_160", bc = "_isBottomLeft_1q30g_160", $c = "_slideEnterLeft_1q30g_1", Ic = "_slideLeaveLeft_1q30g_1", xc = "_timeBar_1q30g_188", Tc = "_timeout_1q30g_1", Sc = "_isFullWidth_1q30g_218", Pc = "_container_1q30g_221", Cc = "_icon_1q30g_230", wc = "_text_1q30g_251", Bc = "_link_1q30g_267", kc = "_closeButton_1q30g_275", Lc = "_closeIcon_1q30g_288", Dc = "_isDisabled_1q30g_291", Mc = {
  fadeEnterActive: Yi,
  fadeIn: Ji,
  fadeLeaveActive: Qi,
  fadeOut: ec,
  xAlert: tc,
  modelInline: sc,
  info: nc,
  success: ac,
  error: oc,
  warning: rc,
  modelBanner: lc,
  details: ic,
  title: cc,
  actions: dc,
  isClosable: uc,
  modelToast: _c,
  isTopRight: pc,
  slideEnterActive: fc,
  isBottomRight: mc,
  slideEnterRight: vc,
  slideLeaveActive: gc,
  slideLeaveRight: hc,
  isTopLeft: yc,
  isBottomLeft: bc,
  slideEnterLeft: $c,
  slideLeaveLeft: Ic,
  timeBar: xc,
  timeout: Tc,
  isFullWidth: Sc,
  container: Pc,
  icon: Cc,
  text: wc,
  link: Bc,
  closeButton: kc,
  closeIcon: Lc,
  isDisabled: Dc
}, { createIconProps: Ot } = ce(), { createTestIdProp: Ft, setupTestId: Et } = S(), { createFullWidthProp: Rt } = Q(), { createPositionProp: Nt } = dr(), Ac = {
  name: "XAlert",
  components: { XIcon: B, XLink: ne }
}, Oc = /* @__PURE__ */ Object.assign(Ac, {
  props: {
    type: {
      type: String,
      default: it.info.name,
      validator: (n) => Gi.includes(n)
    },
    model: {
      type: String,
      default: le.inline.name,
      validator: (n) => ji.includes(n)
    },
    title: {
      type: String,
      default: ""
    },
    actions: {
      type: Array,
      default: () => []
    },
    isVisible: {
      type: Boolean,
      default: !0
    },
    closable: {
      type: Boolean,
      default: !1
    },
    duration: {
      type: Number,
      default: Ki
    },
    ...Nt(),
    ...Rt(),
    ...Ot(),
    ...Ft()
  },
  emits: ["close"],
  setup(n, { emit: e }) {
    const s = n, { t } = W(), a = D(), { activeIcon: o } = Zi(s), { alertClasses: r } = Wi(s), { formatTestId: d } = Et(s), { isToastModel: c } = lt(s), { hasContent: u } = zi(), i = y(null), _ = y(null), f = y(!1), { finishCloseTimer: p } = Ui({
      alertRef: _,
      timeBarRef: i,
      props: s,
      callback: () => T()
    }), m = l(() => c.value ? "slide" : "fade"), v = l(() => ({
      enter: a[`${m.value}EnterActive`],
      leave: a[`${m.value}LeaveActive`]
    })), I = l(() => ({
      base: d(),
      icon: d("icon"),
      title: d("title"),
      link: d("link"),
      text: d("text"),
      timeBar: d("timeBar"),
      closeButton: d("closeButton"),
      closeButtonIcon: d("closeButtonIcon")
    }));
    function g(k) {
      f.value = k;
    }
    function T() {
      p(), e("close", !1), g(!1);
    }
    return R(
      () => s.isVisible,
      async (k) => {
        c.value ? await ie(() => {
          g(k);
        }) : g(k);
      },
      { immediate: !0 }
    ), { __sfc: !0, createIconProps: Ot, createTestIdProp: Ft, setupTestId: Et, createFullWidthProp: Rt, createPositionProp: Nt, props: s, emit: e, t, $style: a, activeIcon: o, alertClasses: r, formatTestId: d, isToastModel: c, hasContent: u, timeBarRef: i, alertRef: _, canShowAlert: f, finishCloseTimer: p, animationName: m, animationClasses: v, testIds: I, setCanShowAlert: g, close: T, XIcon: B, XLink: ne };
  }
});
var Fc = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("transition", { attrs: { name: t.animationName, "enter-active-class": t.animationClasses.enter, "leave-active-class": t.animationClasses.leave } }, [s("div", { directives: [{ name: "show", rawName: "v-show", value: t.canShowAlert, expression: "canShowAlert" }], ref: "alertRef", class: [t.$style.xAlert, t.alertClasses], attrs: { "data-testid": t.testIds.base } }, [s("div", { class: t.$style.container }, [t.activeIcon ? s(t.XIcon, { class: t.$style.icon, attrs: { icon: t.activeIcon, "icon-style": e.iconStyle, "data-testid": t.testIds.icon } }) : e._e(), s("div", { class: t.$style.details, attrs: { role: "alert", "aria-live": "polite" } }, [e.title ? s("h5", { class: t.$style.title, attrs: { "data-testid": t.testIds.title } }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), t.hasContent ? s("div", { class: t.$style.text, attrs: { "data-testid": t.testIds.text } }, [e._t("default")], 2) : e._e(), e.actions.length > 0 ? s("div", { class: t.$style.actions }, e._l(e.actions, function(a) {
    return s(t.XLink, { key: `action-${a.text}`, class: t.$style.link, attrs: { to: a.to, external: a == null ? void 0 : a.external, native: a == null ? void 0 : a.native, target: a == null ? void 0 : a.target, "data-testid": (a == null ? void 0 : a.dataTestId) || t.testIds.link, "no-padding": "" } }, [e._v(e._s(a.text))]);
  }), 1) : e._e()]), e.closable ? s("button", { class: t.$style.closeButton, attrs: { "data-testid": t.testIds.closeButton, title: t.t("ds.xAlert.actions.close") }, on: { click: function(a) {
    return t.close();
  } } }, [s(t.XIcon, { class: t.$style.closeIcon, attrs: { icon: "xmark-large", size: "sm", "icon-style": "fas", "data-testid": t.testIds.closeButtonIcon } })], 1) : e._e()], 1), s("div", { directives: [{ name: "show", rawName: "v-show", value: t.isToastModel, expression: "isToastModel" }], ref: "timeBarRef", class: t.$style.timeBar, attrs: { "data-testid": t.testIds.timeBar } })])]);
}, Ec = [];
const Xt = {
  $style: Mc
};
function Rc(n) {
  for (var e in Xt)
    this[e] = Xt[e];
}
var Nc = /* @__PURE__ */ x(
  Oc,
  Fc,
  Ec,
  !1,
  Rc
);
const Xc = Nc.exports, Vc = [
  "neutral",
  "neutral-0",
  "brand-primary",
  "feedback-success",
  "feedback-error",
  "feedback-warning",
  "feedback-info",
  "brand-support-01",
  "support-01",
  "support-02",
  "support-04"
], zc = "_xBadge_1dkvc_1", jc = "_neutral_1dkvc_11", qc = "_bold_1dkvc_15", Hc = "_isDisabled_1dkvc_15", Wc = "_closeButton_1dkvc_22", Kc = "_subtle_1dkvc_25", Uc = "_text_1dkvc_25", Gc = "_sizeSmall_1dkvc_344", Zc = "_sizeLarge_1dkvc_347", Yc = "_iconContainer_1dkvc_352", Jc = "_icon_1dkvc_352", Qc = "_noLabel_1dkvc_397", ed = {
  xBadge: zc,
  neutral: jc,
  bold: qc,
  isDisabled: Hc,
  closeButton: Wc,
  subtle: Kc,
  text: Uc,
  "neutral-0": "_neutral-0_1dkvc_36",
  "brand-primary": "_brand-primary_1dkvc_62",
  "feedback-success": "_feedback-success_1dkvc_87",
  "feedback-error": "_feedback-error_1dkvc_112",
  "feedback-warning": "_feedback-warning_1dkvc_137",
  "feedback-info": "_feedback-info_1dkvc_162",
  "brand-support-01": "_brand-support-01_1dkvc_187",
  "support-01": "_support-01_1dkvc_212",
  "support-02": "_support-02_1dkvc_237",
  "support-04": "_support-04_1dkvc_262",
  sizeSmall: Gc,
  sizeLarge: Zc,
  iconContainer: Yc,
  icon: Jc,
  noLabel: Qc
}, { createIconProps: Vt } = ce(), { createTestIdProp: zt, setupTestId: jt } = S(), { createDisabledProp: qt, getDisabledClass: Ht } = q(), td = {
  name: "XBadge",
  components: { XIcon: B },
  inheritAttrs: !1
}, sd = /* @__PURE__ */ Object.assign(td, {
  props: {
    tag: {
      type: String,
      default: "div",
      validation: (n) => ["div", "li"].includes(n)
    },
    size: {
      type: String,
      default: "",
      validation: (n) => ["", "sm", "lg"].includes(n)
    },
    color: {
      type: String,
      default: "neutral",
      validator: (n) => Vc.includes(n)
    },
    bold: {
      type: Boolean,
      default: !1
    },
    subtle: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    ...Vt(),
    ...qt(),
    ...zt()
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const s = n, t = ve(), a = D(), { t: o } = W(), { formatTestId: r } = jt(s), { v2Listeners: d } = U(["click"]), { disabledClass: c } = Ht(s), u = l(() => {
      var v, I, g;
      if (!(t != null && t.default) || ((v = t == null ? void 0 : t.default()) == null ? void 0 : v.length) === 0) return !1;
      const m = t.default()[0];
      return J ? !!((I = String(m.text)) != null && I.replace(/\s+/g, "")) : !!((g = String(m.children)) != null && g.replace(/\s+/g, ""));
    }), i = l(() => s.size === "sm" ? "xs" : null), _ = l(() => ({
      [a.sizeSmall]: s.size === "sm",
      [a.sizeLarge]: s.size === "lg"
    })), f = l(() => ({
      [a[s.color]]: !!s.color,
      [a.noLabel]: !u.value,
      [a.subtle]: s.subtle,
      [a.bold]: s.bold,
      ...c.value,
      ..._.value
    }));
    function p(m) {
      s.disabled ? m.preventDefault() : e("click", m);
    }
    return { __sfc: !0, createIconProps: Vt, createTestIdProp: zt, setupTestId: jt, createDisabledProp: qt, getDisabledClass: Ht, props: s, slots: t, $style: a, t: o, emit: e, formatTestId: r, v2Listeners: d, disabledClass: c, hasContent: u, iconSize: i, sizeClass: _, badgeClasses: f, clickHandler: p, XIcon: B };
  }
});
var nd = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(e.tag, { tag: "component", class: [t.$style.xBadge, t.badgeClasses], attrs: { "data-testid": t.formatTestId(), title: e.label } }, [e.icon ? s("span", { class: t.$style.iconContainer }, [s(t.XIcon, { class: t.$style.icon, attrs: { icon: e.icon, "icon-style": e.iconStyle, size: t.iconSize, "data-testid": t.formatTestId("icon") } })], 1) : e._e(), t.hasContent ? s("span", { class: t.$style.text, attrs: { "data-testid": t.formatTestId("text") } }, [e._t("default")], 2) : e._e(), e.closable ? s("button", e._g(e._b({ class: t.$style.closeButton, attrs: { "data-testid": t.formatTestId("closeButton"), "aria-disabled": `${e.disabled}`, title: t.t("ds.xBadge.actions.close") }, on: { click: t.clickHandler } }, "button", e.$attrs, !1), t.v2Listeners), [s(t.XIcon, { attrs: { icon: "xmark-large", "icon-style": "fas", size: "2xs" } })], 1) : e._e()]);
}, ad = [];
const Wt = {
  $style: ed
};
function od(n) {
  for (var e in Wt)
    this[e] = Wt[e];
}
var rd = /* @__PURE__ */ x(
  sd,
  nd,
  ad,
  !1,
  od
);
const he = rd.exports, ld = "_spinner_org9d_1", id = "_isVerticalAligned_org9d_7", cd = "_spinnerIcon_org9d_10", dd = "_spin_org9d_1", ud = "_fade_org9d_1", _d = {
  spinner: ld,
  isVerticalAligned: id,
  spinnerIcon: cd,
  spin: dd,
  fade: ud
}, { createTestIdProp: Kt, setupTestId: Ut } = S(), pd = {
  name: "XSpinner",
  components: { XIcon: B }
}, fd = /* @__PURE__ */ Object.assign(pd, {
  props: {
    size: {
      type: String,
      default: "medium",
      validator: (n) => ["small", "medium", "large"].includes(n)
    },
    variant: {
      type: String,
      default: "primary",
      validator: (n) => ["primary", "light", "dark"].includes(n)
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    showText: {
      type: Boolean,
      default: !1
    },
    ...Kt()
  },
  setup(n) {
    const e = n, s = {
      small: "sm",
      medium: "xl",
      large: "2x"
    }, t = {
      primary: "--color-brand-primary-400",
      light: "--color-neutral-0",
      dark: "--color-brand-primary-600"
    }, a = D(), { t: o } = W(), { formatTestId: r } = Ut(e), d = l(() => s[e.size]), c = l(() => ({
      "--spinner-color": `var(${t[e.variant]})`
    })), u = l(() => ({
      [a.isVerticalAligned]: e.vertical
    }));
    return { __sfc: !0, createTestIdProp: Kt, setupTestId: Ut, sizes: s, variantColors: t, props: e, $style: a, t: o, formatTestId: r, innerSize: d, spinnerStyle: c, verticalClass: u, XIcon: B };
  }
});
var md = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: [t.$style.spinner, t.verticalClass], style: t.spinnerStyle, attrs: { role: "alert", "aria-busy": "true", "aria-live": "polite", "aria-describedby": "spinnerText", "data-testid": t.formatTestId() } }, [s(t.XIcon, { class: t.$style.spinnerIcon, attrs: { icon: "spinner", "icon-style": "fak", "aria-hidden": "true", size: t.innerSize, "data-testid": t.formatTestId("icon") } }), s("span", { directives: [{ name: "show", rawName: "v-show", value: e.showText, expression: "showText" }], attrs: { id: "spinnerText", "aria-hidden": "true", "data-testid": t.formatTestId("text") } }, [e._t("default", function() {
    return [e._v(e._s(t.t("ds.xSpinner.loading")))];
  })], 2)], 1);
}, vd = [];
const Gt = {
  $style: _d
};
function gd(n) {
  for (var e in Gt)
    this[e] = Gt[e];
}
var hd = /* @__PURE__ */ x(
  fd,
  md,
  vd,
  !1,
  gd
);
const Ae = hd.exports, { getFullWidthClass: yd } = Q(), { getLoadingClass: bd } = He();
function $d(n, e) {
  const s = D(), { loadingClass: t } = bd(n), a = l(() => e.value ? "custom" : ""), o = l(() => n.inverted ? "inverted" : ""), r = l(() => ze(`model ${n.model ? n.model : "default"}`)), d = l(() => `design ${n.design ? n.design : "default"}`), c = l(() => {
    const v = ze(
      `${r.value} ${o.value} ${a.value} ${d.value}`
    ), I = ze(
      `${r.value} ${o.value} ${a.value} design`
    );
    return {
      [s[r.value]]: !0,
      [s[I]]: !0,
      [s[v]]: !0
    };
  }), u = l(() => n.model === "plain"), i = l(() => ({
    [s.XButton]: !u.value,
    [s.XButtonPlain]: u.value
  })), _ = l(() => ({
    [s.sizeNano]: n.size === "nano",
    [s.sizeXSmall]: n.size === "xs",
    [s.sizeSmall]: n.size === "sm",
    [s.sizeMedium]: n.size === "md",
    [s.sizeLarge]: n.size === "lg"
  })), f = l(() => ({
    [s.radiusRounded]: n.borderRadius === "rounded",
    [s.radiusCircle]: n.borderRadius === "circle",
    [s.radiusSquare]: n.borderRadius === "square"
  })), { fullWidthClass: p } = yd(n);
  return {
    buttonClasses: l(() => ({
      ...i.value,
      ...c.value,
      ..._.value,
      ...f.value,
      ...t.value,
      ...p.value
    }))
  };
}
const Zt = {
  textColor: "#ffffff",
  // var(--color-neutral-0)
  color: "#5E0F2E"
  // var(--color-brand-secondary-400)
};
function Id(n) {
  const e = D(), s = l(() => !!(n.color || n.textColor)), t = l(() => n.color || Zt.color), a = l(() => n.textColor || Zt.textColor), o = l(() => $t(t.value)), r = l(() => $t(a.value)), d = l(() => parseFloat(Ql(o.value)));
  function c(f) {
    return ei(
      o.value,
      `${d.value + f}%`
    );
  }
  const u = l(() => ({
    light100: c(45),
    light200: c(30),
    dark500: c(-10)
  })), i = l(() => ({
    "--custom-primary-color": o.value,
    "--custom-primary-color-100": u.value.light100,
    "--custom-primary-color-200": u.value.light200,
    "--custom-primary-color-500": u.value.dark500,
    "--custom-secondary-color": r.value
  })), _ = l(() => ({
    [e.hasCustomColors]: s.value
  }));
  return {
    hasCustomColors: s,
    customColorsClass: _,
    customColorsVariables: i
  };
}
const xd = "_XButton_ajezc_1", Td = "_XButtonPlain_ajezc_1", Sd = "_hasCustomColors_ajezc_21", Pd = "_isFullWidth_ajezc_45", Cd = "_content_ajezc_48", wd = "_loading_ajezc_55", Bd = "_isDisabled_ajezc_62", kd = "_radiusRounded_ajezc_74", Ld = "_sizeSmall_ajezc_77", Dd = "_sizeXSmall_ajezc_80", Md = "_radiusCircle_ajezc_85", Ad = "_sizeNano_ajezc_88", Od = "_sizeLarge_ajezc_99", Fd = "_radiusSquare_ajezc_107", Ed = "_isLoading_ajezc_123", Rd = "_modelDefaultDesignDefault_ajezc_187", Nd = "_modelDefaultDesignText_ajezc_195", Xd = "_modelDefaultDesignOutlined_ajezc_204", Vd = "_modelDefaultDesign_ajezc_187", zd = "_modelDefaultInvertedDesign_ajezc_228", jd = "_modelDefaultInvertedDesignDefault_ajezc_232", qd = "_modelDefaultInvertedDesignText_ajezc_239", Hd = "_modelDefaultInvertedDesignOutlined_ajezc_247", Wd = "_modelAlternativeDesign_ajezc_271", Kd = "_modelAlternativeDesignDefault_ajezc_276", Ud = "_modelAlternativeDesignText_ajezc_284", Gd = "_modelAlternativeDesignOutlined_ajezc_293", Zd = "_modelAlternativeInvertedDesign_ajezc_319", Yd = "_modelAlternativeInvertedDesignDefault_ajezc_324", Jd = "_modelAlternativeInvertedDesignText_ajezc_332", Qd = "_modelAlternativeInvertedDesignOutlined_ajezc_341", eu = "_modelLightDesignDefault_ajezc_367", tu = "_modelLightDesign_ajezc_367", su = "_modelDefaultCustomDesignDefault_ajezc_388", nu = "_modelDefaultCustomDesignText_ajezc_393", au = "_modelDefaultCustomDesignOutlined_ajezc_398", ou = "_modelDefaultCustomDesign_ajezc_388", ru = "_modelDefaultInvertedCustomDesignDefault_ajezc_420", lu = "_modelDefaultInvertedCustomDesignText_ajezc_425", iu = "_modelDefaultInvertedCustomDesignOutlined_ajezc_432", cu = "_modelDefaultInvertedCustomDesign_ajezc_420", du = {
  XButton: xd,
  XButtonPlain: Td,
  hasCustomColors: Sd,
  isFullWidth: Pd,
  content: Cd,
  loading: wd,
  isDisabled: Bd,
  radiusRounded: kd,
  sizeSmall: Ld,
  sizeXSmall: Dd,
  radiusCircle: Md,
  sizeNano: Ad,
  sizeLarge: Od,
  radiusSquare: Fd,
  isLoading: Ed,
  modelDefaultDesignDefault: Rd,
  modelDefaultDesignText: Nd,
  modelDefaultDesignOutlined: Xd,
  modelDefaultDesign: Vd,
  modelDefaultInvertedDesign: zd,
  modelDefaultInvertedDesignDefault: jd,
  modelDefaultInvertedDesignText: qd,
  modelDefaultInvertedDesignOutlined: Hd,
  modelAlternativeDesign: Wd,
  modelAlternativeDesignDefault: Kd,
  modelAlternativeDesignText: Ud,
  modelAlternativeDesignOutlined: Gd,
  modelAlternativeInvertedDesign: Zd,
  modelAlternativeInvertedDesignDefault: Yd,
  modelAlternativeInvertedDesignText: Jd,
  modelAlternativeInvertedDesignOutlined: Qd,
  modelLightDesignDefault: eu,
  modelLightDesign: tu,
  modelDefaultCustomDesignDefault: su,
  modelDefaultCustomDesignText: nu,
  modelDefaultCustomDesignOutlined: au,
  modelDefaultCustomDesign: ou,
  modelDefaultInvertedCustomDesignDefault: ru,
  modelDefaultInvertedCustomDesignText: lu,
  modelDefaultInvertedCustomDesignOutlined: iu,
  modelDefaultInvertedCustomDesign: cu
}, { createFullWidthProp: Yt } = Q(), { createLinkProps: Jt } = $e(), { createDisabledProp: Qt } = q(), { createLoadingProp: es } = He(), { createTestIdProp: ts, setupTestId: ss } = S(), uu = {
  name: "XButton",
  components: { XSpinner: Ae, BaseLink: xe }
}, _u = /* @__PURE__ */ Object.assign(uu, {
  props: {
    type: {
      type: String,
      default: "button",
      validator: (n) => /^$|button|submit/.test(n)
    },
    model: {
      type: String,
      default: "",
      validator: (n) => /^$|alternative|light|plain/.test(n)
    },
    design: {
      type: String,
      default: "",
      validator: (n) => /^$|outlined|text/.test(n)
    },
    inverted: {
      type: Boolean,
      default: !1
    },
    borderRadius: {
      type: String,
      default: "rounded",
      validator: (n) => /^$|rounded|circle|square/.test(n)
    },
    size: {
      type: String,
      default: "",
      validator: (n) => /^$|nano|xs|sm|lg/.test(n)
    },
    color: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    ...Jt(),
    ...es(),
    ...Qt(),
    ...Yt(),
    ...ts()
  },
  emits: ["click"],
  setup(n) {
    const e = n, { v2Listeners: s } = U(["click"]), { formatTestId: t } = ss(e), { hasCustomColors: a, customColorsClass: o, customColorsVariables: r } = Id(e), { buttonClasses: d } = $d(e, a), c = l(() => e.to ? "BaseLink" : "button"), u = l(() => e.to ? "" : e.type);
    return { __sfc: !0, createFullWidthProp: Yt, createLinkProps: Jt, createDisabledProp: Qt, createLoadingProp: es, createTestIdProp: ts, setupTestId: ss, props: e, v2Listeners: s, formatTestId: t, hasCustomColors: a, customColorsClass: o, customColorsVariables: r, buttonClasses: d, componentName: c, buttonType: u, XSpinner: Ae };
  }
});
var pu = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.componentName, e._g(e._b({ tag: "Component", class: [t.buttonClasses, t.customColorsClass], style: t.customColorsVariables, attrs: { type: t.buttonType, "data-testid": t.formatTestId(), disabled: e.disabled || e.loading }, on: { click: (a) => e.$emit("click", a) } }, "Component", { ...e.$props, ...e.$attrs }, !1), t.v2Listeners), [s("div", { class: e.$style.content }, [e._t("default")], 2), s("div", { class: e.$style.loading }, [s(t.XSpinner, { directives: [{ name: "show", rawName: "v-show", value: e.loading, expression: "loading" }], staticStyle: { "--spinner-color": "inherit" }, attrs: { "data-testid": t.formatTestId("loading") } })], 1)]);
}, fu = [];
const ns = {
  $style: du
};
function mu(n) {
  for (var e in ns)
    this[e] = ns[e];
}
var vu = /* @__PURE__ */ x(
  _u,
  pu,
  fu,
  !1,
  mu
);
const ae = vu.exports, { PLACEMENTS: as } = Ie();
function gu(n) {
  const e = y(null), s = l(() => {
    function a(c) {
      return c.split("-")[0];
    }
    function o(c) {
      return RegExp(`\\b${e.value}\\b`).test(a(c));
    }
    const r = as.filter((c) => o(c)), d = as.filter((c) => !o(c));
    return [...r, ...d];
  });
  function t(a) {
    e.value = a || "bottom";
  }
  return R(
    () => n.placement,
    () => {
      t(n.placement);
    },
    {
      deep: !0,
      immediate: !0
    }
  ), { activePlacement: e, placementsPriorityOrder: s, setPlacement: t };
}
function hu(n) {
  const e = y(null), s = 12, t = l(() => ({
    backgroundColor: n.arrowColor
  }));
  function a(r) {
    const d = window.devicePixelRatio || 1;
    return Math.round(r * d) / d;
  }
  function o(r) {
    if (r && e.value) {
      const { x: d, y: c } = r;
      Object.assign(e.value.style, {
        left: d != null ? `${d}px` : "",
        top: c != null ? `${c}px` : ""
      });
    }
  }
  return {
    arrowRef: e,
    arrowStyles: t,
    arrowOffset: s,
    roundByDPR: a,
    updateArrowPosition: o
  };
}
function yu(n) {
  const { activePlacement: e, placementsPriorityOrder: s, setPlacement: t, props: a } = n, { arrowRef: o, arrowStyles: r, arrowOffset: d, roundByDPR: c, updateArrowPosition: u } = hu(a), i = y(void 0), _ = y(null), f = y(null), p = y(null), m = l(() => !a.offset && a.showArrow ? d : a.offset), v = l(() => ({
    strategy: "absolute",
    placement: e.value,
    middleware: [
      Vr(m.value),
      zr({ element: o.value }),
      jr({
        padding: m.value,
        fallbackPlacements: s.value
      })
    ]
  }));
  function I() {
    f.value && p.value && Hr(f.value, p.value, v.value).then(
      ({ x: k, y: L, placement: O, middlewareData: h }) => {
        p.value && (Object.assign(p.value.style, {
          left: "0",
          top: "0",
          // Use Transform instead top and left to improve performance
          transform: `translate(${c(k)}px,${c(L)}px)`
        }), t(O)), u(h.arrow);
      }
    );
  }
  function g() {
    a.innerDropdown || document.body.appendChild(p.value);
  }
  function T() {
    a.innerDropdown || _.value.appendChild(p.value), i.value();
  }
  return Le(() => {
    g(), i.value = qr(f.value, p.value, I, {
      ancestorScroll: !0,
      ancestorResize: !0,
      elementResize: !0,
      animationFrame: !1
    });
  }), Go(() => {
    T();
  }), {
    containerRef: _,
    activatorRef: f,
    dropdownRef: p,
    arrowRef: o,
    arrowStyles: r,
    updateDropdown: I
  };
}
function bu(n) {
  const { updateDropdown: e, emit: s, props: t } = n, a = y(t.isOpen);
  function o() {
    a.value = !1;
  }
  function r() {
    a.value = !0, e();
  }
  function d() {
    t.disabled || t.openByHover || (a.value = !a.value);
  }
  return R(a, (c) => s(c ? "focus" : "blur", c)), R(
    () => t.isOpen,
    (c) => {
      a.value = c;
    }
  ), {
    isDropdownVisible: a,
    hideDropdown: o,
    showDropdown: r,
    handleActivator: d
  };
}
function $u(n) {
  const {
    containerRef: e,
    activatorRef: s,
    dropdownRef: t,
    isDropdownVisible: a,
    hideDropdown: o,
    showDropdown: r,
    emit: d,
    props: c
  } = n, u = y(!1);
  function i(g) {
    g ? r() : o();
  }
  function _(g) {
    c.disabled || (clearTimeout(u.value), u.value = setTimeout(() => {
      i(g);
    }, 50));
  }
  function f(g) {
    c.openByHover && _(!0), d("mouseenter", g);
  }
  function p(g) {
    c.openByHover && _(!1), d("mouseleave", g);
  }
  function m() {
    c.closeOnClickContent && o();
  }
  function v(g) {
    g.preventDefault(), o();
  }
  function I(g) {
    var T;
    a.value && !((T = e.value) != null && T.contains(g == null ? void 0 : g.target)) && o();
  }
  return Qo(t, () => c.closeOnClickOutside && I(), {
    ignore: [s]
  }), R(
    () => c.disabled,
    (g) => {
      g && o();
    }
  ), R(
    () => c.allowShortcut,
    (g) => {
      g && er("Escape", v, { dedupe: !0 });
    },
    { immediate: !0 }
  ), {
    setDropdownDelay: _,
    handleCloseDropdown: I,
    hideOnClickAtDropdown: m,
    mouseEnterHandler: f,
    mouseLeaveHandler: p
  };
}
const Iu = "_fadeEnterActive_1dj0y_17", xu = "_fadeIn_1dj0y_1", Tu = "_fadeLeaveActive_1dj0y_21", Su = "_fadeOut_1dj0y_1", Pu = "_XDropdownContainer_1dj0y_25", Cu = "_isFullWidth_1dj0y_28", wu = "_activator_1dj0y_31", Bu = "_dropdown_1dj0y_39", ku = "_arrow_1dj0y_39", Lu = "_arrowShape_1dj0y_47", Du = "_top_1dj0y_51", Mu = "_bottom_1dj0y_67", Au = "_left_1dj0y_83", Ou = "_right_1dj0y_99", Fu = {
  fadeEnterActive: Iu,
  fadeIn: xu,
  fadeLeaveActive: Tu,
  fadeOut: Su,
  XDropdownContainer: Pu,
  isFullWidth: Cu,
  activator: wu,
  dropdown: Bu,
  arrow: ku,
  arrowShape: Lu,
  top: Du,
  "top-start": "_top-start_1dj0y_54",
  "top-end": "_top-end_1dj0y_57",
  bottom: Mu,
  "bottom-start": "_bottom-start_1dj0y_70",
  "bottom-end": "_bottom-end_1dj0y_73",
  left: Au,
  "left-start": "_left-start_1dj0y_86",
  "left-end": "_left-end_1dj0y_89",
  right: Ou,
  "right-start": "_right-start_1dj0y_102",
  "right-end": "_right-end_1dj0y_105"
}, { createFullWidthProp: os, getFullWidthClass: rs } = Q(), { createPlacementProp: ls } = Ie(), { createDisabledProp: is } = q(), { createTestIdProp: cs, setupTestId: ds } = S(), Eu = {
  name: "XDropdown",
  inheritAttrs: !0
}, Ru = /* @__PURE__ */ Object.assign(Eu, {
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    offset: {
      type: Number,
      default: 0
    },
    innerDropdown: {
      type: Boolean,
      default: !1
    },
    openByHover: {
      type: Boolean,
      default: !1
    },
    closeOnClickContent: {
      type: Boolean,
      default: !0
    },
    closeOnClickOutside: {
      type: Boolean,
      default: !0
    },
    allowShortcut: {
      type: Boolean,
      default: !1
    },
    showArrow: {
      type: Boolean,
      default: !1
    },
    arrowColor: {
      type: String,
      default: "var(--color-neutral-0)"
    },
    dropdownClasses: {
      type: Array,
      default: () => []
    },
    disableTrasition: {
      type: Boolean,
      default: !1
    },
    ...os(),
    ...ls(),
    ...is(),
    ...cs()
  },
  emits: [
    "focus",
    "blur",
    "mouseenter",
    "mouseleave",
    "after:open",
    "after:close"
  ],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = ds(s), { fullWidthClass: a } = rs(s), { activePlacement: o, placementsPriorityOrder: r, setPlacement: d } = gu(s), { containerRef: c, activatorRef: u, dropdownRef: i, arrowRef: _, arrowStyles: f, updateDropdown: p } = yu({
      activePlacement: o,
      placementsPriorityOrder: r,
      setPlacement: d,
      props: s
    }), { isDropdownVisible: m, hideDropdown: v, showDropdown: I, handleActivator: g } = bu({
      updateDropdown: p,
      emit: e,
      props: s
    }), { handleCloseDropdown: T, hideOnClickAtDropdown: k, mouseEnterHandler: L, mouseLeaveHandler: O } = $u({
      containerRef: c,
      activatorRef: u,
      dropdownRef: i,
      isDropdownVisible: m,
      hideDropdown: v,
      showDropdown: I,
      emit: e,
      props: s
    });
    return { __sfc: !0, createFullWidthProp: os, getFullWidthClass: rs, createPlacementProp: ls, createDisabledProp: is, createTestIdProp: cs, setupTestId: ds, props: s, emit: e, formatTestId: t, fullWidthClass: a, activePlacement: o, placementsPriorityOrder: r, setPlacement: d, containerRef: c, activatorRef: u, dropdownRef: i, arrowRef: _, arrowStyles: f, updateDropdown: p, isDropdownVisible: m, hideDropdown: v, showDropdown: I, handleActivator: g, handleCloseDropdown: T, hideOnClickAtDropdown: k, mouseEnterHandler: L, mouseLeaveHandler: O };
  }
});
var Nu = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { ref: "containerRef", class: [e.$style.XDropdownContainer, t.fullWidthClass], attrs: { "data-testid": t.formatTestId() } }, [s("div", { ref: "activatorRef", class: e.$style.activator, attrs: { "aria-disabled": e.disabled, "data-testid": t.formatTestId("activator") }, on: { mouseenter: t.mouseEnterHandler, mouseleave: t.mouseLeaveHandler } }, [e._t("activator", null, { on: t.handleActivator, isVisible: t.isDropdownVisible })], 2), s("div", { directives: [{ name: "show", rawName: "v-show", value: t.isDropdownVisible, expression: "isDropdownVisible" }], ref: "dropdownRef", class: [e.$style.dropdown, ...e.dropdownClasses], attrs: { "data-testid": t.formatTestId("content"), "data-placement": t.activePlacement }, on: { click: t.hideOnClickAtDropdown, mouseenter: t.mouseEnterHandler, mouseleave: t.mouseLeaveHandler } }, [s("transition", { attrs: { name: "fade", "enter-active-class": e.$style.fadeEnterActive, "leave-active-class": e.$style.fadeLeaveActive, css: !e.disableTrasition }, on: { "after-enter": function(a) {
    return e.$emit("after:open", t.isDropdownVisible);
  }, "after-leave": function(a) {
    return e.$emit("after:close", t.isDropdownVisible);
  } } }, [t.isDropdownVisible ? s("div", [e.showArrow ? s("div", { ref: "arrowRef", class: [e.$style.arrow, e.$style[t.activePlacement]], attrs: { "data-testid": t.formatTestId("arrow") } }, [s("div", { class: e.$style.arrowShape, style: t.arrowStyles, attrs: { "data-testid": t.formatTestId("arrowShape") } })]) : e._e(), e._t("default", null, { close: t.handleCloseDropdown, isVisible: t.isDropdownVisible })], 2) : e._e()])], 1)]);
}, Xu = [];
const us = {
  $style: Fu
};
function Vu(n) {
  for (var e in us)
    this[e] = us[e];
}
var zu = /* @__PURE__ */ x(
  Ru,
  Nu,
  Xu,
  !1,
  Vu
);
const de = zu.exports, { createDisabledProp: ju } = q(), { createTestIdProp: qu } = S(), { createVModelProp: Hu } = se(), { createItemsCustomKeysProps: Wu, getItemsWithDefaultKeys: Ku } = rt(), Te = {
  items: {
    type: Array,
    default: () => []
  },
  name: {
    type: String,
    default: ""
  },
  value: {
    type: [String, Number, Boolean, Array, Object],
    default: ""
  },
  directionRow: {
    type: Boolean,
    default: !1
  },
  labelFirst: {
    type: Boolean,
    default: !1
  },
  errorMessage: {
    type: String,
    default: ""
  },
  preventFocus: {
    type: Boolean,
    default: !1
  },
  disableForm: {
    type: Boolean,
    default: !1
  },
  checked: {
    type: [String, Number, Boolean, Array, Object],
    default: !1
  },
  ...ju(),
  ...Hu([Boolean, Array, String], !1),
  ...qu(),
  ...Wu()
}, ct = {
  type: {
    type: String,
    default: "checkbox",
    validator: (n) => /^$|checkbox|radio|switch/.test(n)
  }
}, Z = ["change", "update:modelValue"], me = Yo ? Z[1] : Z[0], dt = Yo ? "modelValue" : "checked", Se = {
  prop: "checked",
  event: "change"
}, Uu = "_contentBox_1xvbe_1", Gu = {
  contentBox: Uu
}, Zu = {
  name: "ContentBox",
  inheritAttrs: !0
}, Yu = /* @__PURE__ */ Object.assign(Zu, {
  setup(n) {
    return { __sfc: !0 };
  }
});
var Ju = function() {
  var e = this, s = e._self._c;
  return e._self._setupProxy, s("div", { class: e.$style.contentBox }, [e._t("default")], 2);
}, Qu = [];
const _s = {
  $style: Gu
};
function e_(n) {
  for (var e in _s)
    this[e] = _s[e];
}
var t_ = /* @__PURE__ */ x(
  Yu,
  Ju,
  Qu,
  !1,
  e_
);
const ut = t_.exports, s_ = "_closeButton_1rypo_1", n_ = {
  closeButton: s_
}, { createTestIdProp: ps, setupTestId: fs } = S(), a_ = {
  name: "CloseButton",
  inheritAttrs: !0
}, o_ = /* @__PURE__ */ Object.assign(a_, {
  props: {
    ...ps()
  },
  emits: ["close"],
  setup(n) {
    const e = n, { t: s } = W(), { formatTestId: t } = fs(e);
    return { __sfc: !0, createTestIdProp: ps, setupTestId: fs, props: e, t: s, formatTestId: t, XIcon: B };
  }
});
var r_ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("button", { class: e.$style.closeButton, attrs: { "data-testid": t.formatTestId("tooltipCloseButton"), title: t.t("ds.xTooltip.actions.close") }, on: { click: function(a) {
    return e.$emit("close");
  } } }, [s(t.XIcon, { attrs: { icon: "close", size: "lg" } })], 1);
}, l_ = [];
const ms = {
  $style: n_
};
function i_(n) {
  for (var e in ms)
    this[e] = ms[e];
}
var c_ = /* @__PURE__ */ x(
  o_,
  r_,
  l_,
  !1,
  i_
);
const je = c_.exports, d_ = "_basicContentBox_1ysrg_1", u_ = "_hasCloseButton_1ysrg_10", __ = {
  basicContentBox: d_,
  hasCloseButton: u_
}, p_ = {
  name: "BasicContent",
  components: { ContentBox: ut },
  inheritAttrs: !0
}, f_ = /* @__PURE__ */ Object.assign(p_, {
  props: {
    closeButton: {
      type: Boolean,
      default: !1
    },
    dataTestid: {
      type: String,
      default: ""
    }
  },
  emits: [...je.emits],
  setup(n) {
    return { __sfc: !0, ContentBox: ut, CloseButton: je };
  }
});
var m_ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.ContentBox, { class: [e.$style.basicContentBox, e.closeButton && e.$style.hasCloseButton] }, [e._t("default"), e.closeButton ? s(t.CloseButton, { attrs: { "data-testid": e.dataTestid }, on: { close: function(a) {
    return e.$emit("close");
  } } }) : e._e()], 2);
}, v_ = [];
const vs = {
  $style: __
};
function g_(n) {
  for (var e in vs)
    this[e] = vs[e];
}
var h_ = /* @__PURE__ */ x(
  f_,
  m_,
  v_,
  !1,
  g_
);
const y_ = h_.exports, b_ = "_advancedContentBox_2z3oe_1", $_ = "_header_2z3oe_10", I_ = "_title_2z3oe_16", x_ = "_image_2z3oe_24", T_ = "_text_2z3oe_28", S_ = "_actions_2z3oe_33", P_ = {
  advancedContentBox: b_,
  header: $_,
  title: I_,
  image: x_,
  text: T_,
  actions: S_
}, { createTestIdProp: gs, setupTestId: hs } = S(), C_ = {
  name: "AdvancedContent",
  inheritAttrs: !0
}, w_ = /* @__PURE__ */ Object.assign(C_, {
  props: {
    title: {
      type: String,
      default: ""
    },
    imageSrc: {
      type: String,
      default: ""
    },
    imageAlt: {
      type: String,
      default: ""
    },
    closeButton: {
      type: Boolean,
      default: !1
    },
    ...gs()
  },
  emits: [...je.emits],
  setup(n) {
    const e = n, s = ve(), { formatTestId: t } = hs(e);
    return { __sfc: !0, createTestIdProp: gs, setupTestId: hs, slots: s, props: e, formatTestId: t, ContentBox: ut, CloseButton: je };
  }
});
var B_ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.ContentBox, { class: e.$style.advancedContentBox }, [s("div", { class: e.$style.header }, [s("h5", { class: e.$style.title }, [e._v(" " + e._s(e.title) + " ")]), e.closeButton ? s(t.CloseButton, { attrs: { "data-testid": e.dataTestid }, on: { close: function(a) {
    return e.$emit("close");
  } } }) : e._e()], 1), e.imageSrc ? s("img", { class: e.$style.image, attrs: { src: e.imageSrc, alt: e.imageAlt, "data-testid": t.formatTestId("tooltipImage") } }) : e._e(), s("div", { class: e.$style.text }, [e._t("default")], 2), t.slots.actions ? s("div", { class: e.$style.actions, attrs: { "data-testid": t.formatTestId("tooltipActions") } }, [e._t("actions")], 2) : e._e()]);
}, k_ = [];
const ys = {
  $style: P_
};
function L_(n) {
  for (var e in ys)
    this[e] = ys[e];
}
var D_ = /* @__PURE__ */ x(
  w_,
  B_,
  k_,
  !1,
  L_
);
const ur = D_.exports, M_ = "_xTooltip_1dfkh_1", A_ = "_xTooltipActivator_1dfkh_5", O_ = "_activatorIcon_1dfkh_8", F_ = {
  xTooltip: M_,
  xTooltipActivator: A_,
  activatorIcon: O_
}, { createDisabledProp: bs } = q(), { createPlacementProp: $s } = Ie(), { createTestIdProp: Is } = S(), E_ = {
  name: "XTooltip",
  components: { BasicContent: y_, AdvancedContent: ur },
  inheritAttrs: !0
}, R_ = /* @__PURE__ */ Object.assign(E_, {
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    advanced: {
      type: Boolean,
      default: !1
    },
    openByHover: {
      type: Boolean,
      default: !0
    },
    ...$s(),
    ...bs(),
    ...Is(),
    ...ur.props
  },
  setup(n) {
    const e = n, s = ve();
    function t() {
      return {
        isOpenByHover: l(() => e.closeButton ? !1 : e.openByHover)
      };
    }
    function a() {
      const { closeButton: i, dataTestid: _ } = e;
      return {
        closeButton: i,
        dataTestid: _
      };
    }
    function o() {
      const { title: i, imageSrc: _, imageAlt: f } = e;
      return {
        title: i,
        imageSrc: _,
        imageAlt: f,
        ...a()
      };
    }
    const r = l(() => e.advanced ? o() : a()), d = l(() => e.advanced ? "AdvancedContent" : "BasicContent"), c = l(() => !e.closeButton), { isOpenByHover: u } = t();
    return { __sfc: !0, createDisabledProp: bs, createPlacementProp: $s, createTestIdProp: Is, slots: s, props: e, useAdvancedContent: t, getBasicContentProps: a, getAdvancedContentProps: o, contentProps: r, contentType: d, closeOnClickOutside: c, isOpenByHover: u, XDropdown: de, XIcon: B };
  }
});
var N_ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XDropdown, { class: e.$style.xTooltip, attrs: { "is-open": e.isOpen, "open-by-hover": t.isOpenByHover, "close-on-click-content": !1, "close-on-click-outside": t.closeOnClickOutside, "show-arrow": "", "arrow-color": "var(--color-neutral-900)", disabled: e.disabled, placement: e.placement, "data-testid": e.dataTestid }, scopedSlots: e._u([{ key: "activator", fn: function({ isVisible: a, on: o }) {
    return [s("div", { class: e.$style.xTooltipActivator, attrs: { "aria-disabled": e.disabled }, on: { click: o } }, [e._t("activator", function() {
      return [s(t.XIcon, { class: e.$style.activatorIcon, attrs: { icon: "question-circle" } })];
    }, { isVisible: a })], 2)];
  } }, { key: "default", fn: function({ close: a }) {
    return [s(t.contentType, e._b({ tag: "component", on: { close: a }, scopedSlots: e._u([e._l(t.slots, function(o, r) {
      return { key: r, fn: function() {
        return [e._t(r)];
      }, proxy: !0 };
    })], null, !0) }, "component", t.contentProps, !1))];
  } }], null, !0) });
}, X_ = [];
const xs = {
  $style: F_
};
function V_(n) {
  for (var e in xs)
    this[e] = xs[e];
}
var z_ = /* @__PURE__ */ x(
  R_,
  N_,
  X_,
  !1,
  V_
);
const Oe = z_.exports, j_ = "_message_1mk9j_1", q_ = "_error_1mk9j_6", H_ = "_info_1mk9j_9", W_ = "_warning_1mk9j_12", K_ = "_success_1mk9j_15", U_ = "_messageText_1mk9j_18", G_ = {
  message: j_,
  error: q_,
  info: H_,
  warning: W_,
  success: K_,
  messageText: U_
}, { createMessageProps: Ts } = ge(), { createTestIdProp: Ss, setupTestId: Ps } = S(), Z_ = {
  name: "SingleMessage",
  components: {
    XIcon: B
  }
}, Y_ = /* @__PURE__ */ Object.assign(Z_, {
  props: {
    ...Ts(),
    ...Ss()
  },
  setup(n) {
    const e = n, s = {
      error: "xmark-large",
      warning: "triangle-exclamation",
      success: "circle-check",
      info: "circle-exclamation"
    }, t = D(), { formatTestId: a } = Ps(e), o = l(() => ({
      [t[e.messageType]]: !0
    })), r = l(() => s[e.messageType]);
    return { __sfc: !0, createMessageProps: Ts, createTestIdProp: Ss, setupTestId: Ps, props: e, messageIcons: s, $style: t, formatTestId: a, messageTypeClass: o, messageIconName: r, XIcon: B };
  }
});
var J_ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { directives: [{ name: "show", rawName: "v-show", value: e.message, expression: "message" }], class: [t.$style.message, t.messageTypeClass], attrs: { "aria-live": "polite", "data-testid": t.formatTestId() } }, [s(t.XIcon, { attrs: { icon: t.messageIconName, "fixed-width": "", "data-testid": t.formatTestId("icon") } }), s("small", { class: t.$style.messageText }, [e._v(" " + e._s(e.message) + " ")])], 1);
}, Q_ = [];
const Cs = {
  $style: G_
};
function ep(n) {
  for (var e in Cs)
    this[e] = Cs[e];
}
var tp = /* @__PURE__ */ x(
  Y_,
  J_,
  Q_,
  !1,
  ep
);
const _r = tp.exports, sp = "_MessagesContainer_bfgjf_1", np = {
  MessagesContainer: sp
}, { MESSAGE_TYPES: Be, createMessageProps: ws, createAdditionalMessagesProp: Bs } = ge(), { createTestIdProp: ks, setupTestId: Ls } = S(), { createValidationsProp: Ds, setupValidations: Ms } = Me(), ap = {
  name: "MessagesContainer",
  components: {
    SingleMessage: _r
  }
}, op = /* @__PURE__ */ Object.assign(ap, {
  props: {
    ...Ds(),
    ...Bs(),
    ...ks(),
    ...ws()
  },
  emits: [Be.error],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = Ls(s), a = l(() => s.validations), { validationError: o } = Ms(a), r = l(() => s.message || o.value), d = l(() => r.value || s.additionalMessages.length > 0), c = l(
      () => !!s.additionalMessages.find((i) => i.type === Be.error || !(i != null && i.type))
    ), u = l(
      () => s.message && s.messageType === Be.error || c.value || !!o.value
    );
    return R(
      () => u.value,
      () => {
        e(Be.error, u.value);
      },
      { immediate: !0 }
    ), { __sfc: !0, MESSAGE_TYPES: Be, createMessageProps: ws, createAdditionalMessagesProp: Bs, createTestIdProp: ks, setupTestId: Ls, createValidationsProp: Ds, setupValidations: Ms, props: s, emit: e, formatTestId: t, computedValidations: a, validationError: o, computedMessage: r, hasMessage: d, hasErrorAtAdditionalMessages: c, hasError: u, SingleMessage: _r };
  }
});
var rp = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { directives: [{ name: "show", rawName: "v-show", value: t.hasMessage, expression: "hasMessage" }], class: e.$style.MessagesContainer }, [s(t.SingleMessage, { attrs: { message: t.computedMessage, "message-type": e.messageType, "data-testid": t.formatTestId("message") } }), e._l(e.additionalMessages, function(a, o) {
    return s(t.SingleMessage, { key: a.message, attrs: { message: a.message, "message-type": a.type || t.MESSAGE_TYPES.error, "data-testid": t.formatTestId(`message_${o}`) } });
  })], 2);
}, lp = [];
const As = {
  $style: np
};
function ip(n) {
  for (var e in As)
    this[e] = As[e];
}
var cp = /* @__PURE__ */ x(
  op,
  rp,
  lp,
  !1,
  ip
);
const pr = cp.exports;
function dp(n) {
  const { props: e, contentRef: s } = n, t = y(!1), a = l(() => e.focusable && e.grouped && !e.disabled);
  function o() {
    a.value && (t.value = !0);
  }
  function r() {
    a.value && (t.value = !1);
  }
  return Qo(s, r), {
    setFocus: o,
    isFieldFocused: t
  };
}
const { getFullWidthClass: up } = Q();
function _p(n) {
  const { props: e, isFieldFocused: s } = n, t = D(), a = l(() => ({
    [t.hasFocus]: s.value
  })), o = l(() => ({
    [t.isFlexible]: e.flexible
  })), r = l(() => ({
    [t.isGrouped]: e.grouped
  })), d = l(() => ({
    [t[e.messageType]]: e.message
  })), { fullWidthClass: c } = up(e), u = l(() => ({
    ...c.value,
    ...d.value
  })), i = l(() => ({
    ...a.value,
    ...r.value,
    ...d.value,
    ...o.value
  }));
  return {
    fieldClasses: u,
    contentClasses: i
  };
}
const pp = "_XFormField_vih9i_1", fp = "_header_vih9i_9", mp = "_label_vih9i_17", vp = "_requiredIndicator_vih9i_25", gp = "_helpLink_vih9i_31", hp = "_helpTooltip_vih9i_32", yp = "_content_vih9i_36", bp = "_isFlexible_vih9i_48", $p = "_isGrouped_vih9i_51", Ip = "_hasFocus_vih9i_93", xp = "_error_vih9i_99", Tp = "_isFullWidth_vih9i_102", Sp = {
  XFormField: pp,
  header: fp,
  label: mp,
  requiredIndicator: vp,
  helpLink: gp,
  helpTooltip: hp,
  content: yp,
  isFlexible: bp,
  isGrouped: $p,
  hasFocus: Ip,
  error: xp,
  isFullWidth: Tp
}, { createFullWidthProp: Os } = Q(), { createDisabledProp: Fs } = q(), { createTestIdProp: Es, setupTestId: Rs } = S(), { createValidationsProp: Ns } = Me(), {
  createMessageProps: Xs,
  createAdditionalMessagesProp: Vs,
  createLabelProps: zs,
  createFormFieldProps: js,
  createRequiredProp: qs
} = ge(), Pp = {
  name: "XFormField",
  components: {
    XTooltip: Oe,
    XLink: ne,
    MessagesContainer: pr
  }
}, Cp = /* @__PURE__ */ Object.assign(Pp, {
  props: {
    ...qs(),
    ...zs(),
    ...js(),
    ...Ns(),
    ...Vs(),
    ...Xs(),
    ...Fs(),
    ...Os(),
    ...Es()
  },
  emits: ["error"],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = Rs(s), a = y(null), o = fe("field-"), r = fe("label-"), { setFocus: d, isFieldFocused: c } = dp({
      props: s,
      contentRef: a
    }), { fieldClasses: u, contentClasses: i } = _p({
      props: s,
      isFieldFocused: c
    });
    function _() {
      return s.label || s.helpLink || s.helpTooltip;
    }
    return { __sfc: !0, createFullWidthProp: Os, createDisabledProp: Fs, createTestIdProp: Es, setupTestId: Rs, createValidationsProp: Ns, createMessageProps: Xs, createAdditionalMessagesProp: Vs, createLabelProps: zs, createFormFieldProps: js, createRequiredProp: qs, props: s, emit: e, formatTestId: t, contentRef: a, uuid: o, labelId: r, setFocus: d, isFieldFocused: c, fieldClasses: u, contentClasses: i, canShowHeader: _, XLink: ne, XTooltip: Oe, MessagesContainer: pr };
  }
});
var wp = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: [e.$style.XFormField, t.fieldClasses], attrs: { "data-testid": t.formatTestId() } }, [t.canShowHeader() ? s("div", { class: e.$style.header, attrs: { "data-testid": t.formatTestId("header") } }, [e.label ? s("label", { class: e.$style.label, attrs: { id: t.labelId, for: t.uuid, "data-testid": t.formatTestId("label") } }, [e._v(" " + e._s(e.label) + " ")]) : e._e(), e.required ? s("span", { class: e.$style.requiredIndicator, attrs: { "data-testid": t.formatTestId("required") } }, [e._v(" * ")]) : e._e(), e.helpLink ? s(t.XLink, { class: e.$style.helpLink, attrs: { to: e.helpLink, icon: "question-circle", target: "_blank", "no-padding": "", "data-testid": t.formatTestId("helpLink") } }) : e._e(), e.helpTooltip ? s(t.XTooltip, { class: e.$style.helpTooltip, attrs: { "data-testid": t.formatTestId("tooltip") } }, [e._v(" " + e._s(e.helpTooltip) + " ")]) : e._e()], 1) : e._e(), s("fieldset", { ref: "contentRef", class: [e.$style.content, t.contentClasses], attrs: { tabindex: "-1", disabled: e.disabled, "data-testid": t.formatTestId("content") }, on: { click: function(a) {
    return t.setFocus();
  } } }, [e._t("default", null, { uuid: t.uuid, labelId: t.labelId })], 2), s(t.MessagesContainer, { attrs: { message: e.message, "message-type": e.messageType, "additional-messages": e.additionalMessages, validations: e.validations, "data-testid": e.dataTestid }, on: { error: function(a) {
    return t.emit("error", a);
  } } })], 1);
}, Bp = [];
const Hs = {
  $style: Sp
};
function kp(n) {
  for (var e in Hs)
    this[e] = Hs[e];
}
var Lp = /* @__PURE__ */ x(
  Cp,
  wp,
  Bp,
  !1,
  kp
);
const ee = Lp.exports, Dp = "_BaseOption_hgop1_1", Mp = "_BaseOptionInput_hgop1_8", Ap = "_isCheckbox_hgop1_8", Op = "_BaseOptionLabel_hgop1_8", Fp = "_BaseOptionBox_hgop1_11", Ep = "_isDisabled_hgop1_43", Rp = "_BaseOptionText_hgop1_81", Np = "_isSwitch_hgop1_84", Xp = "_isRadio_hgop1_144", Vp = "_isLabelFirst_hgop1_207", zp = {
  BaseOption: Dp,
  BaseOptionInput: Mp,
  isCheckbox: Ap,
  BaseOptionLabel: Op,
  BaseOptionBox: Fp,
  isDisabled: Ep,
  BaseOptionText: Rp,
  isSwitch: Np,
  isRadio: Xp,
  isLabelFirst: Vp
}, { setupTestId: Ws } = S(), { setupVModel: Ks } = se(), jp = {
  name: "SingleInput",
  inheritAttrs: !1,
  model: Se
}, qp = /* @__PURE__ */ Object.assign(jp, {
  props: {
    ...ct,
    ...Te
  },
  emits: Z,
  setup(n, { emit: e }) {
    const s = n, t = ve(), a = D(), o = fe("input"), r = fe("label"), { formatTestId: d } = Ws(s), { data: c } = Ks(s, e), u = l(() => ({
      [a.isRadio]: s.type === "radio",
      [a.isSwitch]: s.type === "switch",
      [a.isCheckbox]: s.type === "checkbox"
    })), i = l(() => ({
      [a.isLabelFirst]: s.labelFirst
    })), _ = l(() => s.type === "radio" ? "radio" : "checkbox"), f = l(() => {
      var v, I, g;
      if (!(t != null && t.default) || ((v = t == null ? void 0 : t.default()) == null ? void 0 : v.length) === 0) return !1;
      const m = t.default()[0];
      return J ? !!((I = String(m.text)) != null && I.replace(/\s+/g, "")) : !!((g = String(m.children)) != null && g.replace(/\s+/g, ""));
    }), { v2Listeners: p } = U(["change"]);
    return { __sfc: !0, setupTestId: Ws, setupVModel: Ks, props: s, emit: e, slots: t, $style: a, uidInput: o, uidLabel: r, formatTestId: d, checkedValues: c, typeClass: u, directionClass: i, inputType: _, hasContent: f, v2Listeners: p };
  }
});
var Hp = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: t.$style.BaseOption }, [t.inputType === "checkbox" ? s("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: t.checkedValues, expression: "checkedValues" }], class: [t.$style.BaseOptionInput, t.typeClass], attrs: { id: t.uidInput, disabled: e.disabled, "data-testid": t.formatTestId("input"), "aria-labelledby": t.uidLabel, name: e.name, tabindex: e.preventFocus ? -1 : 0, type: "checkbox" }, domProps: { value: e.value, checked: Array.isArray(t.checkedValues) ? e._i(t.checkedValues, e.value) > -1 : t.checkedValues }, on: { change: function(a) {
    var o = t.checkedValues, r = a.target, d = !!r.checked;
    if (Array.isArray(o)) {
      var c = e.value, u = e._i(o, c);
      r.checked ? u < 0 && (t.checkedValues = o.concat([c])) : u > -1 && (t.checkedValues = o.slice(0, u).concat(o.slice(u + 1)));
    } else
      t.checkedValues = d;
  } } }, "input", e.$attrs, !1), t.v2Listeners)) : t.inputType === "radio" ? s("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: t.checkedValues, expression: "checkedValues" }], class: [t.$style.BaseOptionInput, t.typeClass], attrs: { id: t.uidInput, disabled: e.disabled, "data-testid": t.formatTestId("input"), "aria-labelledby": t.uidLabel, name: e.name, tabindex: e.preventFocus ? -1 : 0, type: "radio" }, domProps: { value: e.value, checked: e._q(t.checkedValues, e.value) }, on: { change: function(a) {
    t.checkedValues = e.value;
  } } }, "input", e.$attrs, !1), t.v2Listeners)) : s("input", e._g(e._b({ directives: [{ name: "model", rawName: "v-model", value: t.checkedValues, expression: "checkedValues" }], class: [t.$style.BaseOptionInput, t.typeClass], attrs: { id: t.uidInput, disabled: e.disabled, "data-testid": t.formatTestId("input"), "aria-labelledby": t.uidLabel, name: e.name, tabindex: e.preventFocus ? -1 : 0, type: t.inputType }, domProps: { value: e.value, value: t.checkedValues }, on: { input: function(a) {
    a.target.composing || (t.checkedValues = a.target.value);
  } } }, "input", e.$attrs, !1), t.v2Listeners)), s("label", { class: [t.$style.BaseOptionLabel, t.directionClass], attrs: { id: t.uidLabel, for: t.uidInput, "aria-hidden": "true", "data-testid": t.formatTestId() } }, [s("div", { class: t.$style.BaseOptionBox }), t.hasContent ? s("span", { class: t.$style.BaseOptionText, attrs: { "data-testid": t.formatTestId("label") } }, [e._t("default")], 2) : e._e()])]);
}, Wp = [];
const Us = {
  $style: zp
};
function Kp(n) {
  for (var e in Us)
    this[e] = Us[e];
}
var Up = /* @__PURE__ */ x(
  qp,
  Hp,
  Wp,
  !1,
  Kp
);
const _t = Up.exports, Gp = "_BaseOptionFieldset_dfstq_1", Zp = "_container_dfstq_9", Yp = "_isDirectionRow_dfstq_14", Jp = "_BaseOptionFieldsetLegend_dfstq_18", Qp = "_isEmpty_dfstq_24", ef = {
  BaseOptionFieldset: Gp,
  container: Zp,
  isDirectionRow: Yp,
  BaseOptionFieldsetLegend: Jp,
  isEmpty: Qp
}, { setupTestId: Gs } = S(), tf = {
  name: "MultipleInputs",
  components: { SingleInput: _t },
  inheritAttrs: !1
}, sf = /* @__PURE__ */ Object.assign(tf, {
  props: {
    ...Te,
    ...ct
  },
  emits: Z,
  setup(n) {
    const e = n, s = D(), { formatTestId: t } = Gs(e), { v2Listeners: a } = U(["change"]), { computedItems: o } = Ku(e), r = y(null), d = e.checked || e.modelValue || e.value, c = y(d || []), u = l(() => ({
      [s.isDirectionRow]: e.directionRow
    }));
    function i(p) {
      return e.disabled || p.disabled;
    }
    function _(p) {
      return (p == null ? void 0 : p.dataTestid) || e.dataTestid;
    }
    const f = l(() => {
      var p;
      return !!((p = r.value) != null && p.textContent);
    });
    return { __sfc: !0, setupTestId: Gs, props: e, $style: s, formatTestId: t, v2Listeners: a, computedItems: o, fieldsetLegend: r, initialValue: d, currentValue: c, directionClass: u, isDisabled: i, getDataTestId: _, legendIsEmpty: f, SingleInput: _t, changeEvent: me };
  }
});
var nf = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("fieldset", { class: t.$style.BaseOptionFieldset, attrs: { disabled: e.disabled, "data-testid": t.formatTestId("fieldset") } }, [s("legend", { ref: "fieldsetLegend", class: [t.$style.BaseOptionFieldsetLegend, !t.legendIsEmpty && t.$style.isEmpty], attrs: { "data-testid": t.formatTestId("FieldsetLegend") } }, [e._t("default")], 2), s("div", { class: [t.$style.container, t.directionClass], attrs: { "data-testid": t.formatTestId("fieldsetContainer") } }, e._l(t.computedItems, function(a) {
    return s(t.SingleInput, e._g(e._b({ key: `key-${a.value}-${t.currentValue}`, attrs: { type: e.type, name: e.name, value: a.value, "label-first": e.labelFirst, disabled: t.isDisabled(a), "data-testid": t.getDataTestId(a) }, on: e._d({}, [t.changeEvent, (o) => e.$emit(t.changeEvent, o)]), model: { value: t.currentValue, callback: function(o) {
      t.currentValue = o;
    }, expression: "currentValue" } }, "SingleInput", e.$attrs, !1), t.v2Listeners), [e._v(" " + e._s(a.text) + " ")]);
  }), 1)]);
}, af = [];
const Zs = {
  $style: ef
};
function of(n) {
  for (var e in Zs)
    this[e] = Zs[e];
}
var rf = /* @__PURE__ */ x(
  sf,
  nf,
  af,
  !1,
  of
);
const lf = rf.exports, cf = "_isFormDisabled_1ypk7_1", df = {
  isFormDisabled: cf
}, uf = {
  name: "BaseOption",
  components: { XFormField: ee, SingleInput: _t, MultipleInputs: lf }
}, _f = /* @__PURE__ */ Object.assign(uf, {
  props: {
    ...Te,
    ...ct
  },
  emits: Z,
  setup(n) {
    const e = n, s = l(() => e.items.length > 0), t = l(() => s.value ? "MultipleInputs" : "SingleInput"), a = l(() => e.disableForm ? "div" : "XFormField"), { v2Listeners: o } = U(["change"]);
    function r() {
      return `key-${e.dataTestid}-${e[dt]}`;
    }
    return { __sfc: !0, props: e, isMultiple: s, currentComponentName: t, containerTag: a, v2Listeners: o, getkey: r, changeEvent: me };
  }
});
var pf = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.containerTag, { tag: "component", class: e.disableForm && e.$style.isFormDisabled, attrs: { message: e.errorMessage } }, [s(t.currentComponentName, e._g(e._b({ key: t.getkey(), tag: "component", attrs: { type: e.type }, on: e._d({}, [t.changeEvent, (a) => e.$emit(t.changeEvent, a)]) }, "component", { ...e.$props, ...e.$attrs }, !1), t.v2Listeners), [e._t("default")], 2)], 1);
}, ff = [];
const Ys = {
  $style: df
};
function mf(n) {
  for (var e in Ys)
    this[e] = Ys[e];
}
var vf = /* @__PURE__ */ x(
  _f,
  pf,
  ff,
  !1,
  mf
);
const Pe = vf.exports, gf = {
  name: "XCheckbox",
  components: { BaseOption: Pe },
  model: Se
}, hf = /* @__PURE__ */ Object.assign(gf, {
  props: Te,
  emits: Z,
  setup(n) {
    const { v2Listeners: e } = U(["change"]);
    return { __sfc: !0, v2Listeners: e, BaseOption: Pe, changeEvent: me };
  }
});
var yf = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.BaseOption, e._g(e._b({ attrs: { type: "checkbox" }, on: e._d({}, [t.changeEvent, (a) => e.$emit(t.changeEvent, a)]) }, "BaseOption", { ...e.$props, ...e.$attrs }, !1), t.v2Listeners), [e._t("default")], 2);
}, bf = [], $f = /* @__PURE__ */ x(
  hf,
  yf,
  bf,
  !1,
  null
);
const Fe = $f.exports, If = "_xEllipsis_viutg_1", xf = "_isEnabled_viutg_1", Tf = "_oneLine_viutg_8", Sf = {
  xEllipsis: If,
  isEnabled: xf,
  oneLine: Tf
}, { createTestIdProp: Js, setupTestId: Qs } = S(), Pf = {
  name: "XEllipsis"
}, Cf = /* @__PURE__ */ Object.assign(Pf, {
  props: {
    hasEllipsis: {
      type: Boolean,
      default: !0
    },
    visibleLines: {
      type: Number,
      default: 1
    },
    maxLength: {
      type: Number,
      default: 0
    },
    ...Js()
  },
  setup(n) {
    const e = n, { formatTestId: s } = Qs(e), t = D(), a = y(null), o = y("");
    function r(f) {
      return f.substring(0, e.maxLength);
    }
    const d = l(() => e.maxLength ? {} : {
      webkitLineClamp: e.visibleLines
    }), c = l(() => ({
      [t.isEnabled]: e.hasEllipsis && !e.maxLength,
      [t.oneLine]: e.visibleLines === 1
    })), u = l(() => {
      var f;
      return e.maxLength && a.value ? `${r((f = a.value) == null ? void 0 : f.textContent)}...` : null;
    });
    function i() {
      var f;
      return (f = a.value) == null ? void 0 : f.textContent.replace(/\s+/g, "");
    }
    function _() {
      o.value = a.value.textContent;
    }
    return Le(() => {
      i() && _();
    }), { __sfc: !0, createTestIdProp: Js, setupTestId: Qs, props: e, formatTestId: s, $style: t, refContent: a, originalText: o, truncateText: r, customStyles: d, customClass: c, truncatedText: u, hasValidText: i, setOriginalText: _ };
  }
});
var wf = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { ref: "refContent", class: [t.$style.xEllipsis, t.customClass], style: t.customStyles, attrs: { "data-testid": t.formatTestId(), title: t.originalText } }, [t.truncatedText ? s("span", { attrs: { "aria-description": t.originalText, "data-testid": t.formatTestId("truncatedContainer") } }, [s("span", { attrs: { "aria-hidden": "true", "data-testid": t.formatTestId("truncatedText") } }, [e._v(e._s(t.truncatedText))])]) : e._t("default")], 2);
}, Bf = [];
const en = {
  $style: Sf
};
function kf(n) {
  for (var e in en)
    this[e] = en[e];
}
var Lf = /* @__PURE__ */ x(
  Cf,
  wf,
  Bf,
  !1,
  kf
);
const K = Lf.exports, Df = "_item_zb7t4_1", Mf = "_separator_zb7t4_27", Af = "_noClickable_zb7t4_30", Of = "_isDisabled_zb7t4_30", Ff = "_selected_zb7t4_42", Ef = "_data_zb7t4_46", Rf = "_text_zb7t4_65", Nf = "_badge_zb7t4_78", Xf = {
  item: Df,
  separator: Mf,
  noClickable: Af,
  isDisabled: Of,
  selected: Ff,
  data: Ef,
  text: Rf,
  badge: Nf
}, { createIconProps: tn } = ce(), { createHeightProps: sn, getHeightStyles: nn } = De(), { createDisabledProp: an, getDisabledClass: on } = q(), { createLinkProps: rn } = $e(), { createTestIdProp: ln, setupTestId: cn } = S(), dn = ["div", "li", "button", "a"], Vf = {
  name: "XListItem",
  components: {
    XCheckbox: Fe,
    XIcon: B,
    BaseLink: xe,
    XEllipsis: K
  }
}, zf = Object.assign(Vf, {
  props: {
    tag: {
      type: String,
      default: "div",
      validation: (n) => dn.includes(n)
    },
    active: {
      type: Boolean,
      default: !1
    },
    separator: {
      type: Boolean,
      default: !1
    },
    checkbox: {
      type: Boolean,
      default: !1
    },
    noClickable: {
      type: Boolean,
      default: !1
    },
    level: {
      type: Number,
      default: 0
    },
    ellipsis: {
      type: Boolean,
      default: !1
    },
    navigable: {
      type: Boolean,
      default: !1
    },
    ...sn({
      height: "40px"
    }),
    ...tn(),
    ...rn(),
    ...an(),
    ...ln()
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const s = n, t = D(), { v2Listeners: a } = U(["click"]), { formatTestId: o } = cn(s), { disabledClass: r } = on(s), { heightStyles: d } = nn(s), c = l(() => s.tag === "a"), u = l(() => c.value ? "BaseLink" : s.tag), i = l(() => ({
      paddingLeft: `${s.level * 1.6}rem`
    })), _ = l(() => s.navigable ? 0 : -1), f = l(() => ({
      [t.separator]: s.separator,
      [t.selected]: s.active,
      [t.noClickable]: s.noClickable,
      ...r.value
    })), p = l(() => ({
      [dt]: s.active
    }));
    function m(v) {
      if (s.disabled || s.noClickable || s.separator) {
        v.stopPropagation();
        return;
      }
      e("click", v);
    }
    return { __sfc: !0, createIconProps: tn, createHeightProps: sn, getHeightStyles: nn, createDisabledProp: an, getDisabledClass: on, createLinkProps: rn, createTestIdProp: ln, setupTestId: cn, VALID_TAGS: dn, props: s, emit: e, $style: t, v2Listeners: a, formatTestId: o, disabledClass: r, heightStyles: d, isLink: c, tagName: u, computedStyle: i, tabIndex: _, listItemClasses: f, listItemCheckboxProps: p, handleClick: m, XCheckbox: Fe, XIcon: B, XEllipsis: K };
  }
});
var jf = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.tagName, e._g({ tag: "component", class: [t.$style.item, t.listItemClasses], style: t.heightStyles, attrs: { "data-testid": e.dataTestid, tabindex: t.tabIndex, disabled: e.disabled, "aria-disabled": e.disabled, to: e.to, target: e.target, external: e.external }, on: { click: t.handleClick } }, t.v2Listeners), [e._t("content", function() {
    return [s("div", { class: t.$style.data, style: t.computedStyle }, [e.checkbox ? s("div", { on: { click: function(a) {
      a.preventDefault();
    } } }, [s(t.XCheckbox, e._b({ attrs: { "prevent-focus": !0, "disable-form": "", "data-testid": t.formatTestId("checkbox"), disabled: e.disabled } }, "XCheckbox", t.listItemCheckboxProps, !1))], 1) : e._e(), e.icon ? s(t.XIcon, { attrs: { icon: e.icon, "icon-style": e.iconStyle, "data-testid": t.formatTestId("icon") } }) : e._e(), s(t.XEllipsis, { class: t.$style.text, attrs: { "has-ellipsis": e.ellipsis } }, [e._t("default")], 2)], 1), e._t("badge", null, { badgeClass: t.$style.badge })];
  })], 2);
}, qf = [];
const un = {
  $style: Xf
};
function Hf(n) {
  for (var e in un)
    this[e] = un[e];
}
var Wf = /* @__PURE__ */ x(
  zf,
  jf,
  qf,
  !1,
  Hf
);
const oe = Wf.exports, Kf = "_xBreadcrumb_tbhga_1", Uf = "_xBreadcrumbChevron_tbhga_9", Gf = "_xBreadcrumbCol_tbhga_13", Zf = "_isMenuOpen_tbhga_20", Yf = "_xBreadcrumbMenuCol_tbhga_24", Jf = "_xBreadcrumbDropdown_tbhga_31", Qf = "_xBreadcrumbMenu_tbhga_24", em = "_xBreadcrumbMenuItem_tbhga_43", tm = "_xBreadcrumbPreviousTitle_tbhga_52", sm = "_xBreadcrumbPreviousTitleLink_tbhga_59", nm = "_xBreadcrumbPreviousTitleText_tbhga_65", am = "_xBreadcrumbCurrentTitle_tbhga_69", om = "_xBreadcrumbCurrentTitleText_tbhga_78", rm = {
  xBreadcrumb: Kf,
  xBreadcrumbChevron: Uf,
  xBreadcrumbCol: Gf,
  isMenuOpen: Zf,
  xBreadcrumbMenuCol: Yf,
  xBreadcrumbDropdown: Jf,
  xBreadcrumbMenu: Qf,
  xBreadcrumbMenuItem: em,
  xBreadcrumbPreviousTitle: tm,
  xBreadcrumbPreviousTitleLink: sm,
  xBreadcrumbPreviousTitleText: nm,
  xBreadcrumbCurrentTitle: am,
  xBreadcrumbCurrentTitleText: om
}, { createTestIdProp: _n, setupTestId: pn } = S(), lm = {
  name: "XBreadCrumb",
  components: {
    XIcon: B,
    XLink: ne,
    XDropdown: de,
    XListItem: oe,
    XButton: ae,
    XEllipsis: K
  }
}, im = /* @__PURE__ */ Object.assign(lm, {
  props: {
    paths: {
      type: Array,
      required: !0
    },
    ..._n()
  },
  setup(n) {
    const e = n, s = D(), { formatTestId: t } = pn(e), a = y(!1), { t: o } = W(), r = () => {
      a.value = !0;
    }, d = () => {
      a.value = !1;
    }, c = l(
      () => e.paths.map((m, v) => ({
        ...m,
        trimmedTitle: ti(m.name),
        level: v
      }))
    ), u = l(() => c.value.slice(0, -2)), i = l(() => c.value[c.value.length - 1]), _ = l(() => c.value[c.value.length - 2]), f = l(() => ({
      [s.isMenuOpen]: a.value
    }));
    function p() {
      var m;
      return ((m = u.value) == null ? void 0 : m.length) > 0;
    }
    return { __sfc: !0, createTestIdProp: _n, setupTestId: pn, props: e, $style: s, formatTestId: t, isMenuOpen: a, t: o, openMenu: r, closeMenu: d, computedPaths: c, dropdownPaths: u, currentPath: i, previousPath: _, activatorButtonClass: f, hasDropdownPaths: p, XIcon: B, XLink: ne, XButton: ae, XDropdown: de, XListItem: oe, XEllipsis: K };
  }
});
var cm = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: t.$style.xBreadcrumb, attrs: { "data-testid": t.formatTestId() } }, [s("div", { class: t.$style.xBreadcrumbCol }, [t.hasDropdownPaths() ? s("span", { class: t.$style.xBreadcrumbMenuCol, attrs: { "data-testid": t.formatTestId("dropdownContainer") } }, [s(t.XDropdown, { attrs: { placement: "bottom-start", "data-testid": t.formatTestId("dropdown"), "dropdown-classes": [t.$style.xBreadcrumbDropdown] }, on: { focus: t.openMenu, blur: t.closeMenu }, scopedSlots: e._u([{ key: "activator", fn: function({ on: a }) {
    return [s(t.XButton, { class: [t.activatorButtonClass], attrs: { "border-radius": "circle", size: "sm", design: "outlined", title: t.t("ds.XBreadCrumb.actions.openMenu"), "data-testid": t.formatTestId("menuButton") }, on: { click: a } }, [s(t.XIcon, { attrs: { "icon-style": "fas", icon: "ellipsis-h" } })], 1)];
  } }], null, !1, 1009363239) }, [s("ul", { class: t.$style.xBreadcrumbMenu, attrs: { "data-testid": t.formatTestId("menu") } }, e._l(t.dropdownPaths, function(a) {
    return s("li", { key: a.name }, [s(t.XLink, { class: t.$style.xBreadcrumbMenuItem, attrs: { to: a.to, title: a.name, size: "small", "no-underline": "", "data-testid": t.formatTestId(`dropdown-${a.name}-link`) } }, [s(t.XListItem, { attrs: { icon: a.icon, level: a.level } }, [e._v(" " + e._s(a.trimmedTitle) + " ")])], 1)], 1);
  }), 0)]), s(t.XIcon, { class: t.$style.xBreadcrumbChevron, attrs: { icon: "chevron-right", size: "xs" } })], 1) : e._e(), t.previousPath ? s("span", { class: t.$style.xBreadcrumbPreviousTitle, attrs: { "data-testid": t.formatTestId("previousPath") } }, [s(t.XLink, e._b({ class: t.$style.xBreadcrumbPreviousTitleLink, attrs: { title: t.previousPath.name, "data-testid": t.formatTestId("previousLink") } }, "XLink", t.previousPath, !1), [s(t.XEllipsis, { class: t.$style.xBreadcrumbPreviousTitleText }, [e._v(" " + e._s(t.previousPath.name) + " ")])], 1), s(t.XIcon, { class: t.$style.xBreadcrumbChevron, attrs: { icon: "chevron-right", size: "xs", "data-testid": t.formatTestId("previousIcon") } })], 1) : e._e()]), s("span", { class: t.$style.xBreadcrumbCurrentTitle, attrs: { "data-testid": t.formatTestId("currentPath") } }, [t.currentPath.icon ? s(t.XIcon, { class: t.$style.xBreadcrumbCurrentTitleIcon, attrs: { "icon-style": t.currentPath.iconStyle, icon: t.currentPath.icon, "data-testid": t.formatTestId("currentPathIcon") } }) : e._e(), s("h3", { class: t.$style.xBreadcrumbCurrentTitleText, attrs: { title: t.currentPath.name, "data-testid": t.formatTestId("currentTitle") } }, [s(t.XEllipsis, [e._v(" " + e._s(t.currentPath.name) + " ")])], 1)], 1)]);
}, dm = [];
const fn = {
  $style: rm
};
function um(n) {
  for (var e in fn)
    this[e] = fn[e];
}
var _m = /* @__PURE__ */ x(
  im,
  cm,
  dm,
  !1,
  um
);
const pm = _m.exports, fm = "_card_1egbd_1", mm = "_isOutlined_1egbd_11", vm = {
  card: fm,
  isOutlined: mm
}, mn = ["div", "section", "li", "button", "a"], { createElevationProp: vn, getElevationBoxShadow: gn } = ot(), { createLinkProps: hn, getLinkProps: yn } = $e(), { createDisabledProp: bn } = q(), { createTestIdProp: $n, setupTestId: In } = S(), gm = {
  name: "XCard",
  components: { BaseLink: xe }
}, hm = Object.assign(gm, {
  props: {
    tag: {
      type: String,
      default: "div",
      validation: (n) => mn.includes(n)
    },
    borderRadius: {
      type: String,
      default: "var(--border-radius-medium)"
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "var(--space-regular)"
    },
    ...vn(),
    ...hn(),
    ...bn(),
    ...$n()
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const s = n, t = D(), { boxShadow: a } = gn(s), { formatTestId: o } = In(s), { v2Listeners: r } = U(["click"]), d = l(() => s.tag === "a"), c = l(() => ({
      ...a.value,
      borderRadius: s.borderRadius,
      "--xCard-padding": s.padding
    })), u = l(() => ({
      [t.isOutlined]: s.outlined
    })), i = l(() => d.value ? "BaseLink" : s.tag), _ = l(() => {
      const p = {
        disabled: s.disabled
      };
      return d.value ? {
        ...p,
        ...yn(s)
      } : p;
    });
    function f(p) {
      e("click", p);
    }
    return { __sfc: !0, VALID_TAGS: mn, createElevationProp: vn, getElevationBoxShadow: gn, createLinkProps: hn, getLinkProps: yn, createDisabledProp: bn, createTestIdProp: $n, setupTestId: In, props: s, emit: e, $style: t, boxShadow: a, formatTestId: o, v2Listeners: r, isLink: d, computedStyles: c, cardClasses: u, cardTag: i, cardArgs: _, clickHandler: f };
  }
});
var ym = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.cardTag, e._g(e._b({ tag: "component", class: [t.$style.card, t.cardClasses], style: t.computedStyles, attrs: { "data-testid": t.formatTestId() }, on: { click: t.clickHandler } }, "component", t.cardArgs, !1), t.v2Listeners), [e._t("default")], 2);
}, bm = [];
const xn = {
  $style: vm
};
function $m(n) {
  for (var e in xn)
    this[e] = xn[e];
}
var Im = /* @__PURE__ */ x(
  hm,
  ym,
  bm,
  !1,
  $m
);
const ye = Im.exports;
function xm(n) {
  const e = l(() => n.icon && n.hoverIcon), s = y(!1), t = l(() => ({
    opacity: s.value ? 0 : 1
  })), a = l(() => ({
    opacity: s.value ? 1 : 0
  }));
  function o(r) {
    s.value = r.type === "mouseover" && e.value;
  }
  return {
    baseIconStyles: t,
    hoverIconStyles: a,
    canAnimateIcons: e,
    handleHover: o
  };
}
const Tm = "_XCardInteractive_1xls4_1", Sm = "_isDisabled_1xls4_4", Pm = "_iconContainer_1xls4_23", Cm = "_baseIcon_1xls4_30", wm = "_hoverIcon_1xls4_31", Bm = "_content_1xls4_44", km = "_title_1xls4_50", Lm = "_description_1xls4_59", Dm = "_ctaContainer_1xls4_67", Mm = "_ctaText_1xls4_75", Am = "_ctaIcon_1xls4_82", Om = "_hasAnimation_1xls4_130", Fm = {
  XCardInteractive: Tm,
  isDisabled: Sm,
  iconContainer: Pm,
  baseIcon: Cm,
  hoverIcon: wm,
  content: Bm,
  title: km,
  description: Lm,
  ctaContainer: Dm,
  ctaText: Mm,
  ctaIcon: Am,
  hasAnimation: Om
}, { createIconProps: et } = ce(), { icon: Tn, iconStyle: Sn } = et(), { createElevationProp: Pn } = ot(), { createLinkProps: Cn, getLinkProps: wn } = $e(), { createDisabledProp: Bn, getDisabledClass: kn } = q(), { createTestIdProp: Ln, setupTestId: Dn } = S(), Mn = ["regular", "medium", "large"], An = {
  regular: "var(--space-regular)",
  medium: "var(--space-medium)",
  large: "var(--space-large)"
}, On = {
  regular: "2x",
  medium: "2xl",
  large: "2xl"
}, Fn = {
  button: "button",
  link: "a"
}, Em = {
  name: "XCardInteractive",
  components: { XCard: ye, XIcon: B }
}, Rm = Object.assign(Em, {
  props: {
    type: {
      type: String,
      default: "button",
      validation: (n) => ["button", "link"].includes(n)
    },
    title: {
      type: String,
      default: ""
    },
    ctaText: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "regular",
      validation: (n) => Mn.includes(n)
    },
    width: {
      type: String,
      default: ""
    },
    hoverIcon: Tn,
    hoverIconStyle: Sn,
    ...et(),
    ...Pn(),
    ...Bn(),
    ...Cn(),
    ...Ln()
  },
  emits: ["click"],
  setup(n) {
    const e = n, s = ve(), { v2Listeners: t } = U(["click", "mouseover", "mouseleave"]), { isMobile: a } = Kr(), { baseIconStyles: o, hoverIconStyles: r, canAnimateIcons: d, handleHover: c } = xm(e), u = D(), { formatTestId: i } = Dn(e), { disabledClass: _ } = kn(e), f = l(() => On[e.size]), p = l(() => ({
      width: a.value ? "100%" : e.width
    })), m = l(() => ({
      tag: Fn[e.type],
      elevation: e.elevation,
      padding: An[e.size],
      borderRadius: "var(--border-radius-large)",
      dataTestid: e.dataTestid,
      disabled: e.disabled,
      style: p.value,
      ...wn(e)
    })), v = l(() => ({
      [u.hasAnimation]: d.value,
      ..._.value
    })), I = l(() => ({
      icon: e.icon,
      "icon-style": e.iconStyle,
      size: f.value
    })), g = l(() => ({
      icon: e.hoverIcon,
      "icon-style": e.hoverIconStyle,
      size: f.value
    }));
    return { __sfc: !0, createIconProps: et, hoverIconProp: Tn, hoverIconStyleProp: Sn, createElevationProp: Pn, createLinkProps: Cn, getLinkProps: wn, createDisabledProp: Bn, getDisabledClass: kn, createTestIdProp: Ln, setupTestId: Dn, SIZE_OPTIONS: Mn, PADDING_VARIABLES: An, ICON_SIZE_VARIABLES: On, TYPE_TAGS: Fn, slots: s, props: e, v2Listeners: t, isMobile: a, baseIconStyles: o, hoverIconStyles: r, canAnimateIcons: d, handleHover: c, $style: u, formatTestId: i, disabledClass: _, iconSize: f, cardStyles: p, cardArgs: m, cardClasses: v, baseIconProps: I, hoverIconProps: g, XCard: ye, XIcon: B };
  }
});
var Nm = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XCard, e._g(e._b({ class: [t.$style.XCardInteractive, t.cardClasses], on: { mouseover: t.handleHover, mouseleave: t.handleHover, click: function(a) {
    return e.$emit("click", a);
  } } }, "XCard", t.cardArgs, !1), t.v2Listeners), [e.icon ? s("div", { class: t.$style.iconContainer, attrs: { "data-testid": t.formatTestId("iconContainer") } }, [s(t.XIcon, e._b({ class: t.$style.baseIcon, style: t.baseIconStyles, attrs: { "data-testid": t.formatTestId("baseIcon") } }, "XIcon", t.baseIconProps, !1)), e.hoverIcon ? s(t.XIcon, e._b({ class: t.$style.hoverIcon, style: t.hoverIconStyles, attrs: { "data-testid": t.formatTestId("hoverIcon") } }, "XIcon", t.hoverIconProps, !1)) : e._e()], 1) : e._e(), s("div", { class: t.$style.content }, [e.title ? s("h5", { class: t.$style.title, attrs: { "data-testid": t.formatTestId("title") } }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), t.slots.default ? s("div", { class: t.$style.description, attrs: { "data-testid": t.formatTestId("description") } }, [e._t("default")], 2) : e._e(), e.ctaText ? s("div", { class: t.$style.ctaContainer }, [s("span", { class: t.$style.ctaText, attrs: { "data-testid": t.formatTestId("ctaText") } }, [e._v(" " + e._s(e.ctaText) + " ")]), s(t.XIcon, { class: t.$style.ctaIcon, attrs: { right: "", icon: "arrow-right", size: "sm" } })], 1) : e._e()])]);
}, Xm = [];
const En = {
  $style: Fm
};
function Vm(n) {
  for (var e in En)
    this[e] = En[e];
}
var zm = /* @__PURE__ */ x(
  Rm,
  Nm,
  Xm,
  !1,
  Vm
);
const jm = zm.exports, { t: Rn } = W(), qm = ["small", "regular", "medium"], Hm = ["regular", "medium"], Wm = {
  small: "var(--space-small-x)",
  regular: "var(--space-regular)",
  medium: "var(--space-medium)"
}, Km = {
  regular: "var(--font-family-body)",
  medium: "var(--font-family-title)"
}, Um = {
  regular: "var(--font-size-regular)",
  medium: "var(--font-size-medium)"
}, Gm = {
  regular: "var(--font-weight-regular)",
  medium: "var(--font-weight-semibold)"
}, Nn = {
  close: Rn("ds.xCollapse.actions.close"),
  open: Rn("ds.xCollapse.actions.open")
}, Zm = "_xCollapse_14p2s_1", Ym = "_button_14p2s_19", Jm = "_label_14p2s_30", Qm = "_isDisabled_14p2s_52", ev = "_buttonContent_14p2s_60", tv = "_iconTitle_14p2s_67", sv = "_buttonText_14p2s_71", nv = "_buttonIcon_14p2s_78", av = "_content_14p2s_81", ov = "_isOpen_14p2s_104", rv = {
  xCollapse: Zm,
  button: Ym,
  label: Jm,
  isDisabled: Qm,
  buttonContent: ev,
  iconTitle: tv,
  buttonText: sv,
  buttonIcon: nv,
  content: av,
  isOpen: ov
}, { createIconProps: Xn } = ce(), { createElevationProp: Vn, getElevationBoxShadow: zn } = ot(), { createDisabledProp: jn, getDisabledClass: qn } = q(), { createTestIdProp: Hn, setupTestId: Wn } = S(), lv = {
  name: "XCollapse",
  components: {
    XIcon: B,
    XEllipsis: K
  }
}, iv = /* @__PURE__ */ Object.assign(lv, {
  props: {
    title: {
      type: String,
      required: !0
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    titleSize: {
      type: String,
      default: "regular",
      validator: (n) => Hm.includes(n)
    },
    padding: {
      type: String,
      default: "regular",
      validator: (n) => qm.includes(n)
    },
    border: {
      type: Boolean,
      default: !0
    },
    ...Vn(),
    ...Xn(),
    ...jn(),
    ...Hn()
  },
  emits: ["open", "close"],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = Wn(s);
    function a() {
      const p = fe("label"), m = fe("content"), v = y(s.isOpen);
      function I() {
        s.disabled || (v.value = !v.value, e(v.value ? "open" : "close"));
      }
      return R(
        () => s.isOpen,
        () => {
          I();
        }
      ), {
        isOpenInternal: v,
        labelId: p,
        contentId: m,
        toggleCollapse: I
      };
    }
    const { isOpenInternal: o, labelId: r, contentId: d, toggleCollapse: c } = a(), u = l(() => o.value ? Nn.close : Nn.open);
    function i() {
      const p = D(), { disabledClass: m } = qn(s), { boxShadow: v } = zn(s), I = l(() => ({
        "--xCollapse-font-size": Um[s.titleSize],
        "--xCollapse-font-weight": Gm[s.titleSize],
        "--xCollapse-font-family": Km[s.titleSize],
        "--xCollapse-space": Wm[s.padding],
        "--xCollapse-border-color": s.border ? "var(--color-neutral-600)" : "transparent",
        ...v.value
      })), g = l(() => ({
        [p.isOpen]: o.value,
        ...m.value
      }));
      return {
        collapseStyles: I,
        collapseClasses: g
      };
    }
    const { collapseStyles: _, collapseClasses: f } = i();
    return { __sfc: !0, createIconProps: Xn, createElevationProp: Vn, getElevationBoxShadow: zn, createDisabledProp: jn, getDisabledClass: qn, createTestIdProp: Hn, setupTestId: Wn, props: s, emit: e, formatTestId: t, useControl: a, isOpenInternal: o, labelId: r, contentId: d, toggleCollapse: c, buttonAltText: u, useStyles: i, collapseStyles: _, collapseClasses: f, XIcon: B, XEllipsis: K };
  }
});
var cv = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: [e.$style.xCollapse, t.collapseClasses], style: t.collapseStyles, attrs: { "data-testid": t.formatTestId() } }, [s("h4", { class: e.$style.label, attrs: { id: t.labelId } }, [s("button", { class: e.$style.button, attrs: { "aria-controls": t.contentId, "aria-expanded": t.isOpenInternal, "aria-disabled": e.disabled, title: t.buttonAltText, "data-testid": t.formatTestId("button"), type: "button" }, on: { click: function(a) {
    return t.toggleCollapse();
  } } }, [s("div", { class: e.$style.buttonContent }, [e.icon ? s(t.XIcon, { class: e.$style.iconTitle, attrs: { icon: e.icon, "icon-style": e.iconStyle, "data-testid": t.formatTestId("iconTitle"), left: "" } }) : e._e(), s(t.XEllipsis, { class: e.$style.buttonText, attrs: { "visible-lines": 2 } }, [e._v(" " + e._s(e.title) + " ")])], 1), s(t.XIcon, { class: e.$style.buttonIcon, attrs: { icon: t.isOpenInternal ? "chevron-up" : "chevron-down", "data-testid": t.formatTestId("iconChevron") } })], 1)]), s("section", { directives: [{ name: "show", rawName: "v-show", value: t.isOpenInternal, expression: "isOpenInternal" }], class: e.$style.content, attrs: { id: t.contentId, "aria-labelledby": t.labelId, "data-testid": t.formatTestId("content") } }, [e._t("default")], 2)]);
}, dv = [];
const Kn = {
  $style: rv
};
function uv(n) {
  for (var e in Kn)
    this[e] = Kn[e];
}
var _v = /* @__PURE__ */ x(
  iv,
  cv,
  dv,
  !1,
  uv
);
const pv = _v.exports, fv = "_divider_1hmvl_1", mv = {
  divider: fv
}, vv = {
  name: "XDivider"
}, gv = /* @__PURE__ */ Object.assign(vv, {
  props: {
    margin: {
      type: String,
      default: "var(--space-regular)"
    },
    offset: {
      type: String,
      default: "0px"
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: "auto"
    },
    size: {
      type: String,
      default: "var(--border-width-small)"
    },
    variant: {
      type: String,
      default: "solid"
    },
    color: {
      type: String,
      default: "var(--color-neutral-400)"
    }
  },
  setup(n) {
    const e = n, s = l(() => e.vertical ? `${e.offset} ${e.margin}` : `${e.margin} ${e.offset}`), t = l(() => ({
      "--divider-spacing": s.value,
      "--divider-color": e.color,
      "--divider-size": e.vertical ? "0px" : e.size,
      "--divider-vertical-size": e.vertical ? e.size : "0px",
      [e.vertical ? "height" : "width"]: e.width,
      borderStyle: e.variant
    }));
    return { __sfc: !0, props: e, spacing: s, dividerStyles: t };
  }
});
var hv = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("hr", { class: e.$style.divider, style: t.dividerStyles });
}, yv = [];
const Un = {
  $style: mv
};
function bv(n) {
  for (var e in Un)
    this[e] = Un[e];
}
var $v = /* @__PURE__ */ x(
  gv,
  hv,
  yv,
  !1,
  bv
);
const Iv = $v.exports, xv = "_XDropdownMenu_16lpo_1", Tv = "_dropdown_16lpo_6", Sv = "_dropdownContainer_16lpo_11", Pv = {
  XDropdownMenu: xv,
  dropdown: Tv,
  dropdownContainer: Sv
}, { createDisabledProp: Gn } = q(), { createPlacementProp: Zn } = Ie(), { createTestIdProp: Yn, setupTestId: Jn } = S(), { createHeightProps: Qn, getHeightStyles: ea } = De(), { t: Ze } = W(), Cv = {
  name: "XDropdownMenu",
  components: {
    XDropdown: de,
    XListItem: oe,
    XCard: ye,
    XBadge: he
  }
}, wv = /* @__PURE__ */ Object.assign(Cv, {
  props: {
    options: {
      required: !0,
      type: Array,
      default: () => []
    },
    minWidth: {
      type: String,
      default: ""
    },
    innerDropdown: {
      type: Boolean,
      default: !1
    },
    newBadgeText: {
      type: String,
      default: () => Ze("ds.global.badge.new")
    },
    betaBadgeText: {
      type: String,
      default: () => Ze("ds.global.badge.beta")
    },
    ...Qn(),
    ...Zn(),
    ...Gn(),
    ...Yn()
  },
  emits: ["selected-item", "focus", "blur"],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = Jn(s), { heightStyles: a } = ea(s), o = y(null), r = y(), d = l(() => ({
      minWidth: s.minWidth || r.value,
      ...a.value
    }));
    function c(p) {
      p.action && p.action(p), e("selected-item", p);
    }
    function u(p) {
      var m;
      return r.value = `${(m = o.value) == null ? void 0 : m.offsetWidth}px`, p;
    }
    function i(p) {
      return p.href ? "a" : p.isTitle ? "div" : "button";
    }
    function _(p) {
      return p.isNew ? "sparkles" : "gem";
    }
    function f(p) {
      return p.isNew ? s.newBadgeText : s.betaBadgeText;
    }
    return { __sfc: !0, createDisabledProp: Gn, createPlacementProp: Zn, createTestIdProp: Yn, setupTestId: Jn, createHeightProps: Qn, getHeightStyles: ea, t: Ze, props: s, emit: e, formatTestId: t, heightStyles: a, activatorRef: o, activatorWidth: r, dropdownStyle: d, handleAction: c, handleActivator: u, getItemTagName: i, getBadgeIcon: _, getBadgeText: f, XDropdown: de, XListItem: oe, XCard: ye, XBadge: he };
  }
});
var Bv = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XDropdown, { class: e.$style.XDropdownMenu, attrs: { placement: e.placement, "inner-dropdown": e.innerDropdown, "data-testid": e.dataTestid, disabled: e.disabled }, on: { focus: function(a) {
    return e.$emit("focus");
  }, blur: function(a) {
    return e.$emit("blur");
  } }, scopedSlots: e._u([{ key: "activator", fn: function({ on: a }) {
    return [s("div", { ref: "activatorRef" }, [e._t("activator", null, { on: t.handleActivator(a) })], 2)];
  } }], null, !0) }, [s(t.XCard, { class: e.$style.dropdown, style: t.dropdownStyle, attrs: { elevation: "medium", padding: "0px", "data-testid": t.formatTestId("card") } }, [s("div", { class: e.$style.dropdownContainer }, [e._l(e.options, function(a, o) {
    return [e._t(`slot-${a.slot}`, function() {
      return [a.slot ? e._e() : [s(t.XListItem, { key: `${o}-item`, attrs: { tag: t.getItemTagName(a), separator: a.isTitle, to: a.href, target: a.target, icon: a.icon, "icon-style": a.iconStyle, "data-testid": a.dataTestId, disabled: a.disabled, navigable: !0 }, on: { click: function(r) {
        return t.handleAction(a);
      } }, scopedSlots: e._u([a.isNew || a.isBeta ? { key: "badge", fn: function({ badgeClass: r }) {
        return [s(t.XBadge, { class: r, attrs: { icon: t.getBadgeIcon(a), color: "brand-primary", size: "sm" } }, [e._v(" " + e._s(t.getBadgeText(a)) + " ")])];
      } } : null], null, !0) }, [e._v(" " + e._s(a.text) + " ")])]];
    }, { item: a })];
  })], 2)])], 1);
}, kv = [];
const ta = {
  $style: Pv
};
function Lv(n) {
  for (var e in ta)
    this[e] = ta[e];
}
var Dv = /* @__PURE__ */ x(
  wv,
  Bv,
  kv,
  !1,
  Lv
);
const Mv = Dv.exports, Av = "_XFileInput_pgt54_1", Ov = "_inputLabel_pgt54_4", Fv = {
  XFileInput: Av,
  inputLabel: Ov
}, { createDisabledProp: sa, getDisabledClass: na } = q(), { createTestIdProp: aa, setupTestId: oa } = S(), {
  createMessageProps: ra,
  createAdditionalMessagesProp: la,
  createInputProps: ia,
  createLabelProps: ca,
  createRequiredProp: da
} = ge(), { t: fr } = W(), ua = () => fr("ds.XFileInput.placeholder"), Ev = {
  name: "XFileInput",
  components: { XFormField: ee, XIcon: B, XButton: ae },
  inheritAttrs: !1
}, Rv = Object.assign(Ev, {
  props: {
    accept: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    hideIcon: {
      type: Boolean,
      default: !1
    },
    ...ca(),
    ...da(),
    ...ia({
      placeholder: ua
    }),
    ...sa(),
    ...ra(),
    ...la(),
    ...aa()
  },
  emits: ["input"],
  setup(n, { emit: e }) {
    const s = n, t = y(null), a = y(null), { formatTestId: o } = oa(s), r = D(), { disabledClass: d } = na(s), c = l(() => ({
      [r.hasError]: t.value
    })), u = l(() => ({
      ...c.value,
      ...d.value
    }));
    function i(p) {
      t.value = p;
    }
    function _(p) {
      e("input", p);
    }
    function f() {
      a.value.click();
    }
    return { __sfc: !0, createDisabledProp: sa, getDisabledClass: na, createTestIdProp: aa, setupTestId: oa, createMessageProps: ra, createAdditionalMessagesProp: la, createInputProps: ia, createLabelProps: ca, createRequiredProp: da, t: fr, PLACEHOLDER: ua, props: s, emit: e, hasError: t, inputFileLabelRef: a, formatTestId: o, $style: r, disabledClass: d, errorClass: c, fieldClasses: u, handleError: i, handleInputFile: _, handleFileUpload: f, XFormField: ee, XIcon: B, XButton: ae };
  }
});
var Nv = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XFormField, e._b({ class: [t.$style.XFileInput, t.fieldClasses], attrs: { "data-testid": t.formatTestId("field") }, on: { error: t.handleError }, scopedSlots: e._u([{ key: "default", fn: function({ uuid: a }) {
    return [s("label", { ref: "inputFileLabelRef", class: t.$style.inputLabel, attrs: { for: a, "data-testid": t.formatTestId("label") } }, [s("input", { attrs: { id: a, type: "file", hidden: "", disabled: e.disabled, name: e.name, accept: e.accept, multiple: e.multiple, required: e.required, "data-testid": t.formatTestId() }, domProps: { value: e.value }, on: { change: t.handleInputFile } })]), e._t("default", function() {
      return [s(t.XButton, { attrs: { "data-testid": t.formatTestId("button") }, on: { click: t.handleFileUpload } }, [e.hideIcon ? e._e() : s(t.XIcon, { attrs: { icon: "upload", left: "", "data-testid": t.formatTestId("icon") } }), e._v(" " + e._s(e.placeholder) + " ")], 1)];
    }, { handleFileUpload: t.handleFileUpload })];
  } }], null, !0) }, "XFormField", { ...e.$props, ...e.$attrs }, !1));
}, Xv = [];
const _a = {
  $style: Fv
};
function Vv(n) {
  for (var e in _a)
    this[e] = _a[e];
}
var zv = /* @__PURE__ */ x(
  Rv,
  Nv,
  Xv,
  !1,
  Vv
);
const jv = zv.exports;
function qv(n) {
  const { emit: e, props: s } = n, t = y(!1);
  async function a() {
    var u;
    s.editorSelectorToFocus && t.value && (await ie(), (u = document.querySelector(s.editorSelectorToFocus)) == null || u.focus());
  }
  function o() {
    t.value = !t.value, e("edit", t.value);
  }
  function r() {
    o(), a();
  }
  function d() {
    e("cancel"), o();
  }
  function c() {
    e("save"), s.asyncSave || o();
  }
  return R(
    () => s.isSending,
    (u) => {
      !u && t.value && o();
    }
  ), {
    isEditing: t,
    handleEditor: r,
    handleCancel: d,
    handleSave: c
  };
}
const Hv = "_XInlineEdit_mvj2d_1", Wv = "_label_mvj2d_12", Kv = "_container_mvj2d_20", Uv = "_data_mvj2d_26", Gv = "_content_mvj2d_30", Zv = "_editor_mvj2d_36", Yv = "_actions_mvj2d_42", Jv = "_actionsEditor_mvj2d_45", Qv = {
  XInlineEdit: Hv,
  label: Wv,
  container: Kv,
  data: Uv,
  content: Gv,
  editor: Zv,
  actions: Yv,
  actionsEditor: Jv
}, { createTestIdProp: pa, setupTestId: fa } = S(), eg = {
  name: "XInlineEdit",
  components: { XButton: ae, XIcon: B }
}, tg = /* @__PURE__ */ Object.assign(eg, {
  props: {
    isMultiple: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: ""
    },
    editorSelectorToFocus: {
      type: String,
      default: ""
    },
    isInvalid: {
      type: Boolean,
      default: !1
    },
    isSending: {
      type: Boolean,
      default: !1
    },
    asyncSave: {
      type: Boolean,
      default: !1
    },
    ...pa()
  },
  emits: ["edit", "cancel", "save"],
  setup(n, { emit: e }) {
    const s = n, { t } = W(), { formatTestId: a } = fa(s), { isEditing: o, handleEditor: r, handleCancel: d, handleSave: c } = qv({ props: s, emit: e }), u = l(() => s.isMultiple ? "rounded" : "circle"), i = l(() => s.isMultiple ? "" : "sm");
    return { __sfc: !0, createTestIdProp: pa, setupTestId: fa, props: s, emit: e, t, formatTestId: a, isEditing: o, handleEditor: r, handleCancel: d, handleSave: c, buttonRadius: u, buttonSize: i, XButton: ae, XIcon: B };
  }
});
var sg = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: [e.$style.XInlineEdit, e.isMultiple && e.$style.isMultiple], attrs: { "aria-disabled": e.isSending, "data-testid": t.formatTestId() } }, [e.label && !e.isMultiple ? s("label", { class: e.$style.label, attrs: { for: e.inputId, "data-testid": t.formatTestId("label") } }, [e._v(" " + e._s(e.label) + " ")]) : e._e(), s("div", { class: e.$style.container }, [e.isMultiple ? e._e() : s("div", { class: e.$style.data }, [s("span", { directives: [{ name: "show", rawName: "v-show", value: !t.isEditing, expression: "!isEditing" }], class: e.$style.content, attrs: { "data-testid": t.formatTestId("content") } }, [e._t("content")], 2), s("fieldset", { directives: [{ name: "show", rawName: "v-show", value: t.isEditing, expression: "isEditing" }], class: e.$style.editor, attrs: { disabled: e.isSending, "data-testid": t.formatTestId("editor") } }, [e._t("editor")], 2)]), s("span", { class: e.$style.actions }, [s(t.XButton, { directives: [{ name: "show", rawName: "v-show", value: !t.isEditing, expression: "!isEditing" }], class: e.$style.buttonEdit, attrs: { "border-radius": t.buttonRadius, size: t.buttonSize, design: e.isMultiple ? "outlined" : "text", "data-testid": t.formatTestId("buttonEdit"), title: t.t("ds.xInlineEdit.actions.edit.title", { label: e.label }) }, on: { click: t.handleEditor } }, [e.isMultiple ? s("span", [e._v(" " + e._s(t.t("ds.global.actions.edit.base")) + " ")]) : e._e(), s(t.XIcon, { attrs: { icon: "pen", right: e.isMultiple } })], 1), s("div", { directives: [{ name: "show", rawName: "v-show", value: t.isEditing, expression: "isEditing" }], class: e.$style.actionsEditor }, [s(t.XButton, { class: e.$style.buttonCancel, attrs: { "border-radius": t.buttonRadius, size: t.buttonSize, design: "outlined", disabled: e.isSending, "data-testid": t.formatTestId("buttonCancel"), title: t.t("ds.xInlineEdit.actions.cancel.title", { label: e.label }) }, on: { click: function(a) {
    return t.handleCancel();
  } } }, [e.isMultiple ? s("span", { attrs: { "data-testid": t.formatTestId("buttonCancelText") } }, [e._v(" " + e._s(t.t("ds.global.actions.cancel.base")) + " ")]) : s(t.XIcon, { attrs: { icon: "close", "icon-style": "fak" } })], 1), s(t.XButton, { class: e.$style.buttonSave, attrs: { disabled: e.isInvalid, loading: e.isSending, "border-radius": t.buttonRadius, size: t.buttonSize, design: "outlined", "data-testid": t.formatTestId("buttonSave"), title: t.t("ds.xInlineEdit.actions.save.title", { label: e.label }) }, on: { click: function(a) {
    return t.handleSave();
  } } }, [e.isMultiple ? s("span", [e._v(" " + e._s(t.t("ds.global.actions.save.base")) + " ")]) : e._e(), s(t.XIcon, { attrs: { icon: "check", right: e.isMultiple } })], 1)], 1)], 1)])]);
}, ng = [];
const ma = {
  $style: Qv
};
function ag(n) {
  for (var e in ma)
    this[e] = ma[e];
}
var og = /* @__PURE__ */ x(
  tg,
  sg,
  ng,
  !1,
  ag
);
const rg = og.exports, lg = {
  name: "LogoFull"
};
var ig = function() {
  var e = this, s = e._self._c;
  return s("svg", { staticClass: "fullLogo", attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 265 64" } }, [s("path", { attrs: { d: "M53.87 0h-7.83v47.25h7.83V0Zm36.4 19.5c3.64 0 6.04.62 9.47 2l3.71-6.12a26.35 26.35 0 0 0-13.18-3.43c-11.47 0-18.68 7-18.68 18.13 0 11.12 7.2 18.12 18.68 18.12 5.5 0 9.95-1.58 13.18-3.43l-3.7-6.11c-3.44 1.37-5.85 2-9.48 2-6.46 0-10.51-3.99-10.51-10.58s4.05-10.57 10.5-10.57ZM114.78 0h-7.83v47.25h7.83V0ZM25.37 8.72c5.22 0 8.52 1.03 13.33 2.96l3.91-6.53a33.6 33.6 0 0 0-17.3-4.6C10.18.55.7 9.75.7 24.38c0 14.63 9.48 23.83 24.6 23.83a33.6 33.6 0 0 0 17.3-4.6l-3.91-6.53c-4.81 1.92-8.1 2.96-13.33 2.96-10.02 0-16.14-5.91-16.14-15.66S15.35 8.72 25.37 8.72Zm41.76 4.19H59.3v34.34h7.83V12.9Zm0-12.91H59.3v7.55h7.83V0Zm56.45 18.88c-3.99 2.96-6.46 5.98-6.46 11.2 0 5.22 2.47 8.17 6.39 11.13 2.47 1.85 5.56 3.64 8.92 6.04h6.46v-5.01L122.13 31.1a1.3 1.3 0 0 1-.54-1.03c0-.41.2-.83.54-1.03l16.76-11.2V12.9h-6.46c-3.36 2.33-6.38 4.12-8.85 5.97ZM218 12.9v2.03a17.8 17.8 0 0 0-9.95-2.98c-10.44 0-17.65 7-17.65 18.13 0 11.12 7.2 18.13 17.65 18.13A17.3 17.3 0 0 0 218 45v.66c0 6.59-4.05 10.78-10.16 10.78-3.43 0-6.32.06-13.32-3.64v7.76c3.23 2.47 8.03 3.43 13.32 3.43 10.78 0 18-7.21 18-18.33V12.9H218Zm0 24.8c-2.95 2.13-5.76 3.16-8.92 3.16-6.46 0-10.5-4.19-10.5-10.78 0-6.6 4.04-10.79 10.5-10.79 3.16 0 5.97 1.04 8.92 3.17V37.7Zm31.32-25.75c-4.17 0-7.57 1.2-10.23 2.92v-1.96h-7.83v34.34h7.83V22.36c2.96-2.06 5.69-3.06 9.34-3.06 6.25 0 8.3 3.16 8.3 11.12v17.03h7.84V30.42c0-13.6-4.47-18.47-15.25-18.47ZM185.93 0h-7.83v7.55h7.83V0Zm-22.59 27.33-10.71-2.2c-1.79-.41-2.75-1.37-2.75-2.61 0-1.99 2.4-3.43 7.7-3.43 4.25 0 8.02.89 12.08 2.95l3.02-6.38c-3.23-2.13-8.65-3.71-15.1-3.71-8.11 0-15.8 3.57-15.8 11.33 0 3.7 2.26 7.41 9.54 8.92l9.54 1.93c3.57.75 4.4 1.78 4.4 3.16 0 3.09-3.57 3.77-8.24 3.77s-8.93-1.51-12.23-3.77l-3.64 6.73c3.03 2.4 8.59 4.18 15.73 4.18 9.34 0 16.48-3.43 16.48-11.33 0-5.56-3.57-8.17-10.03-9.54h.01Zm22.59-14.42h-7.83v34.34h7.83V12.9Z" } })]);
}, cg = [], dg = /* @__PURE__ */ x(
  lg,
  ig,
  cg,
  !1,
  null
);
const ug = dg.exports, _g = {
  name: "LogoReduced"
};
var pg = function() {
  var e = this, s = e._self._c;
  return s("svg", { staticClass: "reducedLogo", attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 121 64" } }, [s("path", { attrs: { d: "M71.09 0H60.696v62.726h10.392V0ZM33.256 11.581c6.926 0 11.304 1.367 17.689 3.923L56.14 6.84C50.49 3.467 42.737.726 33.163.726 13.104.726.526 12.948.526 32.366.526 51.787 13.104 64 33.163 64c9.575 0 17.32-2.733 22.978-6.107l-5.196-8.663c-6.385 2.548-10.756 3.922-17.689 3.922-13.311 0-21.426-7.845-21.426-20.785 0-12.941 8.115-20.786 21.426-20.786ZM88.686 0H78.293v62.726h10.393V0Zm11.673 25.07c-5.288 3.922-8.57 7.93-8.57 14.863s3.282 10.848 8.478 14.77c3.281 2.463 7.381 4.834 11.852 8.023h8.57V56.07L98.445 41.3c-.456-.363-.734-.819-.734-1.367s.27-1.096.734-1.366l22.244-14.863V17.14h-8.57c-4.471 3.096-8.478 5.467-11.76 7.93Z" } })]);
}, fg = [], mg = /* @__PURE__ */ x(
  _g,
  pg,
  fg,
  !1,
  null
);
const vg = mg.exports, gg = {}, { createTestIdProp: va, setupTestId: ga } = S(), hg = {
  name: "XLogo",
  components: { LogoFull: ug, LogoReduced: vg }
}, Ye = {
  black: "var(--color-neutral-1000)",
  white: "var(--color-neutral-0)",
  orange: "var(--color-brand-primary-400)"
}, yg = Object.assign(hg, {
  props: {
    color: {
      type: String,
      default: "orange",
      validation: (n) => n in Ye
    },
    height: {
      type: String,
      default: "32px"
    },
    reduced: {
      type: Boolean,
      default: !1
    },
    ...va()
  },
  setup(n) {
    const e = n, { formatTestId: s } = ga(e), t = l(() => ({
      fill: Ye[e.color],
      height: e.height
    })), a = l(() => e.reduced ? "LogoReduced" : "LogoFull");
    return { __sfc: !0, createTestIdProp: va, setupTestId: ga, COLORS: Ye, props: e, formatTestId: s, logoStyles: t, logoModel: a };
  }
});
var bg = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.logoModel, { tag: "component", style: t.logoStyles, attrs: { "data-testid": t.formatTestId() } });
}, $g = [];
const ha = {
  $style: gg
};
function Ig(n) {
  for (var e in ha)
    this[e] = ha[e];
}
var xg = /* @__PURE__ */ x(
  yg,
  bg,
  $g,
  !1,
  Ig
);
const Tg = xg.exports, mr = {
  none: "transparent",
  low: "var(--color-transparent-1000-medium)",
  high: "var(--color-transparent-1000-high)"
}, { getLoadingClass: Sg } = He();
function vr(n) {
  const e = D(), { loadingClass: s } = Sg(n), t = l(() => [s.value, ...n.modalClasses]), a = l(() => ({
    backgroundColor: mr[n.backdropOpacity]
  })), o = l(() => n.fullScreen ? {} : {
    width: `${n.width}px`
  });
  function r(d = !0) {
    document.body.classList[d ? "remove" : "add"](e.hideScrollbar);
  }
  return Go(() => {
    r();
  }), {
    modalStyles: o,
    computedModalClasses: t,
    backdropStyles: a,
    showBodyScrollbar: r
  };
}
function Pg(n) {
  const e = D(), s = y(!1), t = y(!0), a = y(null), o = y(!1), { height: r } = Er(a);
  function d() {
    return a.value.scrollTop + a.value.clientHeight >= a.value.scrollHeight;
  }
  function c() {
    return a.value.scrollTop === 0;
  }
  function u() {
    var v, I;
    return ((v = a.value) == null ? void 0 : v.scrollHeight) > ((I = a.value) == null ? void 0 : I.clientHeight);
  }
  function i() {
    s.value = d(), t.value = c();
  }
  async function _() {
    await ie(), o.value = u();
  }
  const f = l(
    () => n.scrollable && o.value && !t.value
  ), p = l(
    () => n.scrollable && o.value && !s.value
  ), m = l(() => ({
    [e.hasShadowTop]: f.value,
    [e.hasShadowBottom]: p.value
  }));
  return Rr(
    () => n.isOpen && n.scrollable && r.value,
    () => _()
  ), {
    checkScrollPosition: i,
    customContentClasses: m,
    contentRef: a,
    getIsScrollOnTop: c,
    getIsScrollOnBottom: d,
    getHasScrollBar: u,
    setHasScrollbar: _,
    hasShadowBottom: p,
    hasShadowTop: f,
    contentRefHeight: r
  };
}
function Cg(n) {
  async function e() {
    var t;
    n.focusOnOpen && (await ie(), (t = document.querySelector(n.focusOnOpen)) == null || t.focus());
  }
  function s() {
    var t;
    n.focusOnClose && ((t = document.querySelector(n.focusOnClose)) == null || t.focus());
  }
  return {
    setFocusOnOpen: e,
    setFocusOnClose: s
  };
}
function wg(n, e) {
  const { setFocusOnClose: s, setFocusOnOpen: t } = Cg(n), { showBodyScrollbar: a } = vr(n), o = y(!1), r = l(() => ({
    status: o.value,
    testId: n.dataTestid
  }));
  function d(_) {
    o.value = _;
  }
  function c() {
    a(!1), d(!0), t(), e("opened", r.value);
  }
  function u() {
    d(!1), a(), s(), e("close", r.value);
  }
  function i() {
    !n.persistent && !n.fullScreen && u();
  }
  return er("Escape", (_) => {
    n.isOpen && !n.persistent && (_.preventDefault(), u());
  }), Le(() => {
    n.isOpen && c();
  }), R(
    () => n.isOpen,
    () => {
      n.isOpen ? c() : u();
    }
  ), {
    isOpenInternal: o,
    modalData: r,
    closeBackdrop: i,
    close: u
  };
}
const Bg = "_hideScrollbar_lupfp_1", kg = "_xModalScroll_lupfp_5", Lg = "_innerScroll_lupfp_26", Dg = "_xModalBackdrop_lupfp_29", Mg = "_xModal_lupfp_5", Ag = "_xModalContent_lupfp_36", Og = "_fullScreen_lupfp_39", Fg = "_isLoading_lupfp_71", Eg = "_xModalHeader_lupfp_78", Rg = "_xModalHeaderContainer_lupfp_90", Ng = "_xModalTitle_lupfp_95", Xg = "_xModalCloseButton_lupfp_103", Vg = "_xModalCloseButtonIcon_lupfp_113", zg = "_hasShadowTop_lupfp_125", jg = "_hasShadowBottom_lupfp_128", qg = "_xModalActions_lupfp_136", Hg = "_xModalEnterActive_lupfp_144", Wg = "_xModalLeaveActive_lupfp_145", Kg = "_xModalEnterFrom_lupfp_149", Ug = "_xModalLeaveTo_lupfp_150", Gg = "_xModalEnterTo_lupfp_154", Zg = "_xModalLeaveFrom_lupfp_155", Yg = {
  hideScrollbar: Bg,
  xModalScroll: kg,
  innerScroll: Lg,
  xModalBackdrop: Dg,
  xModal: Mg,
  xModalContent: Ag,
  fullScreen: Og,
  isLoading: Fg,
  xModalHeader: Eg,
  xModalHeaderContainer: Rg,
  xModalTitle: Ng,
  xModalCloseButton: Xg,
  xModalCloseButtonIcon: Vg,
  hasShadowTop: zg,
  hasShadowBottom: jg,
  xModalActions: qg,
  xModalEnterActive: Hg,
  xModalLeaveActive: Wg,
  xModalEnterFrom: Kg,
  xModalLeaveTo: Ug,
  xModalEnterTo: Gg,
  xModalLeaveFrom: Zg
}, { createLoadingProp: ya } = He(), { createTestIdProp: ba, setupTestId: $a } = S(), Jg = {
  name: "XModal",
  components: { XIcon: B, XSpinner: Ae }
}, Qg = /* @__PURE__ */ Object.assign(Jg, {
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: [Number, String],
      default: "600"
    },
    closeButton: {
      type: Boolean,
      default: !0
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    persistent: {
      type: Boolean,
      default: !1
    },
    fullScreen: {
      type: Boolean,
      default: !1
    },
    focusOnOpen: {
      type: String,
      default: '.xModal[role="dialog"]'
    },
    focusOnClose: {
      type: String,
      default: ""
    },
    backdropOpacity: {
      type: String,
      default: "low",
      validator: (n) => n in mr
    },
    backdropClasses: {
      type: Array,
      default: () => []
    },
    modalClasses: {
      type: Array,
      default: () => []
    },
    headerClasses: {
      type: Array,
      default: () => []
    },
    contentClasses: {
      type: Array,
      default: () => []
    },
    actionsClasses: {
      type: Array,
      default: () => []
    },
    ...ya(),
    ...ba()
  },
  emits: ["opened", "close", "transition:close"],
  setup(n, { emit: e }) {
    const s = n, t = ve(), { t: a } = W(), { formatTestId: o } = $a(s), { modalStyles: r, computedModalClasses: d, backdropStyles: c } = vr(s), { isOpenInternal: u, modalData: i, closeBackdrop: _, close: f } = wg(s, e), { customContentClasses: p, checkScrollPosition: m, contentRef: v } = Pg(s);
    function I() {
      return t.header || s.title || s.closeButton;
    }
    function g() {
      return t.header || s.title;
    }
    function T() {
      return s.closeButton && !s.persistent;
    }
    return { __sfc: !0, createLoadingProp: ya, createTestIdProp: ba, setupTestId: $a, slots: t, props: s, emit: e, t: a, formatTestId: o, modalStyles: r, computedModalClasses: d, backdropStyles: c, isOpenInternal: u, modalData: i, closeBackdrop: _, close: f, customContentClasses: p, checkScrollPosition: m, contentRef: v, canShowHeader: I, canShowTitle: g, canShowCloseButton: T, XSpinner: Ae, XIcon: B };
  }
});
var eh = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("transition", { attrs: { name: "fade", "enter-active-class": e.$style.xModalEnterActive, "leave-active-class": e.$style.xModalLeaveActive, "leave-from-class": e.$style.xModalLeaveFrom, "leave-to-class": e.$style.xModalLeaveTo, "enter-from-class": e.$style.xModalEnterFrom, "enter-to-class": e.$style.xModalEnterTo }, on: { "after-leave": function(a) {
    return e.$emit("transition:close", t.modalData);
  } } }, [s("div", { directives: [{ name: "show", rawName: "v-show", value: t.isOpenInternal, expression: "isOpenInternal" }], class: [
    e.$style.xModalScroll,
    e.scrollable && e.$style.innerScroll,
    e.fullScreen && e.$style.fullScreen
  ], attrs: { "data-testid": t.formatTestId() } }, [s("div", { class: [e.$style.xModalBackdrop, ...e.backdropClasses], style: t.backdropStyles, attrs: { "data-testid": t.formatTestId("modalBackdrop") }, on: { mousedown: function(a) {
    return a.target !== a.currentTarget ? null : t.closeBackdrop();
  } } }, [s("div", { class: [e.$style.xModal, ...t.computedModalClasses], style: t.modalStyles, attrs: { "data-testid": t.formatTestId("modalDialog"), role: "dialog", "aria-modal": "true", tabindex: "-1" } }, [e.loading ? e._t("loadingContent", function() {
    return [s(t.XSpinner, { attrs: { variant: "light", "data-testid": t.formatTestId("loading") } })];
  }) : [t.canShowHeader() ? s("header", { class: [e.$style.xModalHeader, ...e.headerClasses], attrs: { "data-testid": t.formatTestId("header") } }, [t.canShowTitle() ? s("div", { class: e.$style.xModalHeaderContainer, attrs: { "data-testid": t.formatTestId("headerContainer") } }, [e._t("header", function() {
    return [s("h4", { class: e.$style.xModalTitle, attrs: { "data-testid": t.formatTestId("title") } }, [e._v(" " + e._s(e.title) + " ")])];
  })], 2) : e._e(), t.canShowCloseButton() ? s("button", { class: e.$style.xModalCloseButton, attrs: { "data-testid": t.formatTestId("closeButton"), title: t.t("ds.xModal.actions.close") }, on: { click: function(a) {
    return t.close();
  } } }, [e._t("closeButtonContent", function() {
    return [s(t.XIcon, { class: e.$style.xModalCloseButtonIcon, attrs: { "icon-style": "fak", icon: "close" } })];
  })], 2) : e._e()]) : e._e(), t.slots.default ? s("section", { ref: "contentRef", class: [e.$style.xModalContent, t.customContentClasses, ...e.contentClasses], attrs: { "data-testid": t.formatTestId("content") }, on: { "&scroll": function(a) {
    return t.checkScrollPosition.apply(null, arguments);
  } } }, [e._t("default")], 2) : e._e(), t.slots.actions ? s("footer", { class: [e.$style.xModalActions, ...e.actionsClasses], attrs: { "data-testid": t.formatTestId("actions") } }, [e._t("actions")], 2) : e._e()]], 2)])])]);
}, th = [];
const Ia = {
  $style: Yg
};
function sh(n) {
  for (var e in Ia)
    this[e] = Ia[e];
}
var nh = /* @__PURE__ */ x(
  Qg,
  eh,
  th,
  !1,
  sh
);
const ah = nh.exports;
function oh(n) {
  const e = D();
  return {
    alignClass: l(() => {
      const t = `align${Gl(n.align)}`;
      return {
        [e[t]]: !0
      };
    })
  };
}
function rh(n, e) {
  const s = ri(), t = l(() => {
    var _;
    if (n.eventBased) return n.activePage;
    const u = ((_ = s == null ? void 0 : s.query) == null ? void 0 : _.page) || new URLSearchParams(window.location.search).get("page"), i = Array.isArray(u) ? u[0] : u;
    return Number(i) || 1;
  });
  function a(u) {
    return t.value === u;
  }
  function o(u) {
    if (n.eventBased) return "";
    const i = new URL(window.location.href);
    return i.searchParams.set("page", u), i.toString();
  }
  function r(u, i) {
    (a(i) || n.eventBased) && u.preventDefault(), n.eventBased && e("change", i);
  }
  const d = l(() => t.value - 1 <= 0), c = l(() => t.value + 1 > n.totalPages);
  return {
    currentPage: t,
    hasPrevPage: d,
    hasNextPage: c,
    getPageLink: o,
    isCurrentPage: a,
    changePage: r
  };
}
function lh(n, e) {
  const s = l(
    () => n.totalPages > n.maxVisible ? n.maxVisible : n.totalPages
  ), t = l(() => n.totalPages > n.maxVisible), a = l(
    () => n.totalPages > s.value ? Math.ceil(s.value / 2) : n.totalPages
  );
  function o() {
    return Array.from(Array(s.value), (u, i) => {
      const _ = e.value > a.value ? e.value - 2 : 1, f = t.value ? _ + i : e.value + i;
      return f > n.totalPages ? f - s.value : f;
    });
  }
  function r(u) {
    return u.sort((i, _) => i - _).map((i, _) => t.value ? _ === 0 ? 1 : _ + 1 === n.maxVisible ? n.totalPages : i : i);
  }
  const d = l(() => r(o()));
  function c(u) {
    const i = d.value[u], _ = d.value[u - 1], f = u === n.maxVisible - 1, p = u === 1, m = e.value - 1 > 2 && e.value - 1 >= a.value, v = p && m, I = f && i - _ >= 2;
    return t.value && (I || v);
  }
  return {
    pageLimiterTriggerPoint: a,
    havePagesToHide: t,
    visiblePages: d,
    showLimiter: c
  };
}
const ih = "_xPagination_12e40_1", ch = "_alignLeft_12e40_6", dh = "_alignRight_12e40_9", uh = "_alignCenter_12e40_12", _h = "_xPaginationContainer_12e40_16", ph = "_xPaginationItem_12e40_25", fh = "_xPaginationLink_12e40_32", mh = "_xPaginationNav_12e40_33", vh = "_xPaginationLimiter_12e40_38", gh = "_xPaginationNavText_12e40_53", hh = {
  xPagination: ih,
  alignLeft: ch,
  alignRight: dh,
  alignCenter: uh,
  xPaginationContainer: _h,
  xPaginationItem: ph,
  xPaginationLink: fh,
  xPaginationNav: mh,
  xPaginationLimiter: vh,
  xPaginationNavText: gh
}, { createTestIdProp: xa, setupTestId: Ta } = S(), yh = {
  name: "XPagination",
  components: {
    XLink: ne
  },
  model: {
    prop: "activePage",
    event: "change"
  }
}, bh = /* @__PURE__ */ Object.assign(yh, {
  props: {
    activePage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 2
    },
    maxVisible: {
      type: Number,
      default: 7,
      validator: (n) => n >= 3
    },
    prevText: {
      type: String,
      default: ""
    },
    nextText: {
      type: String,
      default: ""
    },
    eventBased: {
      type: Boolean,
      default: !1
    },
    align: {
      type: String,
      default: "left",
      validator: (n) => /left|center|right/.test(n)
    },
    ...xa()
  },
  emits: ["change"],
  setup(n, { emit: e }) {
    const s = n, { t } = W(), { formatTestId: a } = Ta(s), { alignClass: o } = oh(s), { currentPage: r, hasNextPage: d, hasPrevPage: c, getPageLink: u, isCurrentPage: i, changePage: _ } = rh(s, e), { visiblePages: f, showLimiter: p } = lh(s, r);
    return { __sfc: !0, createTestIdProp: xa, setupTestId: Ta, props: s, emit: e, t, formatTestId: a, alignClass: o, currentPage: r, hasNextPage: d, hasPrevPage: c, getPageLink: u, isCurrentPage: i, changePage: _, visiblePages: f, showLimiter: p, XLink: ne };
  }
});
var $h = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("nav", { class: [e.$style.xPagination, t.alignClass], attrs: { "data-testid": t.formatTestId(), role: "navigation", "aria-label": t.t("ds.xPagination.aria.label") } }, [s("ul", { class: e.$style.xPaginationContainer }, [s("li", { class: e.$style.xPaginationItem }, [s(t.XLink, { class: e.$style.xPaginationNav, attrs: { to: t.getPageLink(t.currentPage - 1), disabled: t.hasPrevPage, "data-testid": t.formatTestId("previousLink"), icon: "arrow-left", "icon-position": "left", "no-padding": "", title: t.t("ds.xPagination.prev") }, on: { click: function(a) {
    return t.changePage(a, t.currentPage - 1);
  } } }, [e.prevText ? s("div", { class: e.$style.xPaginationNavText, attrs: { "data-testid": t.formatTestId("previousText") } }, [e._v(" " + e._s(e.prevText) + " ")]) : e._e()])], 1), e._l(t.visiblePages, function(a, o) {
    return s("li", { key: a, class: e.$style.xPaginationItem }, [s("span", { directives: [{ name: "show", rawName: "v-show", value: t.showLimiter(o), expression: "showLimiter(index)" }], class: e.$style.xPaginationLimiter }, [e._v(" ... ")]), s(t.XLink, { class: e.$style.xPaginationLink, attrs: { to: t.getPageLink(a), disabled: t.isCurrentPage(a), "aria-current": t.isCurrentPage(a), "data-testid": t.formatTestId(`page${a}Link`), "no-padding": "" }, on: { click: function(r) {
      return t.changePage(r, a);
    } } }, [e._v(" " + e._s(a) + " ")])], 1);
  }), s("li", { class: e.$style.xPaginationItem }, [s(t.XLink, { class: e.$style.xPaginationNav, attrs: { to: t.getPageLink(t.currentPage + 1), disabled: t.hasNextPage, "data-testid": t.formatTestId("nextLink"), icon: "arrow-right", "icon-position": "right", "no-padding": "", title: t.t("ds.xPagination.next") }, on: { click: function(a) {
    return t.changePage(a, t.currentPage + 1);
  } } }, [e.nextText ? s("div", { class: e.$style.xPaginationNavText, attrs: { "data-testid": t.formatTestId("nextText") } }, [e._v(" " + e._s(e.nextText) + " ")]) : e._e()])], 1)], 2)]);
}, Ih = [];
const Sa = {
  $style: hh
};
function xh(n) {
  for (var e in Sa)
    this[e] = Sa[e];
}
var Th = /* @__PURE__ */ x(
  bh,
  $h,
  Ih,
  !1,
  xh
);
const Sh = Th.exports, Ph = {
  name: "XRadio",
  components: { BaseOption: Pe },
  model: Se
}, Ch = /* @__PURE__ */ Object.assign(Ph, {
  props: Te,
  emits: Z,
  setup(n) {
    const { v2Listeners: e } = U(["change"]);
    return { __sfc: !0, v2Listeners: e, BaseOption: Pe, changeEvent: me };
  }
});
var wh = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.BaseOption, e._g(e._b({ attrs: { type: "radio" }, on: e._d({}, [t.changeEvent, (a) => e.$emit(t.changeEvent, a)]) }, "BaseOption", { ...e.$props, ...e.$attrs }, !1), t.v2Listeners), [e._t("default")], 2);
}, Bh = [], kh = /* @__PURE__ */ x(
  Ch,
  wh,
  Bh,
  !1,
  null
);
const Lh = kh.exports;
function Dh(n) {
  const { props: e, emit: s, computedItems: t } = n, a = y("");
  function o(p) {
    a.value = p, s("input:search", p);
  }
  function r() {
    e.searchable && o("");
  }
  const d = l(
    () => t.value.filter((p) => p.value === a.value).length === 0
  ), c = l(() => a.value && new RegExp(a.value, "ig")), u = (p) => c.value.test(p.text), i = (p) => {
    const m = { ...p };
    return m.highlighted = m.text.replaceAll(c.value, "<b>$&</b>"), m;
  }, _ = l(() => a.value && t.value.reduce((p, m) => m.header || !u(m) || !m.text ? p : [...p, i(m)], [])), f = l(
    () => a.value && _.value.length === 0 && !e.createNewItemLabel
  );
  return {
    searchTerm: a,
    filteredItems: _,
    isSearchTermNotFound: d,
    canShowEmptySearchMessage: f,
    setSearchTerm: o,
    cleanSearch: r
  };
}
const { createFullWidthProp: Mh } = Q(), { createDisabledProp: Ah } = q(), { createTestIdProp: Oh } = S(), { t: Pa } = W();
function gr() {
  return {
    placeholder: {
      type: String,
      default: () => Pa("ds.xSelect.actions.select.ellipsis")
    },
    maxVisibleSelectedItems: {
      type: [Number, Boolean],
      default: 1
    },
    createNewItemLabel: {
      type: String,
      default: ""
    },
    maxChipTextSize: {
      type: Number,
      default: 0
    },
    searchable: {
      type: Boolean,
      default: !1
    },
    searchPlaceholder: {
      type: String,
      default: () => Pa("ds.xSelect.actions.search")
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    ...Ah(),
    ...Mh(),
    ...Oh()
  };
}
const { setupVModel: Fh } = se(), { DEFAULT_OPTIONS: Ca, createItemObject: Ne, itemHasCorrectKeys: wa } = rt();
function Eh(n) {
  const { props: e, emit: s, filteredItems: t, searchTerm: a, computedItems: o } = n;
  function r() {
    const { data: L } = Fh(e, s), O = l(() => e.returnObject || e.async);
    function h(P) {
      let E = P;
      return wa(P, e) || (E = Ne(P, e)), O.value ? E : E.value;
    }
    function M(P) {
      let E = P;
      wa(P, e) && (E = P.value);
      const G = o.value.find(
        (re) => String(re.value) === String(E)
      );
      return G || Ne(P, e);
    }
    function X() {
      var P;
      return e.multiple ? (P = L.value) == null ? void 0 : P.map(M) : M(L.value);
    }
    function V(P) {
      L.value = e.multiple ? P.map(h) : h(P);
    }
    const F = l({
      get: () => X(),
      set: (P) => V(P)
    });
    function N(P) {
      return e.multiple ? P != null && P.selectAll ? P.value : F.value.some((E) => E.value === P.value) : F.value === P.value;
    }
    const b = l(() => (e.multiple ? F.value : [F.value]).filter((E) => E.value === a.value).length === 0);
    return {
      selectedItems: F,
      isSearchTermNotSelected: b,
      isItemAlreadySelected: N
    };
  }
  const { selectedItems: d, isSearchTermNotSelected: c, isItemAlreadySelected: u } = r();
  function i() {
    function L(b) {
      return d.value.filter((P) => P.value === b.value);
    }
    function O(b) {
      s("remove-item", L(b));
    }
    function h(b) {
      O(b), d.value = d.value.filter((P) => P.value !== b.value);
    }
    function M(b) {
      Array.isArray(b) ? d.value = b : u(b) ? h(b) : d.value = [...d.value, b];
    }
    function X(b) {
      d.value = b;
    }
    function V(b) {
      e.multiple ? M(b) : X(b);
    }
    const F = l(
      () => e.searchable && !!e.createNewItemLabel && a.value
    );
    function N() {
      F.value && (V(Ne(a.value, e)), s("new-item-created", a.value));
    }
    return {
      setSelectedItem: V,
      removeSelectedItem: h,
      createNewItem: N
    };
  }
  const { setSelectedItem: _, removeSelectedItem: f, createNewItem: p } = i();
  function m() {
    function L(b) {
      var P;
      return (P = d.value) != null && P.length && (b != null && b.value) ? !!d.value.find(
        (E) => (E == null ? void 0 : E.disabled) && E.value === b.value
      ) : !1;
    }
    const O = l(() => o.value.filter((b) => L(b))), h = l(() => o.value.filter(
      (b) => (b == null ? void 0 : b.value) && !(b != null && b.disabled) || L(b)
    )), M = l(
      () => d.value.length === h.value.length
    ), X = Uo({
      ...Ne(
        {
          [Ca.itemTextKey]: e.selectAllText,
          [Ca.itemValueKey]: M.value
        },
        e
      ),
      selectAll: !0,
      dataTestid: "selectAll"
    }), V = l(() => e.multiple && e.selectAll);
    function F() {
      X.value ? _(O.value) : _(h.value), X.value = !X.value;
    }
    function N(b) {
      return !!(b != null && b.selectAll);
    }
    return R(
      () => d.value,
      (b) => {
        b != null && b.length && (X.value = b.length === h.value.length);
      }
    ), {
      selectAllOption: X,
      canSelectAll: V,
      handleSelectAllItems: F,
      isSelectAllOption: N
    };
  }
  const { selectAllOption: v, canSelectAll: I, handleSelectAllItems: g, isSelectAllOption: T } = m();
  return {
    itemsList: l(() => I.value && !a.value ? [v, ...o.value] : a.value ? t.value : o.value),
    selectedItems: d,
    isSearchTermNotSelected: c,
    isItemAlreadySelected: u,
    setSelectedItem: _,
    removeSelectedItem: f,
    createNewItem: p,
    isSelectAllOption: T,
    handleSelectAllItems: g
  };
}
const Rh = "_searchInput_7ae9i_1", Nh = {
  searchInput: Rh
}, { createTestIdProp: Ba, setupTestId: ka } = S(), Xh = {
  name: "SearchInput"
}, Vh = /* @__PURE__ */ Object.assign(Xh, {
  props: {
    value: {
      type: String,
      default: ""
    },
    showSearch: {
      type: Boolean,
      default: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    ...Ba()
  },
  emits: ["input"],
  setup(n, { emit: e }) {
    const s = n, t = y(null), a = y(""), { formatTestId: o } = ka(s);
    function r(i) {
      e("input", i.target.value);
    }
    function d() {
      ie(() => {
        s.showSearch && t.value.focus();
      });
    }
    function c(i) {
      a.value = i, a.value || d();
    }
    function u(i) {
      s.showSearch && i.stopPropagation();
    }
    return R(
      () => s.value,
      (i) => {
        c(i);
      }
    ), R(
      () => s.showSearch,
      () => {
        d();
      }
    ), { __sfc: !0, createTestIdProp: Ba, setupTestId: ka, props: s, emit: e, searchInputRef: t, search: a, formatTestId: o, handleInput: r, focusSearchInput: d, updateSearchInput: c, preventClose: u };
  }
});
var zh = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("input", { directives: [{ name: "show", rawName: "v-show", value: e.showSearch, expression: "showSearch" }, { name: "model", rawName: "v-model", value: t.search, expression: "search" }], ref: "searchInputRef", class: e.$style.searchInput, attrs: { placeholder: e.searchPlaceholder, "data-testid": t.formatTestId("searchInput"), size: e.value.length || 1 }, domProps: { value: t.search }, on: { input: [function(a) {
    a.target.composing || (t.search = a.target.value);
  }, t.handleInput], click: t.preventClose } });
}, jh = [];
const La = {
  $style: Nh
};
function qh(n) {
  for (var e in La)
    this[e] = La[e];
}
var Hh = /* @__PURE__ */ x(
  Vh,
  zh,
  jh,
  !1,
  qh
);
const hr = Hh.exports, Wh = "_activator_crei4_1", Kh = "_isMultiple_crei4_26", Uh = "_placeholder_crei4_29", Gh = "_searchContainer_crei4_36", Zh = "_valuesContainer_crei4_39", Yh = "_multipleItems_crei4_49", Jh = "_chipItem_crei4_59", Qh = "_singleItem_crei4_62", ey = "_singleItemText_crei4_66", ty = "_isDisabled_crei4_72", sy = "_selectedItemsCount_crei4_78", ny = "_arrow_crei4_81", ay = "_hasError_crei4_93", oy = {
  activator: Wh,
  isMultiple: Kh,
  placeholder: Uh,
  searchContainer: Gh,
  valuesContainer: Zh,
  multipleItems: Yh,
  chipItem: Jh,
  singleItem: Qh,
  singleItemText: ey,
  isDisabled: ty,
  selectedItemsCount: sy,
  arrow: ny,
  hasError: ay
}, { getDisabledClass: Da } = q(), { setupTestId: Ma } = S(), ry = {
  name: "SelectActivator",
  components: { XBadge: he, XIcon: B, XEllipsis: K, SearchInput: hr }
}, ly = /* @__PURE__ */ Object.assign(ry, {
  props: {
    selectedItems: {
      type: [String, Object, Number, Boolean, Array],
      default: ""
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    isMenuOpened: {
      type: Boolean,
      default: !1
    },
    searchTerm: {
      type: String,
      default: ""
    },
    labelId: {
      type: String,
      default: ""
    },
    uuid: {
      type: String,
      default: ""
    },
    ...gr()
  },
  emits: ["control", "input:search", "arrow-down", "remove-item"],
  setup(n, { emit: e }) {
    const s = n, t = D(), a = y(null), { disabledClass: o } = Da(s), { formatTestId: r } = Ma(s);
    function d() {
      const h = l(() => {
        var b;
        return (b = s.selectedItems) == null ? void 0 : b.length;
      }), M = l(
        () => s.maxVisibleSelectedItems && !s.createNewItemLabel && h.value > s.maxVisibleSelectedItems
      ), X = l(() => M.value ? s.selectedItems.slice(0, s.maxVisibleSelectedItems) : s.selectedItems), V = l(
        () => `+${h.value - s.maxVisibleSelectedItems}`
      );
      function F(b) {
        return r(`${b}SelectChip`);
      }
      function N(b) {
        return s.maxChipTextSize && (b == null ? void 0 : b.length) > s.maxChipTextSize ? `${b.slice(0, s.maxChipTextSize)}...` : b;
      }
      return {
        selectedItemsList: X,
        selectedItemsLength: h,
        selectedItemsCountText: V,
        canShowItemsCount: M,
        getSelectedItemTestId: F,
        truncateItemText: N
      };
    }
    const {
      selectedItemsList: c,
      selectedItemsLength: u,
      selectedItemsCountText: i,
      canShowItemsCount: _,
      getSelectedItemTestId: f,
      truncateItemText: p
    } = d(), m = l(
      () => !s.searchable || !s.isMenuOpened && s.searchable
    ), v = l(() => !!s.selectedItems.text || u.value > 0), I = l(() => ({
      [t.hasSelectedItem]: v.value
    })), g = l(() => ({
      [t.isMultiple]: s.multiple && v.value,
      [t.hasError]: s.hasError,
      ...o.value
    })), T = l(() => {
      const h = !v.value && !s.isMenuOpened, M = s.isMenuOpened && !v.value && !s.searchable;
      return h || M;
    });
    function k(h) {
      e("control", { event: h, activator: a });
    }
    function L(h) {
      h.key === "Enter" ? k(h) : h.key === "ArrowDown" && e("arrow-down", h);
    }
    function O(h) {
      e("input:search", h);
    }
    return { __sfc: !0, getDisabledClass: Da, setupTestId: Ma, props: s, emit: e, $style: t, activator: a, disabledClass: o, formatTestId: r, useMultipleItems: d, selectedItemsList: c, selectedItemsLength: u, selectedItemsCountText: i, canShowItemsCount: _, getSelectedItemTestId: f, truncateItemText: p, isUniqueSelect: m, hasSelectedItem: v, hasSelectedItemClass: I, activatorClasses: g, canShowPlaceholder: T, emitActivatorData: k, keyboardControl: L, handleSearch: O, XBadge: he, XIcon: B, XEllipsis: K, SearchInput: hr };
  }
});
var iy = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { ref: "activator", class: [t.$style.activator, t.activatorClasses], attrs: { tabindex: "0", role: "combobox", "aria-haspopup": "listbox", "aria-labelledby": e.labelId, "aria-owns": e.uuid, "aria-expanded": e.isMenuOpened, "aria-disabled": e.disabled, "data-testid": e.dataTestid }, on: { click: (a) => t.emitActivatorData(a), keydown: t.keyboardControl } }, [s("div", { class: t.$style.valuesContainer, attrs: { "aria-controls": e.uuid } }, [s("span", { directives: [{ name: "show", rawName: "v-show", value: t.canShowPlaceholder, expression: "canShowPlaceholder" }], class: t.$style.placeholder, attrs: { "data-testid": t.formatTestId("placeholder") } }, [e._v(" " + e._s(e.placeholder) + " ")]), e.multiple ? s("ul", { directives: [{ name: "show", rawName: "v-show", value: !t.canShowPlaceholder, expression: "!canShowPlaceholder" }], class: [t.$style.multipleItems, t.hasSelectedItemClass, t.disabledClass] }, [e._l(t.selectedItemsList, function(a) {
    return s(t.XBadge, { key: a.text, class: t.$style.chipItem, attrs: { tag: "li", color: "neutral-0", closable: !(e.disabled || a != null && a.disabled), disabled: e.disabled || (a == null ? void 0 : a.disabled), "data-testid": t.getSelectedItemTestId(a.value) }, on: { click: function(o) {
      return t.emit("remove-item", a);
    } } }, [e._v(" " + e._s(t.truncateItemText(a.text)) + " ")]);
  }), t.canShowItemsCount ? s(t.XBadge, { class: t.$style.selectedItemsCount, attrs: { color: "neutral", disabled: e.disabled, "data-testid": t.formatTestId("countChip") } }, [e._v(" " + e._s(t.selectedItemsCountText) + " ")]) : e._e(), e.searchable ? s("li", { class: t.$style.searchContainer }, [s(t.SearchInput, { attrs: { value: e.searchTerm, "show-search": e.isMenuOpened, "data-testid": e.dataTestid, "search-placeholder": e.searchPlaceholder }, on: { input: t.handleSearch } })], 1) : e._e()], 2) : s("div", { directives: [{ name: "show", rawName: "v-show", value: !t.canShowPlaceholder, expression: "!canShowPlaceholder" }], class: [t.$style.singleItem, t.hasSelectedItemClass, t.disabledClass] }, [s(t.XEllipsis, { directives: [{ name: "show", rawName: "v-show", value: t.isUniqueSelect, expression: "isUniqueSelect" }], class: t.$style.singleItemText, attrs: { "data-testid": t.formatTestId("value") } }, [e._v(" " + e._s(e.selectedItems.text) + " ")]), e.searchable ? s(t.SearchInput, { attrs: { value: e.searchTerm, "show-search": e.isMenuOpened, "data-testid": e.dataTestid, "search-placeholder": e.searchPlaceholder }, on: { input: t.handleSearch } }) : e._e()], 1)]), s("div", { class: t.$style.arrow }, [s(t.XIcon, { attrs: { icon: `chevron-${e.isMenuOpened ? "up" : "down"}`, size: "lg" } })], 1)]);
}, cy = [];
const Aa = {
  $style: oy
};
function dy(n) {
  for (var e in Aa)
    this[e] = Aa[e];
}
var uy = /* @__PURE__ */ x(
  ly,
  iy,
  cy,
  !1,
  dy
);
const yr = uy.exports, _y = "_wrapper_kngqx_1", py = {
  wrapper: _y
}, fy = {
  name: "ListItemsContainer"
}, my = /* @__PURE__ */ Object.assign(fy, {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    virtualizedList: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:list", "mounted:virtualized-list"],
  setup(n, { emit: e }) {
    const s = n, t = l(() => s.items);
    function a() {
      let c, u, i;
      return s.virtualizedList && ({ list: c, wrapperProps: u, containerProps: i } = Xr(t, {
        itemHeight: 40,
        overscan: 30
      })), {
        list: l(() => s.virtualizedList ? [...c.value].map((f) => ({
          ...f == null ? void 0 : f.data,
          index: f == null ? void 0 : f.index
        })) : t.value),
        containerProps: i,
        wrapperProps: u
      };
    }
    const { list: o, containerProps: r, wrapperProps: d } = a();
    return Nr(o, () => {
      s.virtualizedList && e("mounted:virtualized-list");
    }), { __sfc: !0, props: s, emit: e, listItems: t, useListItems: a, list: o, containerProps: r, wrapperProps: d };
  }
});
var vy = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return e.virtualizedList ? s("div", { ref: t.containerProps.ref, style: t.containerProps.style, on: { scroll: t.containerProps.onScroll } }, [e._t("before"), s("ul", { class: e.$style.wrapper, style: t.wrapperProps.style }, [e._t("default", null, { list: t.list })], 2), e._t("after")], 2) : s("ul", [e._t("before"), e._t("default", null, { list: t.list }), e._t("after")], 2);
}, gy = [];
const Oa = {
  $style: py
};
function hy(n) {
  for (var e in Oa)
    this[e] = Oa[e];
}
var yy = /* @__PURE__ */ x(
  my,
  vy,
  gy,
  !1,
  hy
);
const br = yy.exports, by = "_XSelect_1lbyc_1", $y = "_container_1lbyc_4", Iy = "_dropdownMenu_1lbyc_10", xy = "_menuList_1lbyc_18", Ty = "_listItem_1lbyc_24", Sy = "_listItemText_1lbyc_27", Py = "_emptySearchResultsMessage_1lbyc_31", Cy = {
  XSelect: by,
  container: $y,
  dropdownMenu: Iy,
  menuList: xy,
  listItem: Ty,
  listItemText: Sy,
  emptySearchResultsMessage: Py
}, { createLabelProps: Fa, createRequiredProp: Ea } = ge(), { setupTestId: Je } = S(), { createValidationsProp: Ra } = Me(), { createVModelProp: Na } = se(), { createItemsCustomKeysProps: Xa, getItemsWithDefaultKeys: Va } = rt({
  validator: (n) => !(n != null && n.header)
}), { createPlacementProp: $r } = Ie(), { placement: za } = $r("bottom-start"), { t: Xe } = W(), wy = {
  name: "XSelect",
  components: {
    XFormField: ee,
    XDropdown: de,
    SelectActivator: yr,
    XCard: ye,
    XListItem: oe,
    XBadge: he,
    ListItemsContainer: br
  }
}, By = /* @__PURE__ */ Object.assign(wy, {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Object, Number, Boolean, Array],
      default: ""
    },
    virtualizedList: {
      type: Boolean,
      default: !1
    },
    customError: {
      type: String,
      default: ""
    },
    innerDropdown: {
      type: Boolean,
      default: !1
    },
    returnObject: {
      type: Boolean,
      default: !1
    },
    maxItems: {
      type: Number,
      default: 6
    },
    betaBadgeText: {
      type: String,
      default: () => Xe("ds.global.badge.beta")
    },
    newBadgeText: {
      type: String,
      default: () => Xe("ds.global.badge.new")
    },
    async: {
      type: Boolean,
      default: !1
    },
    selectAll: {
      type: Boolean,
      default: !1
    },
    selectAllText: {
      type: String,
      default: () => Xe("ds.xSelect.actions.select.all")
    },
    menuPosition: za,
    ...Ea(),
    ...Fa(),
    ...Ra(),
    ...Na([String, Object, Number, Boolean, Array]),
    ...gr(),
    ...Xa()
  },
  emits: [
    "focus",
    "blur",
    "update:modelValue",
    "input:search",
    "new-item-created",
    "remove-item",
    "input"
  ],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = Je(s), { formatTestId: a } = Je({
      dataTestid: "selectField"
    }), o = fe("select-"), r = y(null), d = y([]), { computedItems: c } = Va(s), {
      searchTerm: u,
      filteredItems: i,
      isSearchTermNotFound: _,
      canShowEmptySearchMessage: f,
      setSearchTerm: p,
      cleanSearch: m
    } = Dh({ props: s, emit: e, computedItems: c });
    function v() {
      const C = y(null), z = y(null), vt = y(!1), gt = y(0);
      function Pr(Ge = !0) {
        vt.value = Ge;
      }
      function Cr(Ge) {
        gt.value = Ge;
      }
      const wr = l(() => ({
        maxHeight: `calc(var(--space-large-x) * ${s.maxItems})`,
        width: `${gt.value}px`
      }));
      return {
        menuRef: C,
        menuListRef: z,
        isMenuOpened: vt,
        menuStyles: wr,
        setMenuVisibility: Pr,
        setMenuWidth: Cr
      };
    }
    const { menuRef: I, menuListRef: g, isMenuOpened: T, menuStyles: k, setMenuVisibility: L, setMenuWidth: O } = v(), {
      itemsList: h,
      selectedItems: M,
      isSearchTermNotSelected: X,
      isItemAlreadySelected: V,
      setSelectedItem: F,
      removeSelectedItem: N,
      createNewItem: b,
      isSelectAllOption: P,
      handleSelectAllItems: E
    } = Eh({
      props: s,
      emit: e,
      filteredItems: i,
      searchTerm: u,
      computedItems: c
    }), { handleNavigationKeyboard: G, setInitialFocusByNodeIndex: re, resetKeyboardNavigation: be } = lr({
      itemsListRef: d,
      virtualizedList: s.virtualizedList,
      horizontal: !1
    }), ue = y(!1);
    function A(C) {
      ue.value = C;
    }
    function H(C) {
      const z = (C == null ? void 0 : C.dataTestid) || `${(C == null ? void 0 : C.value) || (C == null ? void 0 : C.header) || C}`;
      return a(`${z}-Option`);
    }
    const Ce = l(
      () => s.createNewItemLabel && s.searchable && u.value && X.value && _.value
    ), Ke = l(() => ({
      disabled: s.disabled,
      hasError: ue.value,
      isMenuOpened: T.value,
      dataTestid: s.dataTestid,
      multiple: s.multiple,
      selectedItems: M.value,
      placeholder: s.placeholder,
      abbreviationSize: s.abbreviationSize,
      searchable: s.searchable,
      searchPlaceholder: s.searchPlaceholder,
      searchTerm: u.value,
      maxChipTextSize: s.maxChipTextSize,
      maxVisibleSelectedItems: s.maxVisibleSelectedItems,
      createNewItemLabel: s.createNewItemLabel
    }));
    function Ee() {
      !s.searchable && T.value && re();
    }
    function we(C) {
      P(C) ? E() : F(C), m();
    }
    function $(C) {
      return (C == null ? void 0 : C.key) === "Tab" || (C == null ? void 0 : C.key) === "Enter" || !s.multiple && (C == null ? void 0 : C.code) === "Space";
    }
    function w() {
      var C;
      (C = r.value) != null && C.$el && r.value.$el.focus();
    }
    function j(C) {
      b(), m(), L(!1), w(), $(C) || e("blur"), be();
    }
    function Y() {
      L(), e("focus"), ie(() => {
        O(r.value.$el.offsetWidth);
      }), Ee();
    }
    function _e(C, z) {
      z.preventDefault(), ((z == null ? void 0 : z.key) === "Enter" || (z == null ? void 0 : z.code) === "Space") && we(C), $(z) && j(z), G(z);
    }
    function Ue(C) {
      return !C.header && !C.disabled;
    }
    function Sr(C, z) {
      return z != null && z.header ? `${C}_${z.header}` : `${C}_${z.value}`;
    }
    return { __sfc: !0, createLabelProps: Fa, createRequiredProp: Ea, setupTestId: Je, createValidationsProp: Ra, createVModelProp: Na, createItemsCustomKeysProps: Xa, getItemsWithDefaultKeys: Va, createPlacementProp: $r, placement: za, t: Xe, props: s, emit: e, formatTestId: t, formatMenuItemTestId: a, uuid: o, activatorRef: r, itemsListRef: d, computedItems: c, searchTerm: u, filteredItems: i, isSearchTermNotFound: _, canShowEmptySearchMessage: f, setSearchTerm: p, cleanSearch: m, useMenu: v, menuRef: I, menuListRef: g, isMenuOpened: T, menuStyles: k, setMenuVisibility: L, setMenuWidth: O, itemsList: h, selectedItems: M, isSearchTermNotSelected: X, isItemAlreadySelected: V, setSelectedItem: F, removeSelectedItem: N, createNewItem: b, isSelectAllOption: P, handleSelectAllItems: E, handleNavigationKeyboard: G, setInitialFocusByNodeIndex: re, resetKeyboardNavigation: be, hasError: ue, handleError: A, getMenuItemTestId: H, canShowCreateNewItemLabel: Ce, activatorProps: Ke, focusFirstItemOnOpen: Ee, handleSelectItem: we, isKeyboardCloseEvent: $, setActivatorFocus: w, closeMenu: j, openMenu: Y, handleItemKeyboard: _e, checkIfIsValidOption: Ue, getItemKey: Sr, XCard: ye, XListItem: oe, XBadge: he, XFormField: ee, XDropdown: de, SelectActivator: yr, ListItemsContainer: br };
  }
});
var ky = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XFormField, { class: e.$style.XSelect, attrs: { message: e.customError, "help-tooltip": e.helpTooltip, label: e.label, required: e.required, validations: e.validations, "full-width": e.fullWidth }, on: { error: t.handleError }, scopedSlots: e._u([{ key: "default", fn: function({ labelId: a }) {
    return [s(t.XDropdown, { class: e.$style.container, attrs: { "is-open": t.isMenuOpened, "full-width": e.fullWidth, disabled: e.disabled, "close-on-click-content": !e.multiple, placement: e.menuPosition, "inner-dropdown": e.innerDropdown, "data-testid": t.formatTestId("menu"), "allow-shortcut": "", "disable-trasition": "" }, on: { focus: t.openMenu, blur: t.closeMenu }, scopedSlots: e._u([{ key: "activator", fn: function({ on: o }) {
      return [s(t.SelectActivator, e._b({ ref: "activatorRef", attrs: { "label-id": a, uuid: t.uuid }, on: { "input:search": t.setSearchTerm, control: o, "arrow-down": function(r) {
        return t.setInitialFocusByNodeIndex();
      }, "remove-item": t.removeSelectedItem } }, "SelectActivator", t.activatorProps, !1))];
    } }, { key: "default", fn: function() {
      return [s(t.XCard, { ref: "menuRef", class: e.$style.dropdownMenu, style: t.menuStyles, attrs: { padding: "0px", "border-radius": "var(--border-radius-small)", elevation: "high" } }, [s("span", { directives: [{ name: "show", rawName: "v-show", value: t.canShowEmptySearchMessage, expression: "canShowEmptySearchMessage" }], class: e.$style.emptySearchResultsMessage, attrs: { role: "alert", "aria-live": "polite", "data-testid": t.formatTestId("emptySearchMessage") } }, [e._v(" " + e._s(t.t("ds.xSelect.searchEmpty")) + " ")]), s(t.ListItemsContainer, { directives: [{ name: "show", rawName: "v-show", value: !t.canShowEmptySearchMessage, expression: "!canShowEmptySearchMessage" }], ref: "menuListRef", class: e.$style.menuList, attrs: { id: t.uuid, role: "listbox", "aria-multiselectable": e.multiple, "data-testid": t.formatTestId("menuList"), items: t.itemsList, "virtualized-list": e.virtualizedList }, on: { "mounted:virtualized-list": t.focusFirstItemOnOpen }, scopedSlots: e._u([{ key: "before", fn: function() {
        return [t.canShowCreateNewItemLabel ? s(t.XListItem, { attrs: { tag: "li", "data-testid": t.getMenuItemTestId(t.searchTerm) }, on: { click: function(o) {
          t.createNewItem(), t.cleanSearch();
        } } }, [e._v(" " + e._s(e.createNewItemLabel) + ' "' + e._s(t.searchTerm) + '" ')]) : e._e()];
      }, proxy: !0 }, { key: "default", fn: function({ list: o }) {
        return e._l(o, function(r, d) {
          return s(t.XListItem, { key: t.getItemKey(d, r), ref: "itemsListRef", refInFor: !0, class: e.$style.listItem, attrs: { tag: "li", role: t.checkIfIsValidOption(r) && "option", "aria-readOnly": !t.checkIfIsValidOption(r), "data-index": r.index || d, "aria-selected": t.isItemAlreadySelected(r), "data-testid": t.getMenuItemTestId(r), disabled: r.disabled, active: t.isItemAlreadySelected(r), checkbox: e.multiple && !r.header, separator: !!r.header, "no-clickable": r.noClickable, "icon-style": r.iconStyle, icon: r.icon, ellipsis: "" }, on: { click: function(c) {
            return t.handleSelectItem(r);
          }, keydown: function(c) {
            return t.handleItemKeyboard(r, c);
          } }, scopedSlots: e._u([{ key: "badge", fn: function({ badgeClass: c }) {
            return [r.isBeta ? s(t.XBadge, { class: c, attrs: { icon: "gem", color: "brand-primary", size: "sm" } }, [e._v(" " + e._s(e.betaBadgeText) + " ")]) : e._e(), r.new ? s(t.XBadge, { class: c, attrs: { icon: "sparkles", color: "brand-primary", size: "sm" } }, [e._v(" " + e._s(e.newBadgeText) + " ")]) : e._e()];
          } }], null, !0) }, [r.header ? [e._v(" " + e._s(r.header) + " ")] : [e._t("default", function() {
            return [s("span", { class: e.$style.listItemText, attrs: { title: r.text }, domProps: { innerHTML: e._s(r.highlighted || r.text) } })];
          })]], 2);
        });
      } }], null, !0) })], 1)];
    }, proxy: !0 }], null, !0) })];
  } }]) });
}, Ly = [];
const ja = {
  $style: Cy
};
function Dy(n) {
  for (var e in ja)
    this[e] = ja[e];
}
var My = /* @__PURE__ */ x(
  By,
  ky,
  Ly,
  !1,
  Dy
);
const Ay = My.exports, ke = {
  rounded: {
    name: "rounded",
    class: "isRounded"
  },
  circle: {
    name: "circle",
    class: "isCircle"
  }
}, Oy = ["", ...Object.keys(ke)], Fy = "_xSkeletonLoader_ogmln_1", Ey = "_wave_ogmln_1", Ry = "_isRounded_ogmln_18", Ny = "_isCircle_ogmln_21", Xy = {
  xSkeletonLoader: Fy,
  wave: Ey,
  isRounded: Ry,
  isCircle: Ny
}, { createTestIdProp: qa, setupTestId: Ha } = S(), Vy = {
  name: "XSkeletonLoader"
}, zy = /* @__PURE__ */ Object.assign(Vy, {
  props: {
    height: {
      type: String,
      default: "100px"
    },
    width: {
      type: String,
      default: "100%"
    },
    shape: {
      type: String,
      default: "",
      validator: (n) => Oy.includes(n)
    },
    ...qa()
  },
  setup(n) {
    const e = n, s = D(), { t } = W(), { formatTestId: a } = Ha(e), o = l(() => e.shape === ke.circle.name), r = l(() => e.shape === ke.rounded.name), d = l(() => ({
      width: e.width,
      height: o.value ? e.width : e.height
    })), c = l(() => ({
      [s[ke.rounded.class]]: r.value,
      [s[ke.circle.class]]: o.value
    }));
    return { __sfc: !0, createTestIdProp: qa, setupTestId: Ha, props: e, $style: s, t, formatTestId: a, isCircle: o, isRounded: r, loaderStyles: d, loaderClasses: c };
  }
});
var jy = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: [t.$style.xSkeletonLoader, t.loaderClasses], style: t.loaderStyles, attrs: { role: "progressbar", "aria-busy": "true", "aria-label": t.t("ds.xSkeletonLoader.loading"), "data-testid": t.formatTestId() } });
}, qy = [];
const Wa = {
  $style: Xy
};
function Hy(n) {
  for (var e in Wa)
    this[e] = Wa[e];
}
var Wy = /* @__PURE__ */ x(
  zy,
  jy,
  qy,
  !1,
  Hy
);
const pt = Wy.exports, Ky = {
  name: "XCheckbox",
  components: { BaseOption: Pe },
  model: Se
}, Uy = /* @__PURE__ */ Object.assign(Ky, {
  props: Te,
  emits: Z,
  setup(n) {
    const { v2Listeners: e } = U(["change"]);
    return { __sfc: !0, v2Listeners: e, BaseOption: Pe, changeEvent: me };
  }
});
var Gy = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.BaseOption, e._g(e._b({ attrs: { type: "switch" }, on: e._d({}, [t.changeEvent, (a) => e.$emit(t.changeEvent, a)]) }, "BaseOption", { ...e.$props, ...e.$attrs }, !1), t.v2Listeners), [e._t("default")], 2);
}, Zy = [], Yy = /* @__PURE__ */ x(
  Uy,
  Gy,
  Zy,
  !1,
  null
);
const Jy = Yy.exports, { createHeightProps: Qy } = De(), { createTestIdProp: eb } = S(), { createVModelProp: tb } = se(), sb = "5.6rem";
function ft() {
  const n = {
    loading: {
      type: Boolean,
      default: !1
    },
    checkable: {
      type: Boolean,
      default: !1
    },
    ...eb()
  }, e = {
    maxRowLines: {
      type: Number,
      default: 1
    },
    ...Qy({
      height: sb
    })
  }, s = {
    checked: {
      type: [String, Number, Boolean, Array, Object],
      default: !1
    },
    canShowIconSpace: {
      type: Boolean,
      default: !1
    },
    ...tb([Boolean, Array, String], !1)
  };
  return {
    globalProps: n,
    rowProps: e,
    firstColumnProps: s
  };
}
const nb = "_firstColumn_1s3dt_1", ab = {
  firstColumn: nb
}, { setupTestId: Ka } = S(), { setupVModel: Ua } = se(), { globalProps: Ga, firstColumnProps: Za } = ft(), ob = {
  name: "FirstColumn",
  components: {
    XIcon: B,
    XCheckbox: Fe
  },
  model: Se
}, rb = /* @__PURE__ */ Object.assign(ob, {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    role: {
      type: String,
      default: "cell"
    },
    ...Ga,
    ...Za
  },
  emits: ["select:item", ...Z],
  setup(n, { emit: e }) {
    const s = n, { data: t } = Ua(s, e), { formatTestId: a } = Ka(s), o = l(() => {
      var i, _;
      return (_ = (i = s.item) == null ? void 0 : i.icon) == null ? void 0 : _.name;
    }), r = {
      name: "chevron-right"
    }, d = l(() => {
      var i, _, f, p;
      return {
        icon: ((_ = (i = s.item) == null ? void 0 : i.icon) == null ? void 0 : _.name) || r.name,
        iconStyle: ((p = (f = s.item) == null ? void 0 : f.icon) == null ? void 0 : p.style) || "fal",
        fixedWidth: !0
      };
    }), c = l(() => {
      var i, _;
      return {
        visibility: o.value ? "visible" : "hidden",
        fontColor: ((_ = (i = s.item) == null ? void 0 : i.icon) == null ? void 0 : _.color) || "currentColor"
      };
    }), u = l(() => {
      var i;
      return ((i = s.item) == null ? void 0 : i._raw) ?? s.item;
    });
    return { __sfc: !0, setupTestId: Ka, setupVModel: Ua, globalProps: Ga, firstColumnProps: Za, props: s, emit: e, isChecked: t, formatTestId: a, isValidIcon: o, invisibleIcon: r, iconProps: d, iconStyle: c, rawItem: u, XCheckbox: Fe, XIcon: B };
  }
});
var lb = function() {
  var a;
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return !e.loading && (e.canShowIconSpace || e.checkable) ? s("div", { class: e.$style.firstColumn, attrs: { role: e.role } }, [e.checkable ? s(t.XCheckbox, { attrs: { disabled: (a = e.item) == null ? void 0 : a.disabled, "data-testid": t.formatTestId("checkbox"), name: "table-row", value: t.rawItem }, model: { value: t.isChecked, callback: function(o) {
    t.isChecked = o;
  }, expression: "isChecked" } }) : e._e(), e.canShowIconSpace ? s(t.XIcon, e._b({ class: e.$style.icon, style: t.iconStyle }, "XIcon", t.iconProps, !1)) : e._e()], 1) : e._e();
}, ib = [];
const Ya = {
  $style: ab
};
function cb(n) {
  for (var e in Ya)
    this[e] = Ya[e];
}
var db = /* @__PURE__ */ x(
  rb,
  lb,
  ib,
  !1,
  cb
);
const We = db.exports, ub = "_XTableRow_1uy3u_1", _b = "_row_1uy3u_6", pb = "_cell_1uy3u_11", fb = {
  XTableRow: ub,
  row: _b,
  cell: pb
}, { getHeightStyles: Ja } = De(), { setupTestId: Qe } = S(), { setupVModel: Qa } = se(), { globalProps: eo, rowProps: to, firstColumnProps: so } = ft(), mb = {
  name: "XTableRow",
  components: {
    XListItem: oe,
    XSkeletonLoader: pt,
    FirstColumn: We,
    XEllipsis: K
  },
  model: Se
}, vb = /* @__PURE__ */ Object.assign(mb, {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    headers: {
      type: Array,
      default: () => []
    },
    gridTemplateColumns: {
      type: String,
      required: !0
    },
    ...eo,
    ...to,
    ...so
  },
  emits: Z,
  setup(n, { emit: e }) {
    const s = n, { data: t } = Qa(s, e), { heightStyles: a } = Ja(s), { formatTestId: o } = Qe(s), { formatTestId: r } = Qe(s.item);
    function d(i, _) {
      return (i == null ? void 0 : i[_.value]) ?? "";
    }
    function c(i) {
      return {
        textAlign: (i == null ? void 0 : i.align) || "left"
      };
    }
    const u = l(() => r("row") || o("row"));
    return { __sfc: !0, getHeightStyles: Ja, setupTestId: Qe, setupVModel: Qa, globalProps: eo, rowProps: to, firstColumnProps: so, props: s, emit: e, isChecked: t, heightStyles: a, formatTestId: o, formatItemTestId: r, getValueByHeader: d, getColumnStyle: c, rowCheckboxDataTestId: u, XSkeletonLoader: pt, XListItem: oe, XEllipsis: K, FirstColumn: We };
  }
});
var gb = function() {
  var a, o;
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XListItem, e._b({ class: e.$style.XTableRow, attrs: { role: "row", tag: "li", "no-clickable": "", disabled: (a = e.item) == null ? void 0 : a.disabled, "data-testid": (o = e.item) == null ? void 0 : o.dataTestid }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [s(t.FirstColumn, { attrs: { item: e.item, checkable: e.checkable, loading: e.loading, "can-show-icon-space": e.canShowIconSpace, "data-testid": t.rowCheckboxDataTestId }, model: { value: t.isChecked, callback: function(r) {
      t.isChecked = r;
    }, expression: "isChecked" } }), s("div", { class: e.$style.row, style: {
      gridTemplateColumns: e.gridTemplateColumns
    }, attrs: { "data-testid": t.formatTestId("row") } }, e._l(e.headers, function(r) {
      return s("div", { key: `cell-${r.value}`, class: e.$style.cell, style: t.getColumnStyle(r), attrs: { role: "cell" } }, [e.loading ? s(t.XSkeletonLoader, { attrs: { type: "rect", rounded: "", height: "24px", width: "100%", "data-testid": t.formatTestId("rowSkeletonLoader") } }) : s(t.XEllipsis, { attrs: { title: t.getValueByHeader(e.item, r), "visible-lines": e.maxRowLines, "data-testid": t.formatTestId("rowCellContent") } }, [e._t("column", function() {
        return [e._v(" " + e._s(t.getValueByHeader(e.item, r)) + " ")];
      }, { column: r, columnValue: t.getValueByHeader(e.item, r) })], 2)], 1);
    }), 0)];
  }, proxy: !0 }]) }, "XListItem", t.heightStyles, !1));
}, hb = [];
const no = {
  $style: fb
};
function yb(n) {
  for (var e in no)
    this[e] = no[e];
}
var bb = /* @__PURE__ */ x(
  vb,
  gb,
  hb,
  !1,
  yb
);
const mt = bb.exports;
function $b(n) {
  function s(c, u, i) {
    return (c - u) / i;
  }
  function t() {
    return n.headers.reduce(
      (c, u) => c + ((u == null ? void 0 : u.colspan) || 0),
      0
    );
  }
  function a() {
    return n.headers.filter((c) => !c.colspan).length;
  }
  const o = l(() => s(16, t(), a())), r = l(
    () => n.headers.map(({ colspan: c }) => c || o.value)
  );
  return {
    gridTemplateColumns: l(
      () => r.value.map((c) => `${c}fr`).join(" ")
    )
  };
}
const Ib = "_XTable_1mo7m_1", xb = "_header_1mo7m_4", Tb = "_headerRow_1mo7m_14", Sb = "_headerCol_1mo7m_18", Pb = "_sortable_1mo7m_29", Cb = "_isDisabled_1mo7m_32", wb = "_sortIcon_1mo7m_41", Bb = "_rowsContainer_1mo7m_44", kb = {
  XTable: Ib,
  header: xb,
  headerRow: Tb,
  headerCol: Sb,
  sortable: Pb,
  isDisabled: Cb,
  sortIcon: wb,
  rowsContainer: Bb
}, { getHeightStyles: ao } = De(), { setupTestId: oo } = S(), { globalProps: ro, rowProps: lo } = ft(), pe = {
  none: {
    icon: "arrow-up-arrow-down",
    value: null
  },
  asc: {
    icon: "arrow-up",
    value: "asc"
  },
  desc: {
    icon: "arrow-down",
    value: "desc"
  }
}, Lb = {
  name: "XTable",
  components: {
    XTableRow: mt,
    XIcon: B,
    FirstColumn: We
  }
}, Db = Object.assign(Lb, {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    noHeader: {
      type: Boolean,
      default: !1
    },
    previewLoadingRows: {
      type: Number,
      default: 5
    },
    icon: {
      type: Object,
      default: null
    },
    ...ro,
    ...lo
  },
  emits: ["sort", "select:all", ...Z],
  setup(n, { emit: e }) {
    const s = n, t = y(me), a = y({}), o = y([]), { formatTestId: r } = oo(s), { heightStyles: d } = ao(s);
    function c(h) {
      return {
        ...h,
        icon: (h == null ? void 0 : h.icon) || s.icon,
        _raw: h
      };
    }
    function u(h, M = !0) {
      if (!h.sortable) return;
      const X = a.value[h.value], V = Object.values(pe).findIndex(
        (E) => E.value === X
      ), F = Object.values(pe)[(V + 1) % Object.values(pe).length].value, N = M ? F : (h == null ? void 0 : h.order) || pe.none.value, b = {
        ...a.value
      }, P = {
        [h.value]: N
      };
      a.value = {
        ...b,
        ...P
      }, M && e("sort", N, h);
    }
    function i() {
      s.headers.length > 0 && s.headers.forEach((h) => u(h, !1));
    }
    const _ = l(() => s.items.filter((h) => !h.disabled)), f = l(() => {
      var h;
      return !!((h = _.value) != null && h.length);
    }), p = l(
      () => f.value && o.value.length === _.value.length
    );
    function m(h) {
      o.value = h ? _.value : [], e("select:all", o.value);
    }
    function v(h) {
      const M = a.value[h];
      return M ? pe[M].icon : pe.none.icon;
    }
    const I = l(() => {
      var h, M;
      return ((h = s.items) == null ? void 0 : h.length) > 0 && s.previewLoadingRows > ((M = s.items) == null ? void 0 : M.length) ? s.items.length : s.previewLoadingRows;
    }), g = l(
      () => s.loading ? Array.from({ length: I.value }, c) : s.items.map(c)
    ), T = l(() => g.value.some((h) => h.icon)), k = l(() => r("headerRow")), { gridTemplateColumns: L } = $b(s), O = l(() => ({
      [dt]: p.value,
      checkable: s.checkable,
      loading: s.loading,
      canShowIconSpace: T.value
    }));
    return Zo(() => {
      i();
    }), { __sfc: !0, getHeightStyles: ao, setupTestId: oo, globalProps: ro, rowProps: lo, VALID_SORT_ORDERS: pe, props: s, emit: e, changeEventName: t, columnsSortOrder: a, selectedRows: o, formatTestId: r, heightStyles: d, transformRow: c, handleColumnSort: u, sortColumnsBeforeMount: i, enabledItems: _, hasItems: f, isSelectedAll: p, selectAllRows: m, getColumnSortOrderIcon: v, loadingRows: I, tableItems: g, doesAnyRowHaveIcon: T, headerRowDataTestId: k, gridTemplateColumns: L, firstColumnProps: O, XIcon: B, changeEvent: me, XTableRow: mt, FirstColumn: We };
  }
});
var Mb = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: e.$style.XTable, attrs: { role: "table", "data-testid": e.dataTestid } }, [s("div", { class: e.$style.header, attrs: { role: "rowgroup" } }, [t.hasItems ? s(t.FirstColumn, e._b({ attrs: { "data-testid": t.headerRowDataTestId, role: "columnheader" }, on: e._d({}, [t.changeEventName, t.selectAllRows]) }, "FirstColumn", t.firstColumnProps, !1)) : e._e(), e.noHeader ? e._e() : s("div", { class: e.$style.headerRow, style: {
    gridTemplateColumns: t.gridTemplateColumns
  }, attrs: { role: "row", "data-testid": t.headerRowDataTestId } }, e._l(e.headers, function(a, o) {
    return s("div", { key: `header-${a.value}`, class: [e.$style.headerCol, a.sortable && e.$style.sortable], attrs: { role: "columnheader", "data-testid": t.formatTestId(`headerCol-${a.label}`), tabindex: a.sortable ? "0" : "-1" }, on: { click: function(r) {
      return t.handleColumnSort(a);
    }, keyup: function(r) {
      return !r.type.indexOf("key") && e._k(r.keyCode, "enter", 13, r.key, "Enter") ? null : t.handleColumnSort(a);
    } } }, [e._t(`header-${a.value}`, function() {
      return [e._v(" " + e._s(a.label) + " ")];
    }, { index: o, header: a }), a.sortable ? s(t.XIcon, { class: e.$style.sortIcon, attrs: { icon: t.getColumnSortOrderIcon(a.value) } }) : e._e()], 2);
  }), 0)], 1), s("ul", { class: e.$style.rowsContainer, attrs: { role: "rowgroup" } }, [e._l(t.tableItems, function(a, o) {
    return e._t(a != null && a.slot ? `item-${a.slot}` : "item", function() {
      return [s(t.XTableRow, e._b({ key: `row-${o}`, attrs: { item: a, headers: e.headers, "max-row-lines": e.maxRowLines, "grid-template-columns": t.gridTemplateColumns, loading: e.loading, checkable: e.checkable, "can-show-icon-space": t.doesAnyRowHaveIcon, "data-testid": e.dataTestid }, on: e._d({}, [t.changeEventName, (r) => e.$emit(t.changeEvent, r)]), scopedSlots: e._u([{ key: "column", fn: function({ column: r }) {
        return [e._t(`item-${a.slot}-col-${r.value}`, null, { item: a, column: r }), e._t(`items-col-${r.value}`, null, { item: a, column: r })];
      } }], null, !0), model: { value: t.selectedRows, callback: function(r) {
        t.selectedRows = r;
      }, expression: "selectedRows" } }, "XTableRow", t.heightStyles, !1))];
    }, null, {
      item: a,
      index: o,
      headers: e.headers,
      gridTemplateColumns: t.gridTemplateColumns,
      selectedRows: t.selectedRows,
      doesAnyRowHaveIcon: t.doesAnyRowHaveIcon,
      dataTestid: e.dataTestid,
      heightStyles: t.heightStyles
    });
  })], 2)]);
}, Ab = [];
const io = {
  $style: kb
};
function Ob(n) {
  for (var e in io)
    this[e] = io[e];
}
var Fb = /* @__PURE__ */ x(
  Db,
  Mb,
  Ab,
  !1,
  Ob
);
const Eb = Fb.exports;
function Rb(n = {}) {
  const {
    scrollRef: e = y(null),
    currentNavigableNode: s = y(null),
    isHorizontal: t = y(!0)
  } = n, a = y(null), { isScrollRefVisible: o } = cr({
    scrollRef: e,
    isHorizontal: t
  });
  function r(u) {
    var p;
    const i = ((p = e.value) == null ? void 0 : p.scrollLeft) || 0, { offsetLeft: _ = 0, offsetWidth: f = 0 } = u;
    a.value.style.left = `${_ - i}px`, a.value.style.width = `${f}px`;
  }
  function d(u) {
    var p;
    const i = ((p = e.value) == null ? void 0 : p.scrollTop) || 0, { offsetTop: _ = 0, offsetHeight: f = 0 } = u;
    a.value.style.top = `${_ - i}px`, a.value.style.height = `${f}px`;
  }
  function c(u = null) {
    setTimeout(() => {
      var i;
      if (a.value && ((i = a.value) != null && i.style)) {
        const _ = u || s.value || {};
        t.value ? r(_) : d(_);
      }
    }, 0);
  }
  return R(
    () => o.value,
    () => {
      c();
    }
  ), {
    activeBarRef: a,
    setActiveBarPosition: c
  };
}
function Nb(n, e) {
  const s = D();
  function t(o) {
    return {
      [s.isActive]: o.active,
      [s.isDisabled]: o.disabled
    };
  }
  const a = l(() => ({
    [s.hasScroll]: e.value,
    [s.sizeSmall]: n.size === "sm",
    [s.withoutLine]: n.withoutLine,
    [s.isVertical]: n.orientation === "vertical"
  }));
  return {
    getTabClasses: t,
    tabClasses: a
  };
}
function Xb(n) {
  const { props: e, emit: s } = n, t = y(e.activeTab);
  function a(i) {
    t.value = i, s("update:activeTab", t.value);
  }
  function o(i) {
    return i.name === t.value;
  }
  function r(i, _, f) {
    return () => {
      i && !(i != null && i.active) && !(i != null && i.disabled) && !(i != null && i.blocked) && !o(i) ? f() : _ == null || _.preventDefault();
    };
  }
  function d(i, _) {
    r(i, _, () => {
      a(i.name), s("change", {
        ...i,
        active: o(i)
      });
    })();
  }
  const c = l(() => e.items.filter((i) => !(i != null && i.hidden)).map((i) => {
    const _ = { ...i };
    return _.active = o(i), _;
  })), u = l(
    () => e.activeTab ? c.value.findIndex((i) => i.name === e.activeTab) : 0
  );
  return Zo(() => {
    !t.value && c.value.length > 0 && a(c.value[0].name);
  }), {
    computedTabs: c,
    currentTabName: t,
    initialTabIndex: u,
    changeTab: d,
    canChangeTab: r
  };
}
function Vb() {
  const n = {
    link: "BaseLink",
    button: "button"
  };
  function e(t) {
    return !t.to || t.disabled ? n.button : n.link;
  }
  function s(t) {
    return e(t) === n.button;
  }
  return {
    getTabType: e,
    isTabTypeButton: s
  };
}
const zb = "_xTabs_1qqat_1", jb = "_withoutLine_1qqat_26", qb = "_hasScroll_1qqat_29", Hb = "_activeBar_1qqat_29", Wb = "_sizeSmall_1qqat_32", Kb = "_isVertical_1qqat_38", Ub = "_scroll_1qqat_50", Gb = "_tabList_1qqat_54", Zb = "_arrow_1qqat_66", Yb = "_tab_1qqat_54", Jb = "_isActive_1qqat_77", Qb = "_isDisabled_1qqat_77", e$ = "_scrollContainer_1qqat_86", t$ = "_arrowRight_1qqat_128", s$ = "_tabTitle_1qqat_169", n$ = "_tabTooltip_1qqat_174", a$ = {
  xTabs: zb,
  withoutLine: jb,
  hasScroll: qb,
  activeBar: Hb,
  sizeSmall: Wb,
  isVertical: Kb,
  scroll: Ub,
  tabList: Gb,
  arrow: Zb,
  tab: Yb,
  isActive: Jb,
  isDisabled: Qb,
  scrollContainer: e$,
  arrowRight: t$,
  tabTitle: s$,
  tabTooltip: n$
}, { createPlacementProp: Ir } = Ie(), { placement: co } = Ir(), { createTestIdProp: uo, setupTestId: _o } = S(), o$ = {
  name: "XTabs",
  components: { XIcon: B, XTooltip: Oe, XButton: ae, BaseLink: xe, XEllipsis: K }
}, r$ = /* @__PURE__ */ Object.assign(o$, {
  props: {
    /**
     * Array of tab objects, where each object represents a tab.
     * @type {Tab[]}
     */
    items: {
      type: Array,
      default: () => [],
      validator: (n) => {
        const e = ["name", "title"];
        return n.every(
          (s) => e.every((t) => t in s ? !0 : (console.error(
            `One of the objects in prop items does not contain the property ${t}`,
            s
          ), !1))
        );
      }
    },
    activeTab: {
      type: String,
      default: ""
    },
    withoutLine: {
      type: Boolean,
      default: !1
    },
    orientation: {
      type: String,
      default: "horizontal",
      validation: (n) => ["horizontal", "vertical"].includes(n)
    },
    size: {
      type: String,
      default: "",
      validation: (n) => ["", "sm"].includes(n)
    },
    tooltipPlacement: co,
    ...uo()
  },
  emits: ["change", "click:tab", "update:activeTab"],
  setup(n, { emit: e }) {
    const s = n, t = y([]), a = y(null), o = y(null), { formatTestId: r } = _o(s), d = l(() => s.orientation), c = l(() => s.orientation === "horizontal"), { computedTabs: u, changeTab: i, initialTabIndex: _, canChangeTab: f } = Xb({
      props: s,
      emit: e
    }), { handleNavigationKeyboard: p, handleNavigationByItemIndex: m, currentNavigableNode: v } = lr({
      itemsList: l(() => s.items),
      itemsListRef: t,
      horizontal: c.value,
      initialPosition: _.value,
      callBack: (A, H) => {
        f(A, H, () => {
          i(A, H), g();
        })();
      }
    }), { activeBarRef: I, setActiveBarPosition: g } = Rb({
      scrollRef: o,
      currentNavigableNode: v,
      isHorizontal: c
    }), { isScrollNotAtStart: T, isScrollNotAtEnd: k, hasScroll: L, scrollNext: O, scrollPrev: h, handleScroll: M } = cr({
      scrollRef: o,
      isHorizontal: c,
      callBack: g
    }), { getTabClasses: X, tabClasses: V } = Nb(s, L), { getTabType: F, isTabTypeButton: N } = Vb(), b = l(() => s.size === "sm" ? "xs" : "sm");
    function P(A) {
      return !!(A != null && A.tooltipText);
    }
    function E(A, H) {
      return A.disabled ? null : H;
    }
    function G(A) {
      return !N(A) && "_self";
    }
    function re(A) {
      return A.active && !(A != null && A.disabled) ? 0 : -1;
    }
    function be(A, H, Ce) {
      e("click:tab", A), f(A, Ce, () => {
        m(H);
      })();
    }
    function ue(A) {
      const H = `${A.name}-tab`;
      return A.dataTestId || r(H);
    }
    return R(
      () => _.value,
      (A) => {
        m(A);
      }
    ), { __sfc: !0, createPlacementProp: Ir, placement: co, createTestIdProp: uo, setupTestId: _o, props: s, emit: e, itemsListRef: t, tabsHeaderElement: a, scrollRef: o, formatTestId: r, ariaOrientation: d, isHorizontal: c, computedTabs: u, changeTab: i, initialTabIndex: _, canChangeTab: f, handleNavigationKeyboard: p, handleNavigationByItemIndex: m, currentNavigableNode: v, activeBarRef: I, setActiveBarPosition: g, isScrollNotAtStart: T, isScrollNotAtEnd: k, hasScroll: L, scrollNext: O, scrollPrev: h, handleScroll: M, getTabClasses: X, tabClasses: V, getTabType: F, isTabTypeButton: N, navButtonSize: b, hasTooltip: P, getTabDataIndex: E, getTabTarget: G, getTabindex: re, handleChangeTab: be, getTabDataTestId: ue, XIcon: B, XTooltip: Oe, XEllipsis: K, XButton: ae };
  }
});
var l$ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s("div", { class: [e.$style.xTabs, t.tabClasses], attrs: { "data-testid": t.formatTestId() } }, [t.hasScroll ? s(t.XButton, { directives: [{ name: "show", rawName: "v-show", value: t.isScrollNotAtStart, expression: "isScrollNotAtStart" }], class: e.$style.arrow, attrs: { "data-testid": t.formatTestId("prevButton"), size: t.navButtonSize, "border-radius": "circle", design: "text" }, on: { click: function(a) {
    return t.scrollPrev();
  } } }, [s(t.XIcon, { attrs: { icon: "chevron-left" } })], 1) : e._e(), t.hasScroll ? s(t.XButton, { directives: [{ name: "show", rawName: "v-show", value: t.isScrollNotAtEnd, expression: "isScrollNotAtEnd" }], class: [e.$style.arrow, e.$style.arrowRight], attrs: { "data-testid": t.formatTestId("nextButton"), size: t.navButtonSize, "border-radius": "circle", design: "text" }, on: { click: function(a) {
    return t.scrollNext();
  } } }, [s(t.XIcon, { attrs: { icon: "chevron-right" } })], 1) : e._e(), s("div", { class: e.$style.scrollContainer }, [s("div", { ref: "activeBarRef", class: e.$style.activeBar, attrs: { "data-testid": t.formatTestId("activeBar") } }), s("div", { ref: "scrollRef", class: e.$style.scroll, attrs: { "data-testid": t.formatTestId("scroll") }, on: { scroll: t.handleScroll } }, [s("div", { ref: "tabsHeaderElement", class: e.$style.tabList, attrs: { "aria-orientation": t.ariaOrientation, role: "tablist" } }, e._l(t.computedTabs, function(a, o) {
    return s(t.getTabType(a), { key: o, ref: "itemsListRef", refInFor: !0, tag: "Component", class: [e.$style.tab, t.getTabClasses(a)], attrs: { to: a.to, native: a.native, "aria-disabled": a.disabled, "data-index": t.getTabDataIndex(a, o), "data-testid": t.getTabDataTestId(a), target: t.getTabTarget(a), "aria-selected": `${a.active}`, tabindex: t.getTabindex(a), "aria-controls": `panel-${a.name}`, role: "tab" }, on: { click: function(r) {
      return t.handleChangeTab(a, o, r);
    }, keydown: t.handleNavigationKeyboard } }, [a != null && a.icon ? s(t.XIcon, { attrs: { icon: a.icon, "icon-style": a.iconStyle, "fixed-width": !t.isHorizontal, "data-testid": t.formatTestId(`${a.name}-tabIcon`) } }) : e._e(), s(t.XEllipsis, { class: e.$style.tabTitle, attrs: { id: `tab-${a.name}`, "data-testid": t.formatTestId(`${a.name}-tabText`) } }, [e._v(" " + e._s(a.title) + " ")]), t.hasTooltip(a) ? s(t.XTooltip, { class: e.$style.tabTooltip, attrs: { placement: e.tooltipPlacement, "data-testid": t.formatTestId(`${a.name}-tabTooltip`) }, scopedSlots: e._u([{ key: "activator", fn: function() {
      return [s(t.XIcon, { attrs: { icon: "question-circle", "fixed-width": !t.isHorizontal } })];
    }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(a.tooltipText) + " ")]) : e._e(), e._t(`after-title-${a.name}`), e._t("after-title", null, { tab: a })], 2);
  }), 1)])])], 1);
}, i$ = [];
const po = {
  $style: a$
};
function c$(n) {
  for (var e in po)
    this[e] = po[e];
}
var d$ = /* @__PURE__ */ x(
  r$,
  l$,
  i$,
  !1,
  c$
);
const u$ = d$.exports;
function _$(n) {
  const e = y(null), s = [
    "[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
  ];
  function t() {
    var o, r, d;
    return (o = n.value) != null && o.querySelectorAll ? ((d = (r = n.value) == null ? void 0 : r.querySelectorAll(s)) == null ? void 0 : d.length) > 0 : !1;
  }
  function a() {
    e.value = t();
  }
  return Mr(() => {
    a();
  }), R(
    n,
    () => {
      a();
    },
    {
      immediate: !0
    }
  ), {
    hasFocusableElements: e,
    setHasFocusableElements: a
  };
}
const p$ = "_XTabsPanel_apjzn_1", f$ = {
  XTabsPanel: p$
}, { createTestIdProp: fo, setupTestId: mo } = S(), m$ = {
  name: "XTabsPanel"
}, v$ = /* @__PURE__ */ Object.assign(m$, {
  props: {
    tabName: {
      type: String,
      default: ""
    },
    activeTab: {
      type: String,
      default: null
    },
    isAlwaysVisible: {
      type: Boolean,
      default: !1
    },
    ...fo()
  },
  setup(n) {
    const e = n, s = y(null), { formatTestId: t } = mo(e), { hasFocusableElements: a } = _$(s), o = l(() => e.tabName === e.activeTab || e.isAlwaysVisible);
    return { __sfc: !0, createTestIdProp: fo, setupTestId: mo, props: e, activePanelElement: s, formatTestId: t, hasFocusableElements: a, canShowPanel: o };
  }
});
var g$ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return t.canShowPanel ? s("div", { ref: "activePanelElement", class: e.$style.XTabsPanel, attrs: { id: `panel-${e.tabName}`, "aria-labelledby": `tab-${e.tabName}`, "data-testid": t.formatTestId(`${e.tabName}-panel`), role: "tabpanel", tabindex: t.hasFocusableElements ? -1 : 0 } }, [e._t("default")], 2) : e._e();
}, h$ = [];
const vo = {
  $style: f$
};
function y$(n) {
  for (var e in vo)
    this[e] = vo[e];
}
var b$ = /* @__PURE__ */ x(
  v$,
  g$,
  h$,
  !1,
  y$
);
const $$ = b$.exports, I$ = "_textArea_1wntb_1", x$ = "_input_1wntb_12", T$ = "_hasError_1wntb_30", S$ = {
  textArea: I$,
  input: x$,
  hasError: T$
}, go = ["both", "horizontal", "vertical", "none"], { createFullWidthProp: ho } = Q(), { createDisabledProp: yo } = q(), { createTestIdProp: bo, setupTestId: $o } = S(), { createValidationsProp: Io } = Me(), { createVModelProp: xo, setupVModel: To } = se(), {
  createMessageProps: So,
  createAdditionalMessagesProp: Po,
  createLabelProps: Co,
  createFormFieldProps: wo,
  createInputProps: Bo,
  createRequiredProp: ko
} = ge(), P$ = {
  name: "XTextArea",
  components: { XFormField: ee },
  inheritAttrs: !1
}, C$ = Object.assign(P$, {
  props: {
    readonly: {
      type: Boolean,
      default: !1
    },
    textAreaClasses: {
      type: Array,
      default: () => []
    },
    maxlength: {
      type: [String, Number],
      default: ""
    },
    minHeight: {
      type: String,
      default: "210px"
    },
    maxHeight: {
      type: String,
      default: null
    },
    resize: {
      type: String,
      default: "both",
      validator: (n) => go.includes(n)
    },
    ...So(),
    ...Po(),
    ...Io(),
    ...Co(),
    ...wo(),
    ...Bo(),
    ...ko(),
    ...xo(),
    ...or(),
    ...yo(),
    ...ho(),
    ...bo()
  },
  emits: ["input", "keyup", "click", "blur", "update:modelValue"],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = $o(s), a = D(), { inputRef: o } = rr(s), { data: r } = To(s, e), d = y(null), c = l(() => ({
      [a.hasError]: d.value
    })), u = l(() => ({
      maxHeight: s.maxHeight,
      minHeight: s.minHeight,
      resize: s.resize
    })), i = l(() => parseInt(s.maxHeight, 10));
    function _(p) {
      d.value = p;
    }
    function f(p) {
      if (!(s.maxHeight && p.target.scrollHeight >= i.value) && (o.value.style.height = "auto", p.target.scrollHeight > p.target.clientHeight)) {
        const I = p.target.offsetHeight - p.target.clientHeight, g = `${p.target.scrollHeight + I}px`;
        o.value.style.height = g;
      }
    }
    return { __sfc: !0, RESIZE_DIRECTIONS: go, createFullWidthProp: ho, createDisabledProp: yo, createTestIdProp: bo, setupTestId: $o, createValidationsProp: Io, createVModelProp: xo, setupVModel: To, createMessageProps: So, createAdditionalMessagesProp: Po, createLabelProps: Co, createFormFieldProps: wo, createInputProps: Bo, createRequiredProp: ko, props: s, emit: e, formatTestId: t, $style: a, inputRef: o, internalValue: r, hasError: d, errorClass: c, xTextAreaStyles: u, maxHeightNumber: i, handleError: _, setHeightToFitContent: f, XFormField: ee };
  }
});
var w$ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XFormField, e._b({ class: t.$style.textArea, attrs: { "data-testid": t.formatTestId("field") }, on: { error: t.handleError }, scopedSlots: e._u([{ key: "default", fn: function({ uuid: a }) {
    return [s("textarea", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], ref: "inputRef", class: [t.$style.input, t.errorClass, ...e.textAreaClasses], style: t.xTextAreaStyles, attrs: { id: a, name: e.name, disabled: e.disabled, readonly: e.readonly, required: e.required, maxlength: e.maxlength, "data-testid": t.formatTestId(), autofocus: e.autofocus, placeholder: e.placeholder }, domProps: { value: t.internalValue }, on: { input: [function(o) {
      o.target.composing || (t.internalValue = o.target.value);
    }, t.setHeightToFitContent], keyup: function(o) {
      return e.$emit("keyup", o);
    }, click: function(o) {
      return e.$emit("click", o);
    }, blur: function(o) {
      return e.$emit("blur", o);
    } } })];
  } }]) }, "XFormField", { ...e.$props, ...e.$attrs }, !1));
}, B$ = [];
const Lo = {
  $style: S$
};
function k$(n) {
  for (var e in Lo)
    this[e] = Lo[e];
}
var L$ = /* @__PURE__ */ x(
  C$,
  w$,
  B$,
  !1,
  k$
);
const D$ = L$.exports, M$ = "_XTextInput_k936a_1", A$ = "_container_k936a_12", O$ = "_hasIcon_k936a_17", F$ = "_icon_k936a_17", E$ = "_input_k936a_27", R$ = "_hasError_k936a_30", N$ = {
  XTextInput: M$,
  container: A$,
  hasIcon: O$,
  icon: F$,
  input: E$,
  hasError: R$
}, { createIconProps: Do } = ce(), { createFullWidthProp: Mo } = Q(), { createDisabledProp: Ao, getDisabledClass: Oo } = q(), { createTestIdProp: Fo, setupTestId: Eo } = S(), { createValidationsProp: Ro } = Me(), { createVModelProp: No, setupVModel: Xo } = se(), {
  createMessageProps: Vo,
  createAdditionalMessagesProp: zo,
  createLabelProps: jo,
  createFormFieldProps: qo,
  createInputProps: Ho,
  createRequiredProp: Wo
} = ge(), X$ = {
  name: "XTextInput",
  components: { XFormField: ee, XIcon: B },
  inheritAttrs: !1
}, V$ = /* @__PURE__ */ Object.assign(X$, {
  props: {
    maxlength: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    autocomplete: {
      type: String,
      default: "on"
    },
    inputClasses: {
      type: Array,
      default: () => []
    },
    inputWidth: {
      type: String,
      default: "100%"
    },
    ...Vo(),
    ...zo(),
    ...Ro(),
    ...jo(),
    ...qo(),
    ...Ho(),
    ...Do(),
    ...No(),
    ...or(),
    ...Ao(),
    ...Mo(),
    ...Wo(),
    ...Fo()
  },
  emits: ["input", "keyup", "click", "blur", "update:modelValue"],
  setup(n, { emit: e }) {
    const s = n, { formatTestId: t } = Eo(s), a = y(null), o = D(), { disabledClass: r } = Oo(s), { inputRef: d } = rr(s), { data: c } = Xo(s, e), u = l(() => ({
      [o.hasError]: a.value
    })), i = l(() => ({
      [o.hasIcon]: s.icon,
      ...u.value,
      ...r.value
    })), _ = l(() => ({
      maxWidth: s.inputWidth
    }));
    function f(p) {
      a.value = p;
    }
    return { __sfc: !0, createIconProps: Do, createFullWidthProp: Mo, createDisabledProp: Ao, getDisabledClass: Oo, createTestIdProp: Fo, setupTestId: Eo, createValidationsProp: Ro, createVModelProp: No, setupVModel: Xo, createMessageProps: Vo, createAdditionalMessagesProp: zo, createLabelProps: jo, createFormFieldProps: qo, createInputProps: Ho, createRequiredProp: Wo, props: s, emit: e, formatTestId: t, hasError: a, $style: o, disabledClass: r, inputRef: d, internalValue: c, errorClass: u, fieldClasses: i, inputStyles: _, handleError: f, XFormField: ee, XIcon: B };
  }
});
var z$ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.XFormField, e._b({ class: [t.$style.XTextInput, t.fieldClasses], attrs: { "data-testid": t.formatTestId("field") }, on: { error: t.handleError }, scopedSlots: e._u([{ key: "default", fn: function({ uuid: a }) {
    return [e._t("left"), s("div", { class: t.$style.container }, [e.type === "checkbox" ? s("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], ref: "inputRef", class: [t.$style.input, t.errorClass, ...e.inputClasses], style: t.inputStyles, attrs: { id: a, name: e.name, disabled: e.disabled, readonly: e.readonly, required: e.required, maxlength: e.maxlength, autofocus: e.autofocus, placeholder: e.placeholder, autocomplete: e.autocomplete, "data-testid": t.formatTestId(), type: "checkbox" }, domProps: { checked: Array.isArray(t.internalValue) ? e._i(t.internalValue, null) > -1 : t.internalValue }, on: { keyup: function(o) {
      return e.$emit("keyup", o);
    }, click: function(o) {
      return e.$emit("click", o);
    }, blur: function(o) {
      return e.$emit("blur", o);
    }, change: function(o) {
      var r = t.internalValue, d = o.target, c = !!d.checked;
      if (Array.isArray(r)) {
        var u = null, i = e._i(r, u);
        d.checked ? i < 0 && (t.internalValue = r.concat([u])) : i > -1 && (t.internalValue = r.slice(0, i).concat(r.slice(i + 1)));
      } else
        t.internalValue = c;
    } } }) : e.type === "radio" ? s("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], ref: "inputRef", class: [t.$style.input, t.errorClass, ...e.inputClasses], style: t.inputStyles, attrs: { id: a, name: e.name, disabled: e.disabled, readonly: e.readonly, required: e.required, maxlength: e.maxlength, autofocus: e.autofocus, placeholder: e.placeholder, autocomplete: e.autocomplete, "data-testid": t.formatTestId(), type: "radio" }, domProps: { checked: e._q(t.internalValue, null) }, on: { keyup: function(o) {
      return e.$emit("keyup", o);
    }, click: function(o) {
      return e.$emit("click", o);
    }, blur: function(o) {
      return e.$emit("blur", o);
    }, change: function(o) {
      t.internalValue = null;
    } } }) : s("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], ref: "inputRef", class: [t.$style.input, t.errorClass, ...e.inputClasses], style: t.inputStyles, attrs: { id: a, name: e.name, disabled: e.disabled, readonly: e.readonly, required: e.required, maxlength: e.maxlength, autofocus: e.autofocus, placeholder: e.placeholder, autocomplete: e.autocomplete, "data-testid": t.formatTestId(), type: e.type }, domProps: { value: t.internalValue }, on: { keyup: function(o) {
      return e.$emit("keyup", o);
    }, click: function(o) {
      return e.$emit("click", o);
    }, blur: function(o) {
      return e.$emit("blur", o);
    }, input: function(o) {
      o.target.composing || (t.internalValue = o.target.value);
    } } }), e.icon ? s(t.XIcon, { class: t.$style.icon, attrs: { "icon-style": e.iconStyle, icon: e.icon, "fixed-width": "", "data-testid": t.formatTestId("icon") } }) : e._e()], 1), e._t("default")];
  } }], null, !0) }, "XFormField", { ...e.$props, ...e.$attrs }, !1));
}, j$ = [];
const Ko = {
  $style: N$
};
function q$(n) {
  for (var e in Ko)
    this[e] = Ko[e];
}
var H$ = /* @__PURE__ */ x(
  V$,
  z$,
  j$,
  !1,
  q$
);
const W$ = H$.exports, K$ = {
  __name: "XDateTimePicker",
  props: {
    id: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "var(--color-brand-secondary-400)"
    },
    buttonColor: {
      type: String,
      default: "var(--color-brand-secondary-400)"
    },
    dataTestid: {
      type: String,
      default: ""
    },
    maxDate: {
      type: String,
      default: ""
    },
    minDate: {
      type: String,
      default: ""
    },
    noButtonNow: {
      type: Boolean,
      default: !0
    },
    noClearButton: {
      type: Boolean,
      default: !0
    },
    noLabel: {
      type: Boolean,
      default: !0
    },
    noHeader: {
      type: Boolean,
      default: !1
    },
    onlyDate: {
      type: Boolean,
      default: !1
    },
    noShortcuts: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    },
    right: {
      type: Boolean,
      default: !1
    },
    noValueToCustomElem: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Object],
      default: ""
    }
  },
  emits: ["input"],
  setup(n) {
    return { __sfc: !0, activeLocale: Kl, VueCtkDateTimePicker: Wr };
  }
};
var U$ = function() {
  var e = this, s = e._self._c, t = e._self._setupProxy;
  return s(t.VueCtkDateTimePicker, e._g(e._b({ attrs: { id: e.id, "no-header": e.noHeader, "only-date": e.onlyDate, "no-shortcuts": e.noShortcuts, range: e.range, right: e.right, value: e.value, "no-value-to-custom-elem": e.noValueToCustomElem, format: e.format, color: e.color, "max-date": e.maxDate, "min-date": e.minDate, "button-color": e.buttonColor, locale: t.activeLocale, "data-testid": e.dataTestid, "no-button-now": e.noButtonNow, "no-clear-button": e.noClearButton, "no-label": e.noLabel }, on: { input: function(a) {
    return e.$emit("input", a);
  } } }, "VueCtkDateTimePicker", e.$attrs, !1), e.$listeners), [e._t("default")], 2);
}, G$ = [], Z$ = /* @__PURE__ */ x(
  K$,
  U$,
  G$,
  !1,
  null
);
const Y$ = Z$.exports, xr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  XAlert: Xc,
  XBadge: he,
  XBreadCrumb: pm,
  XButton: ae,
  XCard: ye,
  XCardInteractive: jm,
  XCheckbox: Fe,
  XCollapse: pv,
  XDateTimePicker: Y$,
  XDivider: Iv,
  XDropdown: de,
  XDropdownMenu: Mv,
  XEllipsis: K,
  XFileInput: jv,
  XFormField: ee,
  XIcon: B,
  XInlineEdit: rg,
  XLink: ne,
  XListItem: oe,
  XLogo: Tg,
  XModal: ah,
  XPagination: Sh,
  XRadio: Lh,
  XSelect: Ay,
  XSkeletonLoader: pt,
  XSpinner: Ae,
  XSwitch: Jy,
  XTable: Eb,
  XTableRow: mt,
  XTabs: u$,
  XTabsPanel: $$,
  XTextArea: D$,
  XTextInput: W$,
  XTooltip: Oe
}, Symbol.toStringTag, { value: "Module" })), Tr = function(e) {
  Object.entries(xr).forEach(([s, t]) => {
    e.component(s, t);
  });
}, J$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Components: xr,
  default: Tr
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(J$).forEach(([n, e]) => {
  n !== "default" && (Tr[n] = e);
});
export {
  Tr as default
};
